import { Component, ViewChild, AfterViewInit, HostListener, Inject, Input, EventEmitter, Output } from '@angular/core';
import * as uuid from 'uuid';
// import { io } from 'socket.io-client';
import * as io from 'socket.io-client';
import { ConfigService } from '../services/config.service';
import { ControllerService } from '../services/controller.service';
import { TagService } from '../services/tag.service';
import { ReportService } from '../services/report.service';
import { ShapeCreatorService } from '../services/shape-creator.service';
import { ActivityVisualizationService } from '../services/activity-visualization.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import uniqWith from 'lodash/uniqWith';
import get from 'lodash/get';
import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { LanguageService } from '../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import * as  shipDetailList from "../../assets/appData/shipObjects.json";
import * as  shipOrderConfig from "../../assets/appData/shipConfig.json";
import { ChitService } from '../services/chit.service';
import moment from 'moment';

import { RadhazVisService } from "../services/radhaz.service";
import { CommunicationService } from '../services/communication.service';
import { DrawService } from '../services/draw.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SocketService } from '../services/socketService';
import { KHASystemService } from '../services/systems/kha-systems.service';

declare var BABYLON;
export interface PublishData {
  value: string;
  error: string;
  table: any;
  datauxview: any;
  port: any;
  dataList: any;
  type: any;
  shipData: any;
}

// RAJDEC08: try to rename the component as navyapp
@Component({
  selector: 'app-navyapp',
  templateUrl: './navyapp.component.html',
  styleUrls: ['./navyapp.component.scss'],
  providers: [DatePipe]
})

export class NavyappComponent implements AfterViewInit {
  @ViewChild('datauxview', { static: true }) public datauxview: any;
  stateBoardView: boolean = false;
  adminStateBoardView: boolean = false;
  // shipDetailList: any = shipDetailList['default']['ship'];
  shipOrderConfig: any = shipOrderConfig['default'];
  toggleFMFState: boolean = false;
  toggleConeState: boolean = false;
  fmfPanelState = false;
  hazardPanelState = false;
  firstAidPanelState = false;
  wfmPanelState = false;
  noteStatus: any = true;
  selectedGroupData: any;
  commetsWindow: any = false;
  // kioskPanelState = true;
  laydownPanelState = false;
  navyFilterState: any;
  navyFilterShip: any;
  activityPanelState: boolean = false;
  reportPanelState: boolean = false;
  commsConsoleState: boolean = false;
  shapeCreatorService: ShapeCreatorService;
  socketcontroler = false;
  chitWindowState: any = false;
  scheduleWindowState: any = false;
  tagoutWindowState: any = false;
  _shapestatus = false;
  _showObject = true;
  projectConfig: any;
  dfx: any;
  shipMetaData: any = [];
  shipObjects: any = [];
  shipConfig: any = [];
  locationArry: any = [];
  shipLocations: any = [];
  currentShipList: any = [];
  historyShipList: any = [];
  shipObj: any[];
  process_txt = "Processing...";
  pcsDemos = [];
  filterData: any = [];
  selectedDemo = this.pcsDemos[0] || "";
  objIndex = 0;
  percentageValue = 0;
  numberOfObjectLoad = 3;
  showLoading: boolean = false;
  showBlockLoading: boolean = false;
  showNonBlockLoading: boolean = true;
  tagMaxList: any = [];
  detailTbl: boolean = true;
  canvasHeight: any = window.innerHeight + 'px';
  pdfStatus: any = false;
  xangle = 0;
  zangle = 0;
  clearShipSelection: any = false;
  selectedShipElem: any = '';
  selectedLaydownElem: any = '';
  controlLabelState: boolean = false;
  showPDFMode: boolean = false;
  rawDataStatus: boolean = false;
  rawData: any;
  controlPanelState: boolean = false;
  broadcastSubs
  globalanim = 'stop';
  craneanim = 'stop';
  cameraanim = 'stop';
  isDragmove = false;
  isMousedown: boolean = false;
  buildingsList: any = [];
  magTagStatus: boolean = true;
  showUploadScreen: boolean = false;
  receivedMessage: any;
  jettyMissingShipObjects: any = [];
  jettyMissingShipList: any = [];
  activityChangedMetaData: any = [];
  activityChangedShipList: any = [];
  unknownLocationShipList: any = [];
  unknownLocationState: any = false;
  locationErrorState: any = false;
  hazardShowState: any = true;
  scheduleShowState: any = true;
  dialogType: any = "";
  currentShipData: any = [];
  isAppLoaded: boolean = false;
  isReport: boolean = false;
  socket: any;
  allPortElements: any = [];
  uploadedJsonFile: any = '';
  pickedElement: any;
  pickEvent: boolean = false;
  planType: any = 'LIVE';
  cameraMode: any = '3D'
  // cfbport: string = 'cfbhalifax';
  cfb_externalport: string = '';
  cfbport: string = 'cfbesquimalt';
  timeProgress: boolean = false;
  jettyLabelState: boolean = true;
  hideUnselectedState: boolean = false;
  hideCraneState: boolean = true;
  hideLightState: boolean = true;
  toggleOceanState: boolean = false;
  showBuildingState: boolean = true;
  showGroundState: boolean = true;
  toggleCautionState: boolean = false;
  disableTrans: boolean = false;
  loadJetty = true;
  userId: any = '';
  userName: any = '';
  accountEmail: any = '';
  loginInfo: any = {};
  profileInfo: any = {};
  kioskJson: any = {};
  LaydownData: any = {};
  kioskList: any = [];
  coneList: any = [];
  selectedConeElem: any = null;
  kioskPanelState: any = false;
  currentJetty: any = 'cfbesquimalt';
  fistAidJson: any = [];
  chitShipDetails: any = [];
  newAddedShipObj: any;
  chitNotification: any = {};
  layoutModel = false;
  statusColorCode: any = [{ "status": "Operational", "color": "green" }, { "status": "Degraded", "color": "orange" }, { "status": "Not operational", "color": "red" }];
  // statusColorCode:any=[{"status":"Active","color":"green"},{"status":"Available","color":"yellow"},
  // {"status":"Servicing","color":"pink"},{"status":"Not available","color":"blue"},{"status":"No service","color":"transparent"},{"status":"Out of service","color":"red"}];
  cfbport_path = {
    "cfbhalifax": { "cfbhalifax": "./ports/cfbhalifax/cfb_halifax.glb" },
    "cfbesquimalt": { "cfbesquimalt": "./ports/esquimalt/cfb_esquimalt.glb" }
  }
  cfbport_geom = {
    "cfbhalifax": {
      "shapes": [
        {
          "cfb_halifax": {
            "model": "cfb_halifax",
            "material": "custom-included",
            "size": 1

          }
        }
      ],
      "objects": [
        {
          "type": "static",
          "parent": "",
          "name": "cfb_halifax",
          "model": "cfb_halifax",
          "profile": "regular",
          "place": {
            "pos": {
              "x": 0,
              "y": 0,
              "z": 0
            },
            "rot": {
              "x": 0,
              "y": 0,
              "z": 0
            }
          }
        }

      ]

    },
    "cfbesquimalt": {
      "shapes": [
        {
          "cfb_esquimalt": {
            "model": "cfb_esquimalt",
            "material": "custom-included",
            "size": 1
          }
        }
      ],
      "objects": [
        {
          "type": "static",
          "parent": "",
          "name": "cfb_esquimalt",
          "model": "cfb_esquimalt",
          "profile": "regular",
          "place": {
            "pos": {
              "x": 126.47,
              "y": 0,
              "z": 130.98
            },
            "rot": {
              "x": 0,
              "y": 0,
              "z": 0
            }
          }
        }
      ]
    }
  }
  //['sackville_demo', 'sackville2', 'tug', 'tug2', 'vcsub', 'kingston', 'orca', 'rhib', 'rhib_p', 'rhib_q', 'rhib_p_1']
  game_engine = null;
  view_dpr = null;
  tblSeePlanOpen: boolean = false;
  data_event = null;
  ground_mat = null;
  jlabel_near = null;
  jlabel_far = null;
  radhaz_demo_mode = false;
  // RAJ: commenting out this part since it is not required for this project at this time
  /*
  track_label_tex = {
    "meshes": [{
      "position": [0, 0, 0],
      "rotation": [0, 0, 0],
      "scaling": [1, 1, 1],
      "isVisible": true,
      "isEnabled": true,
      "checkCollisions": false,
      "alphaIndex": 201,
      "billboardMode": 0,
      "receiveShadows": false,
      "name": "track",
      "id": "track",
      "positions": [],
      "normals": [],
      "uvs": [],
      "indices": []
    }]
  };
  */
  apploadingStatus: boolean = false;
  cfbstatic_ships: any = [];
  status_cone_mats = ["Cone.red", "Cone.gtreen", "Cone.yellow", "Cone.orange"]
  crane_mngr_cfbhalifax;
  crane_mngr_cfbesquimalt;
  languageSelected: any = 'en';
  plotmode_ca = false;
  plotmode_location = false;
  kioskColorState: any = false;
  updateFirstAid: any = [];
  shipDetailPanelData: any = '';
  shipDetailPanelState: any = false;
  shipOrderKey = 'default';
  radiatesList: any = [];
  reportWFM: any;
  broadcastIframeSubs: any;
  groupWindow: boolean;
  groupName: any;
  groupState: any;
  groupStatusColor: any;
  groupData: any;
  groupList: any = [];
  statusWindow: boolean;
  statusHeading: string;
  btnStatus: string;
  statusColor: any;
  statusId: any;
  statusName: string;
  markerColor = "#ff0000";
  markerWidth = 20;
  markerShape = 'free'
  fillStatus: boolean = false;
  mousestate = "up";
  drawing = false;
  createlayoutData: any;
  doubleClick: number = 0;
  // mobileView:any=false;
  saveLayoutData: any = {};
  createLayoutId: any;
  layoutId: any;
  meshInfoData: any;
  typeArray = [
    { name: 'Rounds' },
    { name: 'Chits' },
    { name: 'Lockout/Tagout' },
    { name: 'Aid' },
    { name: 'HazardAreas' },
    { name: 'Kiosks' },
    { name: 'LaydownAreas' },
  ];
  groupArray = [];
  statusArray = [
  ];
  shapecollectionArray = [
    { name: 'Aid', icon: '../../assets/images/shape/aed.png', id: 'aed_pin_red' },
    // {name: 'Contractors', icon: '../../assets/images/shape/contractors.png',id : 'sphere'},
    { name: 'Hazard Areas', icon: '../../assets/images/shape/hazard.png', id: 'cone_m' },
    { name: 'Kiosks', icon: '../../assets/images/shape/kiosk.png', id: 'kiosk_SM_01_mech' },
    { name: 'Evacuation posters', icon: '../../assets/images/shape/evacuation-posters.png', id: 'location_pin' },
    // {name: 'First aid stations', icon: '../../assets/images/shape/first-aid.png',id : 'cube'},
  ];
  saveNotesData: any = {};
  layoutHeadingName: any;
  showTagPoint: any;
  showTypeData: any;
  markerId: any;
  approval: any;
  notificationData: any;
  currentLoginEmail: any;
  approvalStatus: any;
  usersDetails: any = [];
  userRole: any;
  chitFormData: any;
  collisionShipDetatils: any;
  constructor(private datePipe: DatePipe,
    private chitService: ChitService,
    private reportServ: ReportService,
    public dialog: MatDialog,
    private activityServ: ActivityVisualizationService,
    private tagServ: TagService,
    private configService: ConfigService,
    private ctrlServ: ControllerService,
    private communicationServ: CommunicationService,
    private translate: TranslateService,
    private language: LanguageService,
    private radhazVisServ: RadhazVisService,
    private drawService: DrawService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private socketService: SocketService,
    private _khaConfig: KHASystemService
  ) {
    // this.mobileView = window.innerWidth<720;
    this.cfbstatic_ships = this.tagServ.cfbstatic_ships;
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src == "admin-SB") {
          if (data.event == "adminView") {
            let adminSB = data['data'];
            // this.adminStateBoardView=adminSB;
            this.stateBoardView = adminSB;
          }
          if (data.event == "stateBoardView") {
            let adminSB = data['data'];
            // let result = adminSB['layoutList'].filter(o1 => this.sidepanelLayoutData.some(o2 => o1['_id'] === o2['_id']));
            console.log("stateBoardView", adminSB);
            this.stateBoardView = adminSB;
            // this.adminStateBoardView=false;
          }
        }
        if (data.src == "dynamic-layout") {
          if (data.event == "closeStateboard") {
            this.stateBoardView = false;
          }
        }
        if (data.src == "mobilePanel") {
          if (data.event == "closeLayout") {
            this.layoutState = false;
          }
        }
        if (data.src === "animcontrol") {
          if (data.data.type === 'synchrolift') {
            if (data.event === 'play') {
              if (this.globalanim === 'paused') {
                this.globalanim = 'play'
              } else {
                this.animateSynchroLift();
              }
            }
            if (data.event === 'pause') {
              this.globalanim = 'paused';
            }
            if (data.event === 'stop') {
              this.globalanim = 'stop';
              this.resetSLDemo();
            }
          }
          if (data.data.type === 'craneanim') {
            if (data.event === 'play') {
              if (this.craneanim === 'paused') {
                this.craneanim = 'play';
                this['crane_mngr_' + this.cfbport].play();
              } else {
                this.animateCranes();
              }
            }
            if (data.event === 'pause') {
              this.craneanim = 'paused';
              this['crane_mngr_' + this.cfbport].pause();
            }
            if (data.event === 'stop') {
              this.craneanim = 'stop';
              this.resetCraneDemo();
            }
          }
          if (data.data.type === 'cameraanim') {
            if (data.event === 'play') {
              if (this.cameraanim === 'paused') {
                this.cameraanim = 'play';
                //this.animateCameraView();
                this.pauseCameraAnim(false)
              } else {
                this.cameraanim = 'play';
                this.animateCameraView();
              }
            }
            if (data.event === 'pause') {
              this.cameraanim = 'paused';
              this.pauseCameraAnim(true);
              //cancelAnimationFrame(this.animateAID);
            }
            if (data.event === 'stop') {
              this.cameraanim = 'stop';
              this.resetCameraView();
            }
          }
          if (data.data.type === 'overview') {
          }
          if (data.event === 'external_jetty') {
            if (this.loadJetty) {
              this.loadJetty = false;
              let jetty = data.data.type;
              this.currentJetty = jetty;
              if (jetty === 'cfbhalifax') {
                this.loadHomePort('home');
              } else {
                this.gotoExternalJetty(data.data.type);
              }
              setTimeout(() => {
                this.loadJetty = true;
              }, 1000);
            }

          }
          if (data.event === 'live_env') {
            this.liveEnv = data.data;
            if (!this.liveEnv) {
              this.liveEnvCount = 0;
              this.liveTime = null;
              this.updateSunPos([12])
            }
          }
          if (data.event === 'live_env_time') {
            let t = data.data;
            let hh = Math.floor(t);
            let mm = (t - hh) * 60;
            //this.liveTime=[hh,mm];
            //this.liveEnvCount=0;
            this.updateSunPos([hh, mm])
          }
        }
        if (data.src == "main") {
          if (data.event === 'layoutNameSave') {
            this.showLayout = true;
          }
        }
        if (data.src === "slider") {
          if (data.event === 'hidetag') {
            this.tagServ.unselectTagElement();
          }
        }
        if (data.src == "socketMessage") {
          if (data.event == "activityChangedMetaData") {
            this.activityChangedMetaData = data.data
            this.processActivityChangedShips()
          }
          if (data.event == "openPublishDialog") {
            this.openPublishDialog(data.data)
          }
          if (data.event == "getApproved") {
            this.getApproved(data.data)
          }
          if (data.event == "updateKioskStatus") {
            this.updateKioskStatus(data.data)
          }
        }
        if (data.src === "tagUpdate") {
          if (data.event === 'kioskData') {
            this.kioskList = data.data;
            this.kioskJson.formatKioskJson.jettyList = JSON.parse(JSON.stringify(this.kioskList.jettyList))
            this.broadcastInfo({ src: 'main', event: 'kisokdata', data: this.kioskJson, key: "" });
            this.kioskMaterial(data.service, this.kioskColorState)
          }
        }
        if (data.src === "report") {
          if (data.event === 'load_report_view') {
            let obj = data['data'];
            if (obj) {
              this.hideAllShips();
              this.onUpdateObjectPosition(obj);
            }
          }
        }
        if (data.src === "tagServ") {
          if (data.event === 'show_selected_flag') {
            this.showFlagMessage(data.key);
          }
        }
        if (data.src === "sidepanel") {
          if (data.event === 'toggle_demo_ships') {
            this.toggleDemoShips(data['data']);
          }
          if (data.event == 'stateBoardUser') {
            this.controlToolEvent(data['data']);
            this.broadcastInfo({ src: 'sidepanel', event: 'controlEvent', data: { name: 'stateBoard', state: false } });
          }
          // if(data.event === "openDialogLayoutEdit"){
          //   console.log("openDialogLayoutEdit",data['data'],this.layoutData);
          //   this.editCollection = true;
          //   this.layoutModel = true;
          //   this.layoutHeadingName =data['data']['layoutName'];
          //   this.editCollectionData = data['data'];
          // }
          if (data.event == "stateBoardClose") {
            this.stateBoardView = false;
            this.adminStateBoardView = data['data'];
          }
          // if(data.event == "groupToggle"){
          //   this.groupWindowClose();
          // }
          // if(data.event == "statusToggle"){
          //   this.statusPopWindowClose();
          // }
          if (data.event == 'reportWfm') {
            var key = data.key.split('_')[1];
            if (key == 'preview') {
              this.reportGenerate(data.key, 'preview');
            } else {
              this.reportWFM = data.data;
              this.openPublishDialog(data.key);
            }

          }
          // if (data.event == "createStatus") {
          //   this.btnStatus = 'Create';
          //   this.statusHeading = 'Create Status';
          //   this.statusName = "";
          //   this.statusColor = this.getRandomColor();
          //   this.statusWindow = true;
          // }
          // if (data.event == "statusDelete") {
          //   let deleteGroupData = data.data
          //   var deleteId = deleteGroupData.item
          //   this.statusId = deleteId['_id']
          //   this.deleteStatusData(this.statusId);
          // }
          // if (data.event == "createGroup") {
          //   this.openGroupPanel("new");
          // }
          // if (data.event == "updateGroup") {
          //   console.log("update", data['data'])
          //   this.openGroupPanel("edit", data['data']);
          // }
          if (data.event === 'stepper') {
            this.chitWindowState = data.data;
          }
          if (data.event === 'schedule') {
            this.scheduleWindowState = data.data;
          }
          if (data.event === 'openTagoutDialog') {
            this.tagoutWindowState = data.data;
          }
          if (data.event == 'kioskColor') {
            this.kioskStatusColor(data.data)
          }
          if (data.event === 'port_change') {
            this.cfbport = data['data'];
            if (this.data_event.type === 'server') {
              this.onLoadData(this.data_event);
            } else {
              this.onLoadData(this.data_event);//temporary call, remove this when below TODO is done
              /**
               * TODO show excel upload panel
               */
            }
          }
          if (data.event === 'FMF_mode') {
            let state = data['data'] ? 'exterior' : 'w_interiors';
            this.toggleFMFState = data['data'];
            this.toggleFMFMode(state)
          }
          if (data.event === 'kioskName') {
            this.showHideKioskNames(data['data'])
          }
          if (data.event === 'cautionarea_mode') {
            this.toggleCautionState = data['data'];
            this.toggleCautionMode();
          }
          if (data.event === 'rhIndi') {
            let d = data['data']
            this.showHideRHIndicator(d.id, d.state, data.key);
          }
          if (data.event === 'rhIndi_wf') {
            let d = data['data']
            this.showHideRHIndicator_wf(d.id, d.state, data.key)
          }
          if (data.event === 'rhComp') {
            let d = data['data']
            this.showHideRHComp(d.id, d.state, data.key)
          }
          if (data.event === 'rhshowall') {
            let d = data['data']
            this.showHideRHCompAll(d.state, data.key)
          }
          /**man-aloft */
          if (data.event === 'maIndi') {
            let d = data['data']
            this.showHideMAIndicator(d.id, d.state, data.key);
          }
          if (data.event === 'maComp') {
            let d = data['data']
            this.showHideMAComp(d.id, d.state, data.key)
          }
          if (data.event === 'mashowall') {
            let d = data['data']
            this.showHideMACompAll(d.state, data.key)
          }
          if (data.event === 'togglemav') {
            let d = data['data']
            this.toggleMAVersions();
          }
          if (data.event === 'deleteChit') {
            let chitDate = data['data']
            this.chitShipDetails = chitDate;
          }
          // if (data.event === 'updateCollectionData') {
          //   let collectionData = data['data'];
          //   if(collectionData){
          //     this.statusArray = collectionData.statusCollection;
          //     this.groupArray = collectionData.groupCollection;
          //   }
          // }
          // if (data.event === 'createCollectionTypeForm') {
          //   let e = data['data'];
          //   let item = data['key'];
          //   this.selectedLayoutList = data.layout
          //   this.selectedTagItem = data.tagPoint
          //   this.typeAction(e, this.selectedTagItem);
          // }
          // if (data.event === 'viewCollectionTypeForm') {
          //   let e = data['data'];
          //   let id = data['key'];
          //   let item = data['key1'];
          //   this.viewDataTypeDetails(e, id, item)
          // }
          if (data.event == "createLayout") {
            this.openLayout()
            delete this.layoutHeadingName;
            delete this.shapeCollection;
            delete this.groupCollection;
            delete this.statusCollection;
            delete this.typeCollection;
            delete this.saveLayoutData;
            delete this.pickedMeshObj
          }
          if (data.event == "layoutActive") {
            if (data.data.length == 0 && !this.selectedLayoutList) {
              this.LayoutMode = false;
              this.selectedLayoutList = data['data'];
              this.layoutName = ''
              this.layoutHeading = ''
            } else {
              this.LayoutMode = true;
              this.selectedLayoutList = data['data'];
              this.showTypeData = this.selectedLayoutList['type']
              this.drawService.layoutData = this.selectedLayoutList;
              this.layoutHeading = this.selectedLayoutList['layoutName'];
              this.layoutName = this.selectedLayoutList['layoutName'];
              this.layoutId = this.selectedLayoutList['_id'];
            }
          }
        }
        if (data.src === "controlpanel") {
          if (data.event === 'toggleocean') {
            let boo = data['data'];
            this.toggleOffOcean(boo);
          }
          if (data.event === 'load-mutiple-compartment') {
            // this.khaConfig.matTagClear();
            // this.selectedNotes()
            //this.clearGroup();
            this.LayoutMode = false;
            var layout = data['data'];
            var layoutData = layout['tagPoints']
            this.layoutName = layout['layoutName']
            layoutData.forEach(tagcom => {
              var tag = tagcom.tagComments
              if (tag.statusId) {
                let filteredStatus = this.statusListData.filter(m => m._id == tag.statusId);
                var statusData = filteredStatus[0]
                if (statusData != undefined) {
                  tag.status.name = statusData.name;
                  tag.status.value = statusData.value;
                } else {
                  tag.status.name = '';
                  tag.status.value = '';
                }
                if (statusData == undefined) {
                  tag.status.name = '';
                  tag.status.value = '';
                }
              }
            });
            console.log("selectedLayoutList", data['data']);
            this.selectedLayoutList = data['data'];
            // this.khaConfig.khamode = "compartment";
            // this.processMutipleComparment(this.selectedLayoutList, data['key']);
            // this.createtagPoints();
            // this.getGroupItem();
          }
          // if (data.event === 'clear-layout-window') {
          //   // console.log("636","reset")
          //   this.closeLayoutScreen();
          // }
          // if (data.event === 'delete-layout-data') {
          //   let obj = data['data'];
          //   if (obj) {
          //     this.deleteLayout(obj._id, obj);
          //     this.broadcastInfo({ src: 'navyApp', event: 'deleteLayoutUpdate', data:obj._id });
          //   }
          // }
        }
        if (data.src === "chitStepper") {
          if (data.event === 'chitActivity') {
            let obj = data['data'];
            this.sendInfo(obj)
          }
          if (data.event === 'radhaz_rhIndi') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideRHIndicator(d.shipId, d.state, d.id);
            }
          }
          if (data.event === 'radhaz_rhIndi_wf') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideRHIndicator_wf(d.shipId, d.state, d.id);
            }
          }
          if (data.event === 'radhaz_rhComp') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideRHComp(d.shipId, d.state, d.id);
            }
          }
          /**man-aloft */
          if (data.event === 'radhaz_maIndi') {
            let d = data['data'];
            if (d['shipId']) {
              this.radhazVisServ.showHideMAIndicator(d.shipId, d.state, d.id);
            }
          }
        }
        if (data.src === "ctrlserv") {
          if (data.event === 'opendialogbox') {
            let message = data['data'];
            if (message) {
              this.openPublishDialog(message);
            }
          }
        }
        if (data.src === "tagout") {
          if (data.event === 'closeTagout') {
            this.tagoutWindowState = data['data'];
          }
        }
        if (data.src === "coursePanel") {
          if (data.event == 'LayoutPanelClose') {
            this.showLayout = data['data'];
          }
        }
        if (data.src === "sidepanel") {
          if (data.event === 'selectedLaydown') {
            console.log("data bind laydown id : ", data.data)
            var e = data.data;
            // var e =     {
            //     "pickedMesh": {
            //       "id": "element-cfb_halifax.model-cfb_halifax.laydown.model-cfb_halifax.laydown.S-19.model-cfb_halifax.laydown.S-19.S-19"
            //     },
            //     "pickedPoint": {
            //       "e": {
            //         "x": "120.11639404296875",
            //         "y": "4.200247287750244",
            //         "z": "405.217529296875"
            //       }
            //     }
            // }
            console.log("E Data : ", e);
            this.addLaydownPointer(e);
          }
          // if(data.event === "userList-add-view"){
          //     this.notificationdataView()
          // }
          // if (data.event == "updateStatus") {
          //   console.log("update", data['data'])
          //   var statusData = data['data']
          //   this.statusName = statusData.name;
          //   this.statusColor = statusData.value;
          //   this.statusId = statusData._id;
          //   this.btnStatus = 'Update';
          //   this.statusHeading = 'Update Status';
          //   this.statusWindow = true;
          // }
          if (data.event === 'selectedFirstAid') {
            if (data['data']) {
              this.selectedFirstAidPin(data['data']);
            }
          }
          if (data.event === 'hazardEdit') {
            this.selectedConeElem = data['data'];
          }
          if (data.event === 'hazardDelete') {
            this.selectedConeElem = data['data'];
          }
          if (data.event === 'checkforradhaz') {
            this.checkForRadHaz();
          }
          if (data.event === 'clearradhaz') {
            this.clearRadHaz();
          }
          if (data.event === 'updateDetailPanel') {
            this.updateDetailPanel(data);
          }
          // if (data.event === 'chitDeleteshipList') {
          //   let confirm = data['data'];
          //   // let chitShipDetails = item['item']
          //   this.selectedShipElem = confirm;
          //   this.onRemoveShip();
          //   //   this.hideAllShips();
          //   // this.loadServerData();
          // }
          // if (data.event === 'delete-notes-data') {
          //   if (data.data != undefined) {
          //     if (data.data.tagComments.typeCollection == 'Chits') {
          //       this.chitDeleteActivity(data.data.tagComments.typeCollectionId)
          //     }
          //     if (data.data.tagComments.typeCollection == 'Rounds') {
          //       this.roundseDeleteActivity(data.data.tagComments.typeCollectionId)
          //     }
          //     this.deleteNotes(data.data);
          //   }
          // }
        }
        // if(data.src == "tag-Point"){
        //   if(data.event ="dashboardChit"){
        //     console.log(data.value)
        //     this.typeAction(data.value,data.item)
        //   }
        //   if(data.event ="schedule"){
        //     this.typeAction(data.value,data.item)
        //   }
        //   if(data.event ="createTagoutDialog"){
        //     this.typeAction(data.value,data.item)
        //   }
        // }
        if (data.src === "tagHazard") {
          if (data.event === 'deleteHazard') {
            let obj = data['data'];
            if (obj) {
              this.deleteHazard(obj);
            }
          }
          if (data.event === 'unSelectHazard') {
            this.selectedConeElem = null;
          }
        }
        if (data.src === "tag") {
          if (data.event == 'comms') {
            this.commsConsoleState = false;
          }
          if (data.event === 'updateFirstAidData') {
            // let message = data['data'];
            // console.log("Tag Broadcast msg", message)
            this.updateFirstAid = data['data'];
            this.updatedFirstAidPin();
            // if (message) {
            //   this.openPublishDialog(message);
            // }
          }
          if (data.event == 'updatePositionHazaed') {
            this.positionChangeHazard(data);
          }
          if (data.event == 'updatePositionFirstAid') {
            this.positionChangeFirstAid(data);
          }
          if (data.event === 'updateDetailPanel') {
            this.updateDetailPanel(data);
          }
          if (data.event == 'fmfRoofState') {
            let state = 'exterior';
            this.toggleFMFState = true;
            this.toggleFMFMode(state);
          }
        }
        if (data.src === "chit") {
          if (data.event == 'reloadshipdata') {
            let shipObj = data['data'];
            let startDate = shipObj['startdate'];
            this.chitNotification = data['notify'];
            if (shipObj) {
              let chitId = shipObj['chit_id']
              let ship = this.shipObjects.find(el => el.chit_id === chitId);
              if (ship) {
                if (ship['activity'].split(" ").join("").toLowerCase() !== shipObj['activity'].split(" ").join("").toLowerCase() || ship['location'].split(" ").join("").toLowerCase() !== shipObj['location'].split(" ").join("").toLowerCase()) {
                  this.newAddedShipObj = shipObj;
                  this.hideAllShips();
                  this.broadcastInfo({ src: 'main', event: 'updateSliderDate', data: startDate });
                  this.loadServerData();
                }
              } else {
                this.newAddedShipObj = shipObj;
                this.hideAllShips();
                this.broadcastInfo({ src: 'main', event: 'updateSliderDate', data: startDate });
                this.loadServerData();
              }
            }
          }
          if (data.event == 'shipChitNotification') {
            // let shipObj = data['data'];
            // let startDate = shipObj['startdate'];
            this.chitNotification = data['notify'];
          }
          if (data.event === 'collision') {
            let confirm = data['data'];
            this.openPublishDialog(confirm);
          }
          if (data.event === 'reloadshipList') {
            let confirm = data['data'];
            if (confirm == 'reload') {
              this.hideAllShips();
              this.loadServerData();
            }
          }
          if (data.event === 'chitDeleteshipList') {
            let confirm = data['data'];
            this.selectedShipElem = this.chitShipDetails;
            this.onRemoveShip();
            //   this.hideAllShips();
            // this.loadServerData();
          }
          if (data.event === 'chitAcitivity') {
            this.selectedShipElem = data['data'];
            this.reportWFM = data.chitForm;
            this.currentShipList = data.currentShipList
            console.log(this.reportWFM)
            this.checkForRadHaz(true)
          }
          // if (data.event === 'chitCreate') {
          //   if (this.chitService.typeCollectionForm == 'createCollectionFormActive') {
          //     delete this.pickedMeshObj;
          //     delete this.selectedTagItem;
          //     var min = -1;
          //     var max = 100;
          //     this.pickedMeshObj = {
          //       "tagShapeId": this.getUIDData(),
          //       "shapeId": "sphere",
          //       "position": {
          //         "x": (Math.random() * (max - min + 1)) + min,
          //         "y": (Math.random() * (max - min + 1)) + min,
          //         "z": (Math.random() * (max - min + 1)) + min,
          //       },
          //       "parentMeshId": "element-envelope-59__CEROS_200_aft-9e5d5679-5eeb-41d7-83e0-46aa60be4b9b",
          //       "port": "cfbesquimalt"
          //     }
          //     this.saveNotesData['tagShapeId']= this.pickedMeshObj.tagShapeId || ''
          //     this.saveNotesData['startDate'] = this.saveNotesData['starDate'] || new Date()
          //     this.saveNotesData['typeCollectionId'] =  data.data[0].typeCollectionId;
          //     this.saveNotesData['typeCollection'] =  data.data[0].typeCollection;
          //     this.createNotes()
          //     this.chitService.typeCollectionForm = '';
          //   }else if (this.selectedTagItem) {
          //     this.updateTypeCollection(data);
          //   }else{
          //     this.saveNotesData['tagShapeId']= this.pickedMeshObj.tagShapeId || ''
          //     this.saveNotesData['startDate'] = this.saveNotesData['starDate'] || new Date()
          //     this.saveNotesData['typeCollectionId'] =  data.data[0].typeCollectionId;
          //     this.saveNotesData['typeCollection'] =  data.data[0].typeCollection;
          //     this.createNotes()
          //   }
          // }
          // if (data.event === 'roundsCreate') {
          //   if (this.chitService.typeCollectionForm == 'createCollectionFormActive') {
          //     delete this.pickedMeshObj;
          //     delete this.selectedTagItem;
          //     var min = -1;
          //     var max = 100;
          //     this.pickedMeshObj = {
          //       "tagShapeId": this.getUIDData(),
          //       "shapeId": "sphere",
          //       "position": {
          //         "x": (Math.random() * (max - min + 1)) + min,
          //         "y": (Math.random() * (max - min + 1)) + min,
          //         "z": (Math.random() * (max - min + 1)) + min,
          //       },
          //       "parentMeshId": "element-envelope-59__CEROS_200_aft-9e5d5679-5eeb-41d7-83e0-46aa60be4b9b",
          //       "port": "cfbesquimalt"
          //     }
          //     this.saveNotesData['tagShapeId']= this.pickedMeshObj.tagShapeId || ''
          //     this.saveNotesData['startDate'] = this.saveNotesData['starDate'] || new Date()
          //     this.saveNotesData['typeCollectionId'] =  data.data[0].typeCollectionId;
          //     this.saveNotesData['typeCollection'] =  data.data[0].typeCollection;
          //     this.createNotes()
          //     this.chitService.typeCollectionForm = '';
          //   } else if (this.selectedTagItem) {
          //     this.updateTypeCollection(data);
          //   }else{
          //     this.saveNotesData['tagShapeId']= this.pickedMeshObj.tagShapeId || ''
          //     this.saveNotesData['startDate'] = this.saveNotesData['starDate'] || new Date()
          //     this.saveNotesData['typeCollectionId'] =  data.data[0].typeCollectionId;
          //     this.saveNotesData['typeCollection'] =  data.data[0].typeCollection;
          //     this.createNotes()
          //   }
          // }
          // if (data.event === 'chitDelete') {
          //     this.updateChitData();
          // }
          // if (data.event === 'roundsDelete') {
          //   this.updateChitData();
          // }
        }
        // if (data.event === 'delete-group-data') {
        //   console.log("delete-group-data", data['data'])
        //   let obj = data['data'];
        //   if (obj) {
        //     this.deleteGroup(obj);
        //   }
        // }
        if (data.src == "comment") {
          //  if (data.event == "create-comment") {
          //    this.saveNotesData = data["data"]
          //    this.onSaveLayout()
          //   }
          //   if(data.event == "saveActivityMessage"){
          //     this.socketService.notificationData.messageData.comments =  data.ApprovalStatus + "-" + data.meassage
          //     this.socketService.notificationData.messageData.Messagedate = new Date();
          //     this.socketService.notificationData.messageData.email = this.configService.accountEmail;
          //     var userData = this.usersDetails.filter(obj => obj.email == this.configService.accountEmail)
          //     this.socketService.notificationData.messageData.name = userData[0]['First Name'] + '' +userData[0]['Last Name'];
          //     this.configService.postData(this.configService.project_config.activityMessage, this.socketService.notificationData.messageData).subscribe(result => {
          //     })
          //   }

          // if (data.event == "update-comment") {
          //   this.updateComment(data)
          // }
          // if (data.event == "update-comment-data") {
          //   this.updateDescription(data)
          // }
          // if (data.event == 'notesDelete') {
          //   console.log(data.data)
          //   // this.deleteNotes(data.data)
          // }
          // if (data.event == 'temporary-comment') {
          //   this.temporaryCommentData = data['data']
          // }
          // if (data.event == 'commentsData') {
          //   var comments = data['data'];
          //   if (comments != undefined) {
          //     this.saveNotesData = comments;
          //     this.saveNotesData['tagShapeId'] = this.pickedMeshObj.tagShapeId
          //     if(!this.layoutHeading){
          //         this.saveLayoutData();
          //     }
          //     // this.compComments = comments.comments;
          //   }

          // }
          // if (data.event == 'openDialogConfirmLayoutName') {
          //   this.saveNotesData = data.data;
          //   this.openDialog('layoutName-confirm');
          // }

        }
        // if (data.src == "tagPoint") {
        //   // if (data.event == "groupCreateTag") {
        //   //   // this.selectGroup(data["data"], data.tag);
        //   //  }
        //   //  if (data.event == "statusCreateTag") {
        //   //   this.changeStatus(data["data"]);
        //   //  }
        //    if (data.event == "statusUpdateTag") {
        //     this.changeStatusLayout(data.data, data.key, data.key1, data.key2);
        //    }
        //    if (data.event == "commentsTag") {
        //     this.openCommentWindow(data.data, data.key);
        //    }
        //  }
      })

    this.broadcastIframeSubs = this.communicationServ.getIframeInstance()
      .subscribe((data: any) => {
        if (data.iframeConnection === "sdms-connection") {
          if (data.event === 'Translate') {
            this.languageSelected = data.data;
          }
          if (data.event === 'loginInfo') {
            this.userId = data.data['userId'];
            this.userName = data.data['userName'];
            this.accountEmail = data.data['accountEmail'];
            this.loginInfo = data.data;
            this.configService.accessToken = data.data['accessToken'];
            this.configService.refershToken = data.data['refershToken'];
            console.log("navysdms loginInfo ", this.userId, this.userName);
            delete this.navyFilterState;
            this.broadcastInfo({ src: 'main', event: 'navyUserInfo', key: true, data: this.loginInfo });
          }
          if (data.event == "profileInfo") {
            this.profileInfo = data.data;
            let fname = data.data['First Name'];
            let lname = data.data['Last Name'];
            let rank = data.data['Rank E'];
            let cell = data.data['Cell'];
            let email = data.data['email'];
            const userInfo = { name: fname, lname: lname, rank: rank, Telephone: cell, email: email };
            this.broadcastInfo({ src: 'main', event: 'navyProfileInfo', key: true, data: userInfo });
            console.log("navysdms profileInfo ", this.profileInfo);
          }
          if (data.event == "notificationInfo") {
            var approvalStatus = data.data;
            var notificationData = data.notificationData
            this.broadcastInfo({ src: "material", event: "notificationData", data: approvalStatus, notificationData: notificationData })
          }
          if (data.event == "urlData") {
            // this.broadcastInfo({ src: 'main', event: 'navyfilterState', key:false  });
            this.activityPanelState = false;
            this.commsConsoleState = false;
            this.kioskPanelState = false;
            this.reportPanelState = false;
            this.wfmPanelState = false;
            this.hazardPanelState = false;
            this.firstAidPanelState = false;
            this.fmfPanelState = false;
            this.planType = data.data;

            if (this.planType.toLowerCase() == 'kiosk') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbesquimalt';
              this.currentJetty = 'cfbesquimalt';
              this.kioskPanelState = true;
            }
            if (this.planType.toLowerCase() == 'marlant') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbhalifax';
              this.currentJetty = 'cfbhalifax';
              this.activityPanelState = true;
            }
            if (this.planType.toLowerCase() == 'marpac') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbesquimalt';
              this.currentJetty = 'cfbesquimalt';
              this.activityPanelState = true;
            }
            if (this.planType.toLowerCase() == 'marlant-qhm') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbhalifax';
              this.currentJetty = 'cfbesquimalt';
              this.activityPanelState = true;
              this.commsConsoleState = true;
            }
            if (this.planType.toLowerCase() == 'marpac-qhm') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbesquimalt';
              this.currentJetty = 'cfbesquimalt';
              this.activityPanelState = true;
              this.commsConsoleState = true;
            }
            if (this.planType.toLowerCase() == 'marlant-report') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbhalifax';
              this.currentJetty = 'cfbesquimalt';
              this.reportPanelState = true;
            }
            if (this.planType.toLowerCase() == 'marpac-report') {
              this.planType = 'LIVE';
              this.cfbport = 'cfbesquimalt';
              this.currentJetty = 'cfbesquimalt';
              this.reportPanelState = true;
            }
            if (this.planType.toLowerCase().includes('fmf')) {
              var splitUrlData = this.planType.toLowerCase().split('_');
              var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
              this.cfbport = port;
              this.currentJetty = port;
              this.planType = 'LIVE';
              this.fmfmode = 'exterior'// 'exterior';//:
              this.toggleFMFMode(this.fmfmode);
              this.activityPanelState = false;
              this.wfmPanelState = false;
              if (splitUrlData.length == 2) {
                if (splitUrlData[1] == 'fmf') {
                  this.fmfPanelState = true;
                }
              } else {
                this.fmfPanelState = true;
                if (splitUrlData[2] == 'hazard') {
                  this.hazardPanelState = true;
                }
                if (splitUrlData[2] == 'faid') {
                  this.firstAidPanelState = true;
                }
              }
            }
            if (this.planType.toLowerCase().includes('wfm')) {
              var splitUrlData = this.planType.toLowerCase().split('_');
              var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
              this.cfbport = port;
              this.currentJetty = port;
              this.planType = 'LIVE';
              this.fmfmode = 'w_interiors';
              this.toggleFMFMode(this.fmfmode);
              this.activityPanelState = false;
              this.fmfPanelState = false;
              if (splitUrlData.length == 2) {
                if (splitUrlData[1] == 'wfm') {
                  this.wfmPanelState = true;
                }
              } else {
                this.wfmPanelState = true;
                if (splitUrlData[2] == 'hazard') {
                  this.hazardPanelState = true;
                }
                if (splitUrlData[2] == 'faid') {
                  this.firstAidPanelState = true;
                }
                if (splitUrlData[2] == 'kiosk') {
                  this.kioskPanelState = true;
                }
                if (splitUrlData[2] == 'laydown') {
                  this.laydownPanelState = true;
                }
              }
            }
            if (this.planType.toLowerCase().includes('shipdata')) {

              var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
              this.navyFilterShip = splitUrlData[1];
              var port: string = splitUrlData[2];
              this.cfbport = port;
              this.currentJetty = port;
              this.planType = 'LIVE';
              this.activityPanelState = true;
              this.navyFilterState = 'ship';
              this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'ship', data: this.navyFilterShip });
              this.updateShipMetadata(true);
              // this.broadcastInfo({ src: 'main', event: 'updateshipmetadata', data: obj });
            }
            if (this.planType.toLowerCase().includes('commanding')) {
              var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
              console.log('splitUrlData', splitUrlData);

              this.navyFilterShip = splitUrlData[1];
              var port: string = splitUrlData[2];
              this.cfbport = port;
              this.currentJetty = port;
              this.planType = 'LIVE';
              this.activityPanelState = true;
              this.navyFilterState = 'commanding';
              // this.ctrlServ.commandingOfficer = this.navyFilterState;
              this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'commanding', data: this.navyFilterShip });
              this.updateShipMetadata(true);
            }
          }

        }
        if (data.iframeConnection === "dockyard") {
          if (data.event === 'dockyard-shipdata-iframe') {
            let shipList = this.currentDayShipList;
            /**
             * makesure the dockyard current date matches login data
             */
            let id_n = shipList.filter(t => t.location == data['data'].location);
            if (id_n && id_n.length) {
              this.ctrlServ.focusElement(id_n[0]);
            }
          }

          if (data.event === 'chitAcitivity') {
            this.selectedShipElem = data['data'];
            this.reportWFM = data.chitForm;
            //this.currentShipList = data.currentShipList;
            console.log(this.reportWFM)
            this.radhazVisServ.selectedActivity = this.selectedShipElem.activity
            let shipList = this.shipObj;
            /**
             * makesure the dockyard current date matches login data
             */
            let id_n = shipList.filter(t => t.location == this.selectedShipElem.location);
            if (id_n && id_n.length) {
              this.selectedShipElem.iname = this.selectedShipElem.name
              this.selectedShipElem.name = id_n[0]['name'];
              this.checkForRadHaz(true)
            } else {
              /**
               * throw error 'ship not found in venue for given date'
               */
            }
            // this.checkForRadHaz(true)
          }
          /* if (data.event == 'shipChitNotification') {
            this.chitNotification = data['notify'];
          } */
        }
      })



    this.language.languageChange.subscribe(props => {
      console.log("language", props);
      this.translate.use(props);
    })
    // this.saveNotesData['status'] = {
    //   value: '#b2b2b2',
    //   name: "Select status",
    // }
    this.matIconRegistry.addSvgIcon(
      "hexagon-icon",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon.svg")
    );
    this.matIconRegistry.addSvgIcon(
      'hexagon-icon-active',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon-active.svg")
    );
    this.tagServ.port = this.cfbport;
  }

  @HostListener('document:pointermove', ['$event'])
  handlePointereMoveEvent(event: MouseEvent) {
    if (event.target['nodeName'] === 'CANVAS') {
      if (this.mousestate === 'down') {
        this.mousestate = "drag";
      }
      if (this.mousestate === 'drag') {
        let drawaction = (this.drawService.draw_select_mode && this.markerShape != 'polygon') || this.drawService.cut_mode
        if (drawaction && this.drawing) {
          this.drawService.doDraw()
        }
      }
    }
    // this.onMouseMoveN(event)
  }
  @HostListener('document:pointerup', ['$event'])
  handlePointereUpEvent(event: MouseEvent) {
    if (this.mousestate === 'down') {

      if ((<HTMLInputElement>event.target).id == "renderCanvas") {
        if (event.which === 1 || event.button === 0) {
          // if (!this.gameManager) {
          //   setTimeout(() => {
          //     this.canvasPickedObject(event);
          //   }, 201)
          // }
        }
      }
    }
    if ((<HTMLInputElement>event.target).id == "renderCanvas") {
      if (this.drawing) {
        let drawaction = this.drawService.draw_select_mode || this.drawService.cut_mode
        if (drawaction && this.drawing) {
          let dr = this.drawService.stopDraw()
          this.drawing = dr;
        }
        this.onMouseUpN();
      }
    }
    this.mousestate = "up";
  }
  // @HostListener('window:message', ['$event'])
  // onmessage(e) {
  //   console.log(e)
  //   if (e) {
  //     if (e.data.for == "Translate") {
  //       this.languageSelected = e.data.data;
  //     }
  //     if (e.data.for == "loginInfo") {
  //       this.userId = e.data.data['userId'];
  //       this.userName = e.data.data['userName'];
  //       this.accountEmail = e.data.data['accountEmail'];
  //       this.loginInfo = e.data.data;
  //       this.configService.accessToken = e.data.data['accessToken'];
  //       this.configService.refershToken = e.data.data['refershToken'];
  //       console.log("navysdms loginInfo ", this.userId, this.userName);

  //       delete this.navyFilterState;
  //       // this.broadcastInfo({ src: 'main', event: 'navyUserInfo', key: true, data: this.loginInfo });
  //     }
  //     if (e.data.for == "profileInfo") {
  //       this.profileInfo = e.data.data;
  //       let fname = e.data.data['First Name'];
  //       let lname = e.data.data['Last Name'];
  //       let rank = e.data.data['Rank E'];
  //       let cell = e.data.data['Cell'];
  //       let email = e.data.data['email'];
  //       const userInfo = { name: fname, lname: lname, rank: rank, Telephone: cell, email: email };
  //       this.broadcastInfo({ src: 'main', event: 'navyProfileInfo', key: true, data: userInfo });
  //       console.log("navysdms profileInfo ", this.profileInfo);
  //     }
  //     if (e.data.for == "urlData") {
  //       // this.broadcastInfo({ src: 'main', event: 'navyfilterState', key:false  });
  //       this.activityPanelState = false;
  //       this.commsConsoleState = false;
  //       this.kioskPanelState = false;
  //       this.reportPanelState = false;
  //       this.wfmPanelState = false;
  //       this.hazardPanelState = false;
  //       this.firstAidPanelState = false;
  //       this.fmfPanelState = false;
  //       this.planType = e.data.data;

  //       if (this.planType.toLowerCase() == 'kiosk') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbesquimalt';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.kioskPanelState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marlant') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbhalifax';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.activityPanelState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marpac') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbesquimalt';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.activityPanelState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marlant-qhm') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbhalifax';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.activityPanelState = true;
  //         this.commsConsoleState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marpac-qhm') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbesquimalt';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.activityPanelState = true;
  //         this.commsConsoleState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marlant-report') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbhalifax';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.reportPanelState = true;
  //       }
  //       if (this.planType.toLowerCase() == 'marpac-report') {
  //         this.planType = 'LIVE';
  //         this.cfbport = 'cfbesquimalt';
  //         this.currentJetty = 'cfbesquimalt';
  //         this.reportPanelState = true;
  //       }
  //       if (this.planType.toLowerCase().includes('fmf')) {
  //         var splitUrlData = this.planType.toLowerCase().split('_');
  //         var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
  //         this.cfbport = port;
  //         this.currentJetty = port;
  //         this.planType = 'LIVE';
  //         this.fmfmode = 'exterior'// 'exterior';//:
  //         this.toggleFMFMode(this.fmfmode);
  //         this.activityPanelState = false;
  //         this.wfmPanelState = false;
  //         if (splitUrlData.length == 2) {
  //           if (splitUrlData[1] == 'fmf') {
  //             this.fmfPanelState = true;
  //           }
  //         } else {
  //           this.fmfPanelState = true;
  //           if (splitUrlData[2] == 'hazard') {
  //             this.hazardPanelState = true;
  //           }
  //           if (splitUrlData[2] == 'faid') {
  //             this.firstAidPanelState = true;
  //           }
  //         }
  //       }
  //       if (this.planType.toLowerCase().includes('wfm')) {
  //         var splitUrlData = this.planType.toLowerCase().split('_');
  //         var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
  //         this.cfbport = port;
  //         this.currentJetty = port;
  //         this.planType = 'LIVE';
  //         this.fmfmode = 'w_interiors';
  //         this.toggleFMFMode(this.fmfmode);
  //         this.activityPanelState = false;
  //         this.fmfPanelState = false;
  //         if (splitUrlData.length == 2) {
  //           if (splitUrlData[1] == 'wfm') {
  //             this.wfmPanelState = true;
  //           }
  //         } else {
  //           this.wfmPanelState = true;
  //           if (splitUrlData[2] == 'hazard') {
  //             this.hazardPanelState = true;
  //           }
  //           if (splitUrlData[2] == 'faid') {
  //             this.firstAidPanelState = true;
  //           }
  //           if (splitUrlData[2] == 'kiosk') {
  //             this.kioskPanelState = true;
  //           }
  //           if (splitUrlData[2] == 'laydown') {
  //             this.laydownPanelState = true;
  //           }
  //         }
  //       }
  //       if (this.planType.toLowerCase().includes('shipdata')) {

  //         var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
  //         this.navyFilterShip = splitUrlData[1];
  //         var port: string = splitUrlData[2];
  //         this.cfbport = port;
  //         this.currentJetty = port;
  //         this.planType = 'LIVE';
  //         this.activityPanelState = true;
  //         this.navyFilterState = 'ship';
  //         this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'ship', data: this.navyFilterShip });
  //         this.updateShipMetadata(true);
  //         // this.broadcastInfo({ src: 'main', event: 'updateshipmetadata', data: obj });
  //       }
  //       if (this.planType.toLowerCase().includes('commanding')) {
  //         var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
  //         console.log('splitUrlData', splitUrlData);

  //         this.navyFilterShip = splitUrlData[1];
  //         var port: string = splitUrlData[2];
  //         this.cfbport = port;
  //         this.currentJetty = port;
  //         this.planType = 'LIVE';
  //         this.activityPanelState = true;
  //         this.navyFilterState = 'commanding';
  //         // this.ctrlServ.commandingOfficer = this.navyFilterState;
  //         this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'commanding', data: this.navyFilterShip });
  //         this.updateShipMetadata(true);
  //       }
  //     }
  //   }
  // }

  openLayout() {
    this.layoutModel = true;
  }


  // RAJDEC08: need to add more comments
  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

  broadcastIframeInfo(data: any) {
    this.communicationServ.createIframeInstance(data);
  }

  datauxView() {
    this.broadcastInfo({ src: 'dashboard', event: 'datauxView', data: "dashboard", key: "" });
  }

  /* * * * *
  * method for get query param values from url
  * * * * * */
  collitionState: any = false;

  getQueryParamValues() {
    if (window.location.search) {
      let queryParams = window.location.search.split('?')[1].split('&');
      for (var i = 0; i < queryParams.length; i++) {
        let searchUrl = queryParams[i].split("=");
        if (searchUrl[0] == "planType") {
          this.planType = searchUrl[1].toUpperCase();
        }
        if (searchUrl[0] == "mode") {
          if (searchUrl[1] == 'collition') {
            this.collitionState = true;
          }
        }
        if (searchUrl[0] == "userId") {
          console.log(" userid ", searchUrl[1]);
          this.userId = searchUrl[1];
        }
        if (searchUrl[0] == "username") {
          console.log(" username ", searchUrl[1]);
          this.userName = decodeURIComponent(searchUrl[1]);
        }
      }
    }
    console.log("planType :", this.planType);
    if (this.planType.toLowerCase() === 'ptp' || this.planType.toLowerCase() === 'gdp') {
      this.showUploadScreen = true;
    } else {
      if (this.planType.toLowerCase() == 'kiosk') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbesquimalt';
        this.currentJetty = 'cfbesquimalt';
        this.kioskPanelState = true;
      }
      if (this.planType.toLowerCase() == 'marlant') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbhalifax';
        this.currentJetty = 'cfbesquimalt';
        this.activityPanelState = true;
      }
      if (this.planType.toLowerCase() == 'marpac') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbesquimalt';
        this.currentJetty = 'cfbesquimalt';
        this.activityPanelState = true;
      }
      if (this.planType.toLowerCase() == 'marlant-qhm') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbhalifax';
        this.currentJetty = 'cfbesquimalt';
        this.activityPanelState = true;
        this.commsConsoleState = true;
      }
      if (this.planType.toLowerCase() == 'marpac-qhm') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbesquimalt';
        this.currentJetty = 'cfbesquimalt';
        this.activityPanelState = true;
        this.commsConsoleState = true;
      }
      if (this.planType.toLowerCase() == 'marlant-report') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbhalifax';
        this.currentJetty = 'cfbesquimalt';
        this.reportPanelState = true;
      }
      if (this.planType.toLowerCase() == 'marpac-report') {
        this.planType = 'LIVE';
        this.cfbport = 'cfbesquimalt';
        this.currentJetty = 'cfbesquimalt';
        this.reportPanelState = true;
      }
      if (this.planType.toLowerCase().includes('fmf')) {
        var splitUrlData = this.planType.toLowerCase().split('_');
        var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
        this.cfbport = port;
        this.currentJetty = port;
        this.planType = 'LIVE';
        this.fmfmode = 'exterior'// 'exterior';//:
        this.activityPanelState = false;
        if (splitUrlData.length == 2) {
          if (splitUrlData[1] == 'fmf') {
            this.fmfPanelState = true;
          }
        } else {
          this.fmfPanelState = true;
          if (splitUrlData[2] == 'hazard') {
            this.hazardPanelState = true;
          }
          if (splitUrlData[2] == 'faid') {
            this.firstAidPanelState = true;
          }
        }
      }
      if (this.planType.toLowerCase().includes('wfm')) {
        var splitUrlData = this.planType.toLowerCase().split('_');
        var port = splitUrlData[0] == 'marlant' ? 'cfbhalifax' : 'cfbesquimalt';
        this.cfbport = port;
        this.currentJetty = port;
        this.planType = 'LIVE';
        this.fmfmode = 'w_interiors';
        this.activityPanelState = false;
        if (splitUrlData.length == 2) {
          if (splitUrlData[1] == 'wfm') {
            this.wfmPanelState = true;
          }
        } else {
          this.wfmPanelState = true;
          if (splitUrlData[2] == 'hazard') {
            this.hazardPanelState = true;
          }
          if (splitUrlData[2] == 'faid') {
            this.firstAidPanelState = true;
          }
          if (splitUrlData[2] == 'kiosk') {
            this.kioskPanelState = true;
          }
          if (splitUrlData[2] == 'laydown') {
            this.laydownPanelState = true;
          }
        }
      }
      if (this.planType.toLowerCase().includes('shipdata')) {

        var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
        this.navyFilterShip = splitUrlData[1];
        var port: string = splitUrlData[2];
        this.cfbport = port;
        this.currentJetty = port;
        this.planType = 'LIVE';
        this.activityPanelState = true;
        this.navyFilterState = 'ship';
        this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'ship', data: this.navyFilterShip });
        // this.updateShipMetadata(true);
      }
      if (this.planType.toLowerCase().includes('commanding')) {

        var splitUrlData = this.planType.toLowerCase().replace(/%20/g, ' ').split('_');
        console.log('splitUrlData', splitUrlData);

        this.navyFilterShip = splitUrlData[1];
        var port: string = splitUrlData[2];
        this.cfbport = port;
        this.currentJetty = port;
        this.planType = 'LIVE';
        this.activityPanelState = true;
        this.navyFilterState = 'commanding';
        // this.ctrlServ.commandingOfficer = this.navyFilterState;
        this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: 'commanding', data: this.navyFilterShip });
        // this.updateShipMetadata(true);
      }
      this.showLoading = true;
    }
  }

  ngOnInit(): void {
    this.getUserData();
    delete this.navyFilterState;
    this.initIframeMessage();
    this.getQueryParamValues();
  }
  getUserData() {
    this.configService.getProjectConfig().then((project_config: any) => {
      this.projectConfig = project_config;
      this.chitService.getUserData().subscribe(
        (response) => {
          this.usersDetails = response;
          this.broadcastInfo({ src: 'navyApp', event: 'userDetails', data: this.usersDetails });
        },
        error => {
          console.error('Request failed with error')
        })
    })
  }
  initIframeMessage() {
    // parent.postMessage("sdms-connection", "*");
    this.broadcastIframeInfo({ iframeConnection: 'sdms-connection', event: 'sdms-init', data: '', key: "" });
  }

  /* * *
  * update ship status
  * * */
  updateShipStatus(ship) {
    let shipName = ship['shipname'].toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
    this.ctrlServ.service['hazardList'].forEach((elem) => {
      let shipConfig = this.shipOrderConfig[elem['order']];
      Object.keys(shipConfig).forEach((key) => {
        let keyName = key.toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
        let value = shipConfig[key].toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
        if (shipName === keyName) {
          let statusArr = this.ctrlServ.statusList.filter(el => el.id === value);
          if (statusArr.length > 0) {
            elem['activity'] = statusArr[0]['status'];
          }
        }
      });
    });
  }

  /* * *
  * update ship status
  * * */
  updateDetailPanel(data) {
    let ship = data['data'];
    let key = data['key'];
    if (ship) {
      ship['_state'] = 'No Issues';
      this.updateShipStatus(ship);
      let shipConfig = this.shipOrderConfig[this.shipOrderKey];
      let shipName = ship['shipname'].toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
      Object.keys(shipConfig).forEach((key) => {
        let keyName = key.toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
        let value = shipConfig[key].toLowerCase().split(" ").join("").replace(".", "").replace("'", "");
        if (shipName === keyName) {
          let statusArr = this.ctrlServ.statusList.filter(el => el.id === value);
          if (statusArr.length > 0) {
            ship['_state'] = statusArr[0]['status'];
          }
        }
      });
      this.shipDetailPanelData = ship;
      this.shipDetailPanelState = key;
    } else {
      this.shipDetailPanelData = '';
      this.shipDetailPanelState = key;
    }
  }

  // RAJDEC08: need to add more comments
  /* * * * *
  * method for project config json based on load the project
  * initilaze the objects form settings.json
  * * * * * */
  pickdownElem: any
  ngAfterViewInit(): void {
    this.configService.loadFile('../assets/license.info').then((info) => {
      this.configService.getProjectConfig().then((project_config: any) => {
        project_config.licence = info;
        this.projectConfig = project_config;
        this.datauxview.setProjectSettins(project_config);
        this.datauxview.loadCanvas('settings', 'json', (data, settingstatus) => {
          var setting_status = settingstatus;
          if (!setting_status) {
            // RAJ: commenting out this part since it is not required for this project at this time
            /*
            setting_status = this.attachDynamicObject(data, (settingstatus) => {
              if (settingstatus) {
                this.initObjects();
              }
            });
            */
          } else {
            this.init_data();
          }
        });
      }, (err) => { console.log(err) });
    }, (err) => { alert("License not found!") })
    let canvas = document.getElementById('canvasElem').children[0].children[0];
    // canvas.addEventListener('mousemove',(evt)=>{
    //   if(this.isMouseDown){
    //     console.log(evt,this.pickdownElem);
    //   }

    // })
    canvas.addEventListener('pointerdown', (evt) => {


      console.log("pointerdown", evt);
      this.clickPosition = evt;
      this.isMousedown = true;
      this.isDragmove = true;
      this.tagServ.isDragmove = true;
    })
    canvas.addEventListener('pointerup', (evt: any) => {
      console.log("pointerup", evt);
     
      if (this.clickPosition.clientX == evt.clientX && this.clickPosition.clientY == evt.clientY) {
        this.tagServ.isDragmove = false;
        this.isDragmove = false;
        this.showRawDataYard();
      }
      if (this.plotmode_ca) {
        this.plotPin();
      }
      this.mousestate = "up";
      if (this.plotmode_location) {
        this.placeLocationPin();
      }
    })
    // this.collectionInfo();
  }
  sendLoadedMsgToHost() {
    if (this.collitionState) {
      this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'dockyard-loaded-iframe', data: true });
      // this.broadcastInfo({ src: 'navyApp', event: 'collection', data: true });
    }
  }
  clickPosition: any;
  /* * * * *
  * attach Dynamic Object
  * * * * * */
  // RAJ: commenting out this part since it is not required for this project at this time
  /*
  attachDynamicObject(data, callback) {
    var _this = this;
    const TERMINAL_ORIGIN = [-97.35, 33];
    this.shapeCreatorService = new ShapeCreatorService(TERMINAL_ORIGIN[0], TERMINAL_ORIGIN[1]);
    var trackWidth_met = 4;
    let trackgeom = _this.shapeCreatorService.MakeColourRect(1000, trackWidth_met, 32.0 / 1024.0, 1 - (828.0 / 1024.0));
    let _track = JSON.parse(JSON.stringify(_this.track_label_tex));
    let track = _track.meshes[0];
    track.name = track.name;
    track.id = track.name;
    track.positions = trackgeom.positions;
    track.normals = trackgeom.normals;
    track.uvs = trackgeom.uvs;
    track.indices = trackgeom.indices;
    data.shapes[track.name] = 'data:' + JSON.stringify(_track);
    return _this.datauxview.attachDynamicObject(data, callback);
  }
  */

  /**
   * method for activity changed ships get meta data
   */
  getActivityChangedShips() {
    this.socket.emit('pullActivityChangedShips', '');
  }

  /**
   * method for activity changed ships process meta data
   */
  processActivityChangedShips() {
    if (this.shipObjects.length > 0 && this.activityChangedMetaData.length > 0) {
      this.shipObjects.forEach(m_ship => {
        this.activityChangedMetaData.forEach(a_ship => {
          a_ship.activity = a_ship.activity.toLowerCase();
          a_ship.location = (a_ship.location ? a_ship.location.replace(" ", "").replace("/", "_") : "");
          if ((m_ship.ship === a_ship.ship) && (m_ship.location === a_ship.location) && (m_ship.startdate === a_ship.startdate) && (m_ship.starttime === a_ship.starttime)) {
            const found = this.activityChangedShipList.some(el => el.name === m_ship.name);
            if (!found) {
              this.activityChangedShipList.push(m_ship);
              this.tagServ.showMessageTag(m_ship);
            }
          }
        });
      });
      this.broadcastInfo({ src: 'main', event: 'showmsgtag', data: this.activityChangedShipList, key: "" });
    }
  }

  // /* * * * *
  // * init socket service
  // * * * * * */
  // init_socket() {
  //   console.log('init_socket');
  //   var _this = this;
  //   let socketPath = this.projectConfig.socketport || 'http://localhost:3000';
  //   console.log("soket url", socketPath)
  //   if (_this.userId) {
  //     let socketport = `${socketPath}?userId=${_this.userId}&username=${_this.userName}`;
  //     _this.socket = io.connect(socketport);
  //     _this.socket.on('connect', onConnect);
  //     _this.socket.on('receiveMsg', onMessage);
  //     _this.socket.on('pushActivityChangedShips', onActivityChanged);
  //     _this.socket.on('disconnect', onDisconnect);
  //     _this.socket.on('connect_error', onError);
  //     _this.socket.on('reconnect_error', onError);

  //     function onConnect(evt) {
  //       console.log("socket connected!!");
  //       writeToScreen("CONNECTED");

  //       _this.socket.on("getNotification", data => {
  //         console.log("getNotification ", data);
  //         if (_this.userId === data['userid']) {
  //           _this.ctrlServ.openDialogBox(data['message']);
  //         }
  //       });

  //       _this.socket.on("getKioskStatus", message => {
  //         console.log("getKioskStatus :", message);
  //         _this.updateKioskStatus(message);
  //       });

  //       _this.socket.on("getInfo", message => {
  //         _this.getInfo(message);
  //       });
  //       _this.socket.on("getApproved", message => {
  //         _this.getApproved(message);
  //       });
  //     }

  //     function onMessage(message) {
  //       console.log("receiveMsg :", message);
  //       _this.openPublishDialog(message);
  //     }
  //     function onDisconnect(evt) {
  //       writeToScreen("DISCONNECTED");
  //       console.log("socket disconnected!!");
  //     }

  //     function onError(message) {
  //       writeToScreen('<span style="color: red;">ERROR:</span> ' + message);
  //     }

  //     function onActivityChanged(data) {
  //       writeToScreen('<span style="color: blue;">RESPONSE: ' + data + '</span>');
  //       console.log("activityChangedShips :", data);
  //       if (data.length > 0) {
  //         _this.activityChangedMetaData = data;
  //         _this.processActivityChangedShips();
  //       }
  //     }

  //     function doSend(message) {
  //       writeToScreen("SENT: " + message);
  //       _this.socket.emit('sendMsg', message);
  //     }

  //     function writeToScreen(message) {
  //       var pre = document.createElement("p");
  //       pre.style.wordWrap = "break-word";
  //       pre.innerHTML = message;
  //       //output.appendChild(pre);
  //     }

  //   }
  // }

  /**
   * method send info broadcast message through socket
   */
  sendInfo(obj) {
    if (this.socket !== undefined) {
      obj['userId'] = this.userId;
      obj['username'] = this.userName;
      obj['email'] = this.accountEmail;
      obj['app'] = 'sdms';
      obj['type'] = 'chitcreation';
      // obj['message'] = obj.message;
      this.socket.emit('sendInfo', obj);
    }
  }



  // sendApproved(obj) {
  //   if (this.socket !== undefined) {
  //     obj['userId'] = this.userId;
  //     this.socket.emit('sendApproved', obj);
  //   }
  // }
  /**
   * method recive info broadcast message through socket
   */
  getApproved(data) {
    if (data.message === 'success') {
      // if (this.userId !== data['userId']) {
      // console.log("getApproved ---:::", data);
      this.broadcastInfo({ src: 'chitStepper', event: 'chitApprove', data: 'reload', key: "" });
      // }
    }
  }

  /* * * * *
  * init data
  * * * * * */
  init_data() {
    this.socketService.init_socket(this.projectConfig);
    this.isAppLoaded = true;
    window['scope'] = this;
    window['dfx'] = this.dfx = this.datauxview.getDatascape();
    this.drawService.scene = this.dfx.getCamera().getScene();
    this.drawService.datauxview = this.datauxview;
    this.drawService.dfx = this.dfx;
    // if plantype is live directly load app
    if (this.planType.toLowerCase() === 'live') {
      let obj = { name: 'server', metaData: [], planType: this.planType };
      this.onLoadData(obj);
    }
    if (this.planType.toLowerCase() === 'radhaz') {
      this.radhaz_demo_mode = true;
      this.showUploadScreen = !true;
      this.showLoading = true;
      this.showRadHazDemo();

    }
  }

  /* * * * *
  * init onjects
  * loading all the static objects from objects.json
  * * * * * */
  initObjects(cbck) {
    let obj = 'objects-' + this.cfbport;
    // load all the assets to be used information from socket
    this.datauxview.loadAssets(obj, 'json', (objectstatus) => {
      if (objectstatus) {
        // load all the object settings from settings json file
        this.datauxview.renderAssets(obj, 'json', (objectstatus) => {
          if (objectstatus) {
            console.log('objects', objectstatus);
            this.dfx = this.datauxview.getDatascape();
            this.allElements = this.datauxview.getElementsid();
            this.ctrlServ.init(this.datauxview);
            this.tagServ.init(this.datauxview);
            this._khaConfig.datauxview = this.datauxview;
            this.activityServ.init(this.datauxview);
            this.reportServ.init(this.datauxview);
            this.addEnv();
            // this.getGroupData();
            //this.prepareSynchroliftDemo();
            this.updateCompass();
            this.createBasicShapes();
            this.showDetailTagStaticShip();
            //this.hideBuildings();
            // this.isAppLoaded = true;
            // this.deleteData();
            // this.getGroupData();
            // this.getStatusData();
            this.radhazVisServ.initService(this.datauxview, this.communicationServ, this.activityServ);
            // this.getLayoutData();
            //this.getLayoutData();
            cbck();
          }
        }, (id, pointer) => this.animate(id, pointer));
      }
    });
  }
  deleteData() {
    ["626237960f09e224a4cc84a2", "626257128eba6533d44957a5", "6267a5ee54d3e30039303d0f"].forEach(e => {
      // this.deleteGroup(e)
    })
    // ["620c8cc428bd4400355214de"].forEach(e=>{
    //   this.deleteLayout(e)
    // })

  }
  /* * * *
  * method for hide the building and load along with halifax port
  * * * */
  hideBuildings() {
    this.buildingsList = [];
    //let port = this.datauxview.getElementId("cfb_halifax");
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
    let pmesh = this.getMesh(mc[this.cfbport]);
    //let pmesh = this.getMesh("cfb_halifax");
    let comps = pmesh.getChildMeshes();
    let idx = 0;
    comps.forEach((m) => {
      if (m.id.includes('_buildings')) {
        if (m != null) {
          m.setEnabled(false);
        }
        let id = m.id.substr(m.id.lastIndexOf('buildings_'));
        this.buildingsList.push(id);
        idx++;
      }
      /*  if (m.id.includes('jetty_labels_1')) {
         this.jlabel_far = m;
       }
       if (m.id.includes('jetty_labels_2')) {
         this.jlabel_near = m;
       } */
    });
    this.activityServ.setBuildingList(this.buildingsList);
    this.createBuildings();
  }
  initLabels() {
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
    let pmesh = this.getMesh(mc[this.cfbport]);
    let comps = pmesh.getChildMeshes();
    let idx = 0;

    comps.forEach((m) => {
      if (this.cfbport.includes('esq')) {
        if (m.id.includes('esq_jetty_labels_LARGE')) {
          this.jlabel_far = m;
        }
        if (m.id.includes('esq_jetty_labels_SMALL')) {
          this.jlabel_near = m;
        }
        if (m.id.includes('C_Jetty_crane')) {
          m.setEnabled(false);
        }
        if (m.id.includes('EGD_kone_crane')) {
          m.setEnabled(false);
        }
        if (m.id.includes('EGD_ebco_crane')) {
          m.setEnabled(false);
        }

        if (m.id.includes('EGD_ebco_crane_track')) {
          m.setEnabled(true);
        }
        if (m.id.includes('EGD_kone_crane_track')) {
          m.setEnabled(true);
        }
      } else {
        //jetty_labels_1
        if (m.id.includes('jetty_labels_1')) {
          this.jlabel_far = m;
        }
        if (m.id.includes('jetty_labels_2')) {
          this.jlabel_near = m;
        }
        if (m.id.includes('Jetty_NF_crane')) {
          m.setEnabled(false);
        }
        if (m.id.includes('Jetty_NC_crane')) {
          m.setEnabled(false);
        }
        if (m.id.includes('Jetty_NB_crane')) {
          m.setEnabled(false);
        }
      }

    });
  }
  showHideKioskNames(boo = false) {
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
    let pmesh = this.getMesh(mc[this.cfbport]);
    let comps = pmesh.getChildMeshes();
    let idx = 0;
    comps.forEach((m) => {
      if (m.name.includes('C_Jetty_kiosk names')) {
        m.setEnabled(boo);
      }

    });
  }
  showHideBuildings(boo) {
    this.showBuildingState = boo;
    if (this.cfbport === 'cfbesquimalt') {
      let pmesh = this.getMesh("cfb_esquimalt");
      let bid = "esq_buildings_primitive0";
      let bld = pmesh.getChildMeshes().find(e => { return e.id.includes(bid) })
      if (bld != null) {
        bld.setEnabled(boo);
        //bld.material.wireframe=!boo
      }
      bid = "esq_buildings_primitive1";
      bld = pmesh.getChildMeshes().find(e => { return e.id.includes(bid) })
      if (bld != null) {
        bld.setEnabled(boo);
        //bld.material.wireframe=!boo
      }
      return
    } else {
      /* if (this.currentJetty === 'cfad') {
        let pmesh = this.getMesh("cfad");
        // console.log("cfad",pmesh.getChildMeshes())/
        let bid = "cfad_bldgs";
        let bld = pmesh.getChildMeshes().find(e => { return e.id.includes(bid) })
        if (bld != null) {
          bld.setEnabled(boo);
          //bld.material.wireframe=!boo
        }
        // return
      }
      if (this.currentJetty === 'shearwater') {
        let pmesh = this.getMesh("shearwater");
        let bid = "shearwater_bldgs";
        let bld = pmesh.getChildMeshes().find(e => { return e.id.includes(bid) })
        if (bld != null) {
          bld.setEnabled(boo);
          //bld.material.wireframe=!boo
        }
        // return
      } */
    }
    this.buildingsList.forEach((id) => {
      let m = this.getMesh(id);
      if (m) {
        if (m != null) {
          m.setEnabled(boo);
          //m.material.wireframe=!boo
        }
      }
    });
  }
  showHideGround(boo) {
    this.showGroundState = boo;
    let scene: any = window["scene"];
    let matids = boo ? ["rastMat", "land_base_map"] : ["Material.002", "Material.002"];
    let pmesh = this.getMesh("cfb_halifax");
    let mapids = ['EXPORT_GOOGLE_SAT_WM_primitive0', 'land_patch_primitive0']
    let mapid;
    if (this.cfb_externalport == '') {
      if (this.cfbport === 'cfbesquimalt') {
        /* pmesh = this.getMesh("cfb_esquimalt");
        mapids = ['cfb_esquimalt_base_primitive0'];
        matids = boo ? ["rastMat_esq"] : ["Material.002"]; */
        mapids = []
      }
      mapids.forEach((mapid, i) => {
        let matid = matids[i];
        let mat = scene.getMaterialByID(matid);
        let map = pmesh.getChildMeshes().find(e => { return e.id.includes(mapid) })
        map.material = mat;
      })
    }
    /* if (this.cfb_externalport == 'cfad') {
      //shearwater_port_mat,shearwater_port_mat_2
      //cfad_port_mat, cfad_land_mat
      matids = boo ? ['cfad_port_mat', 'cfad_land_mat'] : ["Material.002", "Material.002"];
      pmesh = this.getMesh("cfad");
      mapids = ['cfad_port_primitive0', 'land_cfad_primitive0']
      mapids.forEach((mapid, i) => {
        let matid = matids[i];
        let mat = scene.getMaterialByID(matid);
        let map = pmesh.getChildMeshes().find(e => { return e.id.includes(mapid) })
        map.material = mat;
      })
    }
    //
    if (this.cfb_externalport == 'shearwater') {
      matids = boo ? ['shearwater_port_mat', 'shearwater_port_mat_2'] : ["Material.002", "Material.002"];
      pmesh = this.getMesh("shearwater");
      mapids = ['shearwater_port_primitive0', 'land_shearwater_primitive0']
      mapids.forEach((mapid, i) => {
        let matid = matids[i];
        let mat = scene.getMaterialByID(matid);
        let map = pmesh.getChildMeshes().find(e => { return e.id.includes(mapid) })
        map.material = mat;
      })
    } */
  }
  resetGroundBld() {
    this.showHideBuildings(true);
    this.showHideGround(true);
  }


  /* * * *
  * create building objects with child halifax port
  * * * */
  createBuildings() {
    let port_el = this.datauxview.getElementId("cfb_halifax");
    this.buildingsList.forEach((bld) => {
      let shape = bld;
      let id = bld;
      let profiles = {
        regular: { material: 'custom-included' },
        invisible: { material: 'custom-included' },
        highlight: { material: 'custom-included' },
      };
      let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': { x: 0, y: 0, z: 0 }, 'size': 1 } };
      this.datauxview.addElement(shape, id, profiles, settings);
      let buildModel = this.datauxview.getElementId(id);
      this.dfx.setAsParent(port_el, [buildModel]);
      this.attchStaticObjEvent(buildModel);
    });
  }

  /* * * *
  * method for get jetty name
  * * * */
  getJettyName(id, port) {
    let str = id.split(".");
    let jetty = '';
    for (let idx in str) {
      if (str[idx] == 'model-' + port) {
        jetty = str[idx + 1];
        jetty = jetty.split("_").join("").toLowerCase();
        break;
      }
    }
    return jetty;
  }

  /* * * *
  * method for get jetty name
  * * * */
  getUID(obj) {
    let kioskJson = this.kioskJson['kioskJson']
    let service = obj['service'];
    let jetty = obj['jetty'];
    let kioskName = obj['id'].split("_").join("").replace(service, '').toLowerCase();
    let jettyJson = kioskJson[jetty];
    let uid = '';

    for (let el of jettyJson) {
      let servicetype = el['servicetype'].toLowerCase();
      let name = '';
      let item = el['kiosk'].split(" ").join("").replace(":", "").toLowerCase();
      if (isNaN(item)) {
        let num = item.replace(/[^0-9]/g, '');
        let text = item.match(/[a-zA-Z]+/g)[0];
        if (num) {
          let val = (Number(num) < 10 ? '0' + num : num);
          name = text + val;
        } else {
          name = text;
        }
      } else {
        name = item;
      }
      if ((kioskName == name) && (servicetype.includes(service))) {
        uid = el['uid'];
        break;
      }
    }
    return uid;
  }

  /* * * *
  * method for hide the kiosk and load along with esquimalt port
  * * * */
  hideKiosk() {
    this.kioskList = [];
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" };
    let port = mc[this.cfbport];
    let pmesh = this.getMesh("cfb_esquimalt");
    let comps = pmesh.getChildMeshes();
    comps.forEach((m) => {
      let obj = {};
      if (m.id.includes('kiosk_')) {
        let id = m.id.substr(m.id.lastIndexOf('kiosk_'));
        let jetty = this.getJettyName(m.id, port);
        let service = id.substr(id.lastIndexOf('_') + 1);
        //let pos = { x: (m.absolutePosition['x']-126.47),y:m.absolutePosition["y"]-5.6,z:130.98+m.absolutePosition["z"] }
        let pos = { x: (m.position['x'] + (126.47)), y: m.position["y"], z: m.position["z"] + (130.98) }
        obj['id'] = id;
        obj['jetty'] = jetty;
        obj['service'] = service;
        obj['port'] = port;
        obj['uid'] = this.getUID(obj);
        obj['position'] = pos;
        this.kioskList.push(obj);
        if (m != null) {
          m.setEnabled(false);
        }
      }
    });
    console.log("hideKiosk ", this.kioskList);
    this.createKioskObject();
  }

  /* * * *
  * create building objects with child halifax port
  * * * */
  createKioskObject() {
    let port_el = this.datauxview.getElementId("cfb_esquimalt");
    this.kioskList.forEach((kiosk) => {
      let shape = kiosk['id'];
      let id = (kiosk['uid'] === '' ? kiosk['id'] : kiosk['uid']);
      let profiles = {
        red: { material: 'cube_red' },
        orange: { material: 'cube_orange' },
        green: { material: 'cube_green' },
        regular: { material: 'custom-included' },
        invisible: { material: 'custom-included' },
        highlight: { material: 'custom-included' },
      };
      let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': kiosk['position'], 'size': 1 } };
      this.datauxview.addElement(shape, id, profiles, settings);
      let kioskModel = this.datauxview.getElementId(id);
      /* this.dfx.setAsParent(null, [kioskModel]);
      this.dfx.setElementScale(kioskModel,[-1,1,1]) */
      this.attchKioskObjEvent(kioskModel);
    });
  }

  /**
   * add shoreside object
   *
   */
  sso_cfbhalifax = [
    { shape: 'Jetty_NF_crane', name: "hfx_crane_1", "c_name": "NF Jetty Crane", orientation: { x: 0, y: 0, z: 0 }, position: { x: 2185.19, y: 0, z: 1425.09 }, size: 1 }
    , { shape: 'Jetty_NC_crane', name: "hfx_crane_2", "c_name": "NC Jetty Crane", orientation: { x: 0, y: -19.25, z: 0 }, position: { x: 2447.06, y: 0, z: 1268.81 }, size: 1 }
    , { shape: 'Jetty_NB_crane', name: "hfx_crane_3", "c_name": "NB Jetty Crane", orientation: { x: 0, y: -18.84, z: 0 }, position: { x: 2659.27, y: 0, z: 1310.11 }, size: 1 }
    , { shape: 'pole', name: "hfx_light_1", "c_name": "Halifax Light 1", orientation: { x: 0, y: -17, z: 0 }, position: { x: 2601.79, y: 3.3, z: 1525.21 }, size: 1 }
    , { shape: 'pole', name: "hfx_light_2", "c_name": "Halifax Light 2", orientation: { x: 0, y: -17, z: 0 }, position: { x: 2554, y: 3.3, z: 1523.5 }, size: 1 }
    , { shape: 'pole', name: "hfx_light_3", "c_name": "Halifax Light 3", orientation: { x: 0, y: -47, z: 0 }, position: { x: 2211, y: 3.3, z: 1442 }, size: 1 }
    , { shape: 'pole', name: "hfx_light_4", "c_name": "Halifax Light 4", orientation: { x: 0, y: -7, z: 0 }, position: { x: 1955, y: 3.3, z: 1427.88 }, size: 1 }
    , { shape: 'pole', name: "hfx_light_5", "c_name": "Halifax Light 5", orientation: { x: 0, y: 43, z: 0 }, position: { x: 1759.8, y: 3.3, z: 1406.6 }, size: 1 }
  ];
  sso_cfbesquimalt = [{ shape: 'thor_crane', name: "esq_crane_1", orientation: { x: 0, y: 37, z: 0 }, position: { x: 190.815, y: 3.50, z: 418.536 }, size: 1 }
    , { shape: 'C_Jetty_crane', name: "esq_crane_2", orientation: { x: 0, y: 0, z: 0 }, position: { x: -111.17, y: 2.5, z: -14.48 }, size: 1 }
    , { shape: 'EGD_kone_crane', name: "esq_crane_3", orientation: { x: 0, y: 206.7, z: 0 }, position: { x: -529.23, y: 3, z: -417.79 }, size: 1 }
    , { shape: 'EGD_ebco_crane', name: "esq_crane_4", orientation: { x: 0, y: 206.7, z: 0 }, position: { x: -578.87, y: 3, z: -397.14 }, size: 1 }
  ];
  crpath_cfbhalifax = {
    "hfx_crane_3": [{ x: 2592.79, y: 0, z: 1504.97, w: -18.84 * 0.0175, count: 600 }, { x: 2588.22, y: 0, z: 1514.73, w: -30.4 * 0.0175, count: 50 }, { x: 2584.1, y: 0, z: 1520.42, w: -42 * 0.0175, count: 50 }, { x: 2578.99, y: 0, z: 1524.94, w: -53.6 * 0.0175, count: 50 }, { x: 2573.3, y: 0, z: 1528.28, w: -65.2 * 0.0175, count: 50 }, { x: 2566.52, y: 0, z: 1530.59, w: -76.8 * 0.0175, count: 50 }, { x: 2560.11, y: 0, z: 1531.47, w: -88.4 * 0.0175, count: 50 }, { x: 2550.95, y: 0, z: 1530.95, w: -100 * 0.0175, count: 50 }, { x: 2520.05, y: 0, z: 1524.84, w: -101 * 0.0175, count: 250 }]
    , "hfx_crane_2": [{ x: 2368.56, y: 0, z: 1493.59, w: -0.336, count: 750 }]
    , "hfx_crane_1": [{ x: 2185.19, y: 0, z: 1325.8, w: 0, count: 300 }, { x: 2184.53, y: 0, z: 1317.46, w: 11.6 * 0.0175, count: 50 }, { x: 2182.62, y: 0, z: 1311.43, w: 23.2 * 0.0175, count: 50 }, { x: 2179.78, y: 0, z: 1306.24, w: 34.8 * 0.0175, count: 50 }, { x: 2175.92, y: 0, z: 1301.71, w: 46.4 * 0.0175, count: 50 }, { x: 2171.15, y: 0, z: 1297.91, w: 58 * 0.0175, count: 50 }, { x: 2165.78, y: 0, z: 1295.19, w: 69.6 * 0.0175, count: 50 }, { x: 2159.75, y: 0, z: 1293.68, w: 81.2 * 0.0175, count: 50 }, { x: 2150.76, y: 0, z: 1293.08, w: 90 * 0.0175, count: 50 }, { x: 2061.59, y: 0, z: 1293.74, w: 90.7 * 0.0175, count: 300 }, { x: 2051.53, y: 0, z: 1294.62, w: 99.5 * 0.0175, count: 50 }, { x: 2046.04, y: 0, z: 1296.19, w: 111 * 0.0175, count: 50 }, { x: 2040.79, y: 0, z: 1298.85, w: 122.6 * 0.0175, count: 50 }, { x: 2035.96, y: 0, z: 1302.59, w: 134.2 * 0.0175, count: 50 }, { x: 2031.98, y: 0, z: 1307.37, w: 145.8 * 0.0175, count: 50 }, { x: 2029.23, y: 0, z: 1312.44, w: 158 * 0.0175, count: 50 }, { x: 2027.42, y: 0, z: 1318.38, w: 169 * 0.0175, count: 50 }, { x: 2026.55, y: 0, z: 1329.31, w: 180 * 0.0175, count: 50 }, { x: 2027.22, y: 0, z: 1419.9, w: 180.7 * 0.0175, count: 300 }]
  };
  crpath_cfbesquimalt = {
    "esq_crane_1": []
    , "esq_crane_2": [{ x: 7.15, y: 2.5, z: -14.44, w: 0, count: 250 }, { x: 9.26, y: 2.5, z: -14.53, w: 0.044, count: 10 }, { x: 11.36, y: 2.5, z: -14.81, w: 0.131, count: 10 }, { x: 13.43, y: 2.5, z: -15.27, w: 0.218, count: 10 }, { x: 15.44, y: 2.5, z: -15.9, w: 0.305, count: 10 }, { x: 17.4, y: 2.5, z: -16.71, w: 0.393, count: 10 }, { x: 19.28, y: 2.5, z: -17.69, w: 0.48, count: 10 }, { x: 21.06, y: 2.5, z: -18.83, w: 0.567, count: 10 }, { x: 22.74, y: 2.5, z: -20.11, w: 0.655, count: 10 }, { x: 24.3, y: 2.5, z: -21.54, w: 0.742, count: 10 }, { x: 25.73, y: 2.5, z: -23.1, w: 0.829, count: 10 }, { x: 27.02, y: 2.5, z: -24.78, w: 0.916, count: 10 }, { x: 28.15, y: 2.5, z: -26.57, w: 1.004, count: 10 }, { x: 29.13, y: 2.5, z: -28.44, w: 1.091, count: 10 }, { x: 29.94, y: 2.5, z: -30.4, w: 1.178, count: 10 }, { x: 30.57, y: 2.5, z: -32.41, w: 1.265, count: 10 }, { x: 31.03, y: 2.5, z: -34.48, w: 1.353, count: 10 }, { x: 31.31, y: 2.5, z: -36.58, w: 1.44, count: 10 }, { x: 31.4, y: 2.5, z: -38.69, w: 1.527, count: 10 }, { x: 31.4, y: 9, z: -88.38, w: 1.571, count: 150 }, { x: 31.31, y: 9, z: -90.49, w: 1.614, count: 10 }, { x: 31.03, y: 9, z: -92.59, w: 1.702, count: 10 }, { x: 30.57, y: 9, z: -94.65, w: 1.789, count: 10 }, { x: 29.94, y: 9, z: -96.67, w: 1.876, count: 10 }, { x: 29.13, y: 9, z: -98.63, w: 1.964, count: 10 }, { x: 28.15, y: 9, z: -100.5, w: 2.051, count: 10 }, { x: 27.02, y: 9, z: -102.29, w: 2.138, count: 10 }, { x: 25.73, y: 9, z: -103.96, w: 2.225, count: 10 }, { x: 24.3, y: 9, z: -105.52, w: 2.312, count: 10 }, { x: 22.74, y: 9, z: -106.95, w: 2.4, count: 10 }, { x: 21.06, y: 9, z: -108.24, w: 2.487, count: 10 }, { x: 19.28, y: 9, z: -109.38, w: 2.575, count: 10 }, { x: 17.4, y: 9, z: -110.35, w: 2.662, count: 10 }, { x: 15.44, y: 9, z: -111.16, w: 2.749, count: 10 }, { x: 13.43, y: 9, z: -111.8, w: 2.836, count: 10 }, { x: 11.36, y: 9, z: -112.26, w: 2.924, count: 10 }, { x: 9.26, y: 9, z: -112.53, w: 3.011, count: 10 }, { x: 7.15, y: 9, z: -112.63, w: 3.098, count: 10 }, { x: -111.17, y: 9, z: -112.63, w: 3.142, count: 250 }]
    , "esq_crane_3": [{ x: -369.08, y: 3, z: -99.49, w: 3.607, count: 250 }]
    , "esq_crane_4": [{ x: -419.55, y: 3, z: -80.33, w: 3.607, count: 250 }]
  };
  addShoresideObjects() {
    let objs = this['sso_' + this.cfbport];
    objs.forEach((item) => {
      let el = this.datauxview.getElementId(item.name);
      if (!el) {
        let shape = item.shape;
        let id = item.name;
        let profiles = {
          regular: { material: 'custom-included' },
          invisible: { material: 'custom-included', visible: false },
          highlight: { material: 'custom-included' }
        };
        let settings = { 'geometry': { 'orientation': item.orientation, 'position': item.position, 'size': item.size * this.gratio } };
        this.datauxview.addElement(shape, id, profiles, settings);
        el = this.datauxview.getElementId(item.name);
        this.disableRQ(item.name);
        if (item.name.includes("esq_crane_2")) {
          let mesh = this.getMesh(item.name);
          let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
          let pmesh = this.getMesh(mc[this.cfbport]);
          mesh.parent = null;
          mesh.position.x = item.position.x;
          mesh.position.z = item.position.z;
          mesh.position.y = item.position.y;
          mesh.parent = pmesh;
        }
      }
      this.dfx.modify(el, { profile: "invisible" });
      this.attchStaticObjEvent(el);
    })
  }
  showShoresideObjects(p = null) {
    let objs = this['sso_' + (p || this.cfbport)];
    objs.forEach((item) => {
      let el = this.datauxview.getElementId(item.name);
      if (el) {
        this.ctrlServ.showElement(item.name)
      }
    })
  }
  hideShoresideObjects(p = null) {
    let objs = this['sso_' + (p || this.cfbport)];
    objs.forEach((item) => {
      let el = this.datauxview.getElementId(item.name);
      if (el) {
        this.ctrlServ.hideElement(item.name)
      }
    })
  }
  toggleCraneObjects(show, p = null) {
    let objs = this['sso_' + (p || this.cfbport)];
    objs.forEach((item) => {
      if (item.name.includes('crane')) {
        let el = this.datauxview.getElementId(item.name);
        if (el) {
          if (show) {
            this.ctrlServ.showElement(item.name);
          } else {
            this.ctrlServ.hideElement(item.name);
          }
        }
      }
    })
  }
  toggleLightObjects(show, p = null) {
    let objs = this['sso_' + (p || this.cfbport)];
    objs.forEach((item) => {
      if (item.name.includes('light')) {
        let el = this.datauxview.getElementId(item.name);
        if (el) {
          if (show) {
            this.ctrlServ.showElement(item.name);
          } else {
            this.ctrlServ.hideElement(item.name);
          }
        }
      }
    })
  }
  showHideSSO() {
    let showport = this.cfbport;
    let hideport = showport === 'cfbhalifax' ? 'cfbesquimalt' : 'cfbhalifax';
    this.showShoresideObjects(showport);
    this.hideShoresideObjects(hideport);
  }
  stopAllAnims() {
    this.globalanim = 'stop';
    this.craneanim = 'stop';
  }
  /**
   * show/hide jetty labels
   */
  jetty_label = null;
  jetty_label_mode = true;
  showJettyLabels(boo) {
    this.jetty_label_mode = boo;
    if (this.cfbport === 'cfbhalifax') {
      if (!this.jetty_label) {
        let pmesh = this.getMesh("cfb_halifax");
        let comps = pmesh.getChildMeshes();
        let idx = comps.findIndex(e => e.id.includes('jetty_labels'));
        if (idx > -1) {
          let mesh = comps[idx];
          this.jetty_label = mesh;
          mesh.isVisible = boo
        }
      } else {
        this.jetty_label.isVisible = boo
      }
    }
  }
  /**
   * show/hide labels for pdf
   */
  showLabelsForPDF(boo) {
    this.currentShipList.forEach((data) => {
      if (data.ship_status === 'show') {
        let m = this.getMesh(data.name);
        if (m.isVisible) {
          this.tagServ.showShipLabel(boo, data.name);
        }
      }
    })
  }
  /* * * *
  * create basic shapes
  * * * */
  createBasicShapes() {
    let dfx = this.datauxview.getDatascape();
    dfx.addShape('cylinder', [{ name: 'cylinder', height: 1, diaTop: 1, diaBottom: 1, tesselation: 32 }]);
  }

  /**
   * update compass graphic with camera orientation
   */
  liveEnv = false;
  liveTime = null;
  liveEnvCount = 0;
  timeToSunIncl(time = null) {
    let date = new Date();
    if (time) {
      date.setHours(time[0], time[1] || 0);
    }
    let t = date.toLocaleString('en-US', { hour: 'numeric', hour12: false });
    let m = date.getMinutes() / 60
    let dt = (((Number(t) + m) - 12) / 6) * 0.5;
    return dt;
  }
  updateSunPos(time = null) {
    let inc = this.timeToSunIncl(time);
    let vect = this.dfx.getVector();
    let matx = this.dfx.getMatrix();
    let axis = this.dfx.getAxis();
    let sunPosition = new vect(0, 0, 0);
    let distance = 500;
    if (this.sky) {
      let yaw = -60 * Math.PI / 180;
      if (!this.sky.material.useSunPosition) {
        this.sky.material.useSunPosition = true;
      }
      var theta = Math.PI * (inc - 0.5);
      var phi = 2 * Math.PI * (this.sky.material.azimuth - 0.5);
      sunPosition.x = distance * Math.cos(phi);
      sunPosition.y = distance * Math.sin(phi) * Math.sin(theta);
      sunPosition.z = distance * Math.sin(phi) * Math.cos(theta);
      var matrix = matx.RotationAxis(axis.Y, yaw);
      var v2 = vect.TransformCoordinates(sunPosition, matrix);
      this.sky.material.sunPosition.x = v2.x;
      this.sky.material.sunPosition.y = v2.y;
      this.sky.material.sunPosition.z = v2.z;
      this.setVenueLightsIntensity(2.5 - (Math.abs(inc) * 4));
    }
  }
  ccp = '';
  //offset:x:2229,z:1558
  updateCompass() {
    let cam = this.dfx.getCamera();
    let yaw = cam.yaw_deg.value;
    let pitch = cam.pitch_deg.value;
    this.zangle = 0;
    this.xangle = 0;
    let aoff = this.cfbport === 'cfbesquimalt' ? 111 : 43;
    //
    let anim = (t) => {
      /**
       * handle dpr change
       */
      let curs = this.datauxview.rendererCanvas.nativeElement;
      curs.style.cursor = (this.plotmode_ca || this.plotmode_location) ? "crosshair" : "pointer";
      // curs.style.cursor = this.plotmode_location ? "crosshair" : "pointer";
      if (this.view_dpr != window.devicePixelRatio) {
        this.view_dpr = window.devicePixelRatio;
        if (this.game_engine) {
          this.game_engine.setHardwareScalingLevel(1 / window.devicePixelRatio)
        }
      }
      //

      yaw = cam.yaw_deg.value;
      pitch = cam.pitch_deg.value;
      this.zangle = 180 - yaw - aoff;
      this.xangle = 90 - pitch;
      if (this.liveEnv) {
        if (this.liveEnvCount === 0 || this.liveEnvCount >= 60 * 60) {
          this.updateSunPos(this.liveTime);
          this.liveEnvCount = 0;
        }
        this.liveEnvCount++
      }
      if (cam.distance.value < 2000) {
        //if (this.ccp != 'near') {
        cam.minZ = 1
        if (this.jlabel_far) {
          this.jlabel_far.isVisible = false;
          this.jlabel_near.isVisible = false;
          this.jetty_label = this.jlabel_near;
          this.ccp = 'near';
          this.jetty_label.isVisible = this.jetty_label_mode;

        }
        //}
      } else {
        cam.minZ = 10
        //if (this.ccp != 'far') {
        if (this.jlabel_far) {
          this.jlabel_far.isVisible = false;
          this.jlabel_near.isVisible = false;
          this.jetty_label = this.jlabel_far;
          this.ccp = 'far';
          this.jetty_label.isVisible = this.jetty_label_mode;
        }
        //}
      }
      requestAnimationFrame(anim)
    }
    requestAnimationFrame(anim)
  }
  /**
   * pos geo coordinates to meters
   * ref:m: -219.009044, 315.181059
   * ref:latlon: 44.6562, -63.5771
   */
  gscale = 0.7167;
  gratio = 1;// 1 / 0.7167;
  port_origin_m
  port_origin
  getModelGeom() {
    let obj
    if (this.cfbport === 'cfbhalifax') {
      //obj = { origin: [44.6562, -63.5771], off: [-219.009044, 315.181059], gscale: 0.7167, gratio: 1 / 0.7167 }
      obj = { origin: [44.6562, -63.5771], off: [-219.009044, 315.181059], gscale: 1, gratio: 1 }
    } else {
      obj = { origin: [48.4333, -123.4303], off: [-280.502819 - 470.267279], gscale: 1, gratio: 1 }
    }
    this.gscale = obj.gscale;
    this.gratio = obj.gratio;
    this.port_origin_m = obj.off;
    this.port_origin = obj.origin;
  }
  public latlong_mt(origin_deg, pos_deg, off = [-219.009044, 315.181059]) {
    let m1 = 111132.92;
    let m2 = -559.82;
    let m3 = 1.175;
    let m4 = -0.0023;
    let p1 = 111412.84;
    let p2 = -93.5;
    let p3 = 0.118;
    let lat = origin_deg[0] * Math.PI / 180;
    const cos = Math.cos;
    let degrees_lat_to_metres = m1 + (m2 * cos(2 * lat)) + (m3 * cos(4 * lat)) + (m4 * cos(6 * lat));
    let degrees_lon_to_metres = (p1 * cos(lat)) + (p2 * cos(3 * lat)) + (p3 * cos(5 * lat));
    let x_met: any = ((pos_deg[1] - origin_deg[1]) * degrees_lon_to_metres).toFixed(6);
    let z_met: any = ((pos_deg[0] - origin_deg[0]) * degrees_lat_to_metres).toFixed(6);
    return [off[0] - (x_met / this.gscale), off[1] - (z_met / this.gscale)]
    //return [off[0] - (x_met * Math.cos(ang[1])), off[1] - (z_met * Math.sin(ang[1]))];
  }
  /**
   * disable rotation quaternion
   */
  disableRQ(id) {
    let mship1 = this.getMesh(id);
    mship1.rotationQuaternion = null;
    return null;//mship1;
  }
  /**
   * add environment - sky, ocean
   * @sathesh Dec18
   */
  sky = null;
  ocean = null;
  addToOceanRL(arr) {
    arr.forEach((ship) => {
      this.ocean.addToRenderList(ship);
      let c = ship.getChildMeshes();
      c.forEach((m) => {
        this.ocean.addToRenderList(m);
      })
    })
  }
  addEnv() {
    /* let mship = this.getMesh("vcsub");
    mship.rotationQuaternion = null; */
    let s1 = this.disableRQ("tug");
    let s2 = this.disableRQ("tug2");
    this.disableRQ("ship_vis3");
    this.disableRQ("ship_vis2");
    /* let s3 = this.disableRQ("sackville2");
    let s4 = this.disableRQ("kingston");
    let s5 = this.disableRQ("orca");
    this.disableRQ("rhib");
    this.disableRQ("rhib_p");
    this.disableRQ("rhib_q");
    this.disableRQ("rhib_p_1"); */
    if (!this.cfbport.includes('esq')) {
      this.disableRQ("halifax_demo");

    } else {
      this.disableRQ("ship_csc3");
    }

    // this.disableRQ("halifax_demo2");
    this.sky = this.dfx.addSky('sky', { size: 20000, rayleigh: 1, inclination: 0.1 });
    //let rl = [this.sky];
    //this.ocean = this.dfx.addOcean("ocean", { renderList: rl, waveOpts: { height: 0.1, dir: [-1.25, -0.35] }, meshOpts: { width: 5000, height: 5000, subdiv: 32 * 5 }, texOpts: { fresnelSeparate: true, bumpSuperimpose: true, bumpAffectsReflection: true, bump: 0.5, bumptex: "./assets/sdms/assets/env/waterbump.png" } });
    //this.ocean.alpha = 0.95;
    //this.ocean.bumpTexture.wAng = 1;
    //this.ocean.bumpTexture.uScale=this.ocean.bumpTexture.vScale=.5
    let scene = this.dfx.getCamera().getScene();
    //this.setVenueLightsIntensity(2.5);
    this.updateSunPos([14])
    /**
     * to be removed on prod
     * only for dev
     */
    window['scope'] = this;
    window['dfx'] = this.dfx;
    window['scene'] = scene;
    this.game_engine = scene.getEngine();
    //
    let checkformesh = () => {
      if (this.ocean && this.ocean._mesh) {
        this.toggleOffOcean(true);
      } else {
        setTimeout(() => {
          checkformesh();
        }, 0)
      }
    }
    checkformesh();

    /* setTimeout(()=>{
      this.addToOceanRL([s1,s2,s3,s4,s5]);
    },1000) */
  }
  addOcean() {
    let rl = [this.sky];
    let dim = [5000, 5000]
    if (this.cfbport === 'cfbhalifax') {
      dim = [50000, 50000]
    }
    this.ocean = this.dfx.addOcean("ocean", { renderList: rl, waveOpts: { height: 0.1, dir: [-1.25, -0.35] }, meshOpts: { width: dim[0], height: dim[1], subdiv: 32 * 5 }, texOpts: { fresnelSeparate: true, bumpSuperimpose: true, bumpAffectsReflection: true, bump: 0.5, bumptex: "./assets/sdms/assets/env/waterbump.png" } });
    //this.ocean.alpha = 0.9;
    //this.ocean.colorBlendFactor2 = 0.5;
  }
  enableStencilBuffer() {
    let engine = this.game_engine;
    let scene = window['scene'];
    if (!this.ground) {
      if (this.cfbport === 'cfbhalifax') {
        this.ground = this.getChildMesh('cfb_halifax', 'hfx_water');
      } else {
        this.ground = this.getChildMesh('cfb_esquimalt', 'esq_water');
      }
    }
    let checkformesh = () => {
      if (this.ocean && this.ocean._mesh) {

        let waterMesh = this.ocean._mesh;
        //let ground = this.getMesh('ground');
        this.ground.renderingGroupId = 1
        waterMesh.renderingGroupId = 1;
        engine.setStencilBuffer(true);
        scene.setRenderingAutoClearDepthStencil(0, true, true, true);
        scene.setRenderingAutoClearDepthStencil(1, false, false, false);
        waterMesh.onBeforeRenderObservable.add(() => {
          engine.setStencilMask(0x00);
          engine.setStencilFunction(517);//BABYLON.Engine.NOTEQUAL
          engine.setStencilFunctionReference(1);
        });
        this.ground.onBeforeRenderObservable.add(() => {
          engine.setStencilMask(0x00);
          engine.setStencilFunction(517);//BABYLON.Engine.NOTEQUAL
          engine.setStencilFunctionReference(1);
        });
      } else {
        setTimeout(() => {
          checkformesh();
        }, 0)
      }
    }
    checkformesh();
  }
  /**
   * set venue lights intensity
   */
  setVenueLightsIntensity(i = 2) {
    let scene = this.dfx.getCamera().getScene();
    let lights = scene.lights;
    lights.forEach((light) => {
      light.intensity = i;
    })
  }
  /***
   * Laydown object add tag
   */
  laydownArea(e) {
    var pmesh, bid;
    console.log("attchEventLaydown id", e.pickedMesh.id);
    if (this.cfbport === 'cfbhalifax') {
      pmesh = this.getMesh("cfb_halifax");
      bid = "laydown";
    }
    if (this.cfbport === 'cfbesquimalt') {
      pmesh = this.getMesh("cfb_esquimalt");
      bid = "FMF_CB._laydowns";
    }
    if (!pmesh) {
      return
    }
    let eleLaydown = pmesh.getChildren().find(e => { return e.id.includes(bid) });
    console.log("attchEventLaydown", eleLaydown._children);
    let idx = eleLaydown._children.findIndex(ele => ele.id == e.pickedMesh.id);
    if (idx > -1) {
      this.addLaydownPointer(e);
    }
  }
  laydownPointer: any;
  laydownPointerElem: any;
  /***
   * Laydown object add tag
   */
  addLaydownPointer(e) {
    console.log('addLaydownPointer');
    if (this.laydownPointer) {
      if (this.laydownPointer.pickedMesh.id == e.pickedMesh.id) {
        this.broadcastInfo({ src: 'main', event: 'showLaydownPointer', data: 'laydownPointer', state: false, sub: e.pickedMesh.id });
        delete this.laydownPointer
      } else {
        this.laydownPointer = e;
        this.activityServ.createShapePointer('cube', e);
        setTimeout(() => {
          this.ctrlServ.focusElement({ name: 'laydownPointer' }, true);
        }, 500);
      }
    } else {
      this.laydownPointer = e;
      this.activityServ.createShapePointer('cube', e);
      setTimeout(() => {
        this.ctrlServ.focusElement({ name: 'laydownPointer' }, true);
      }, 500);
    }
  }
  // First Aid object add tag

  firstAidPointer: any;
  firstAidPointerElem: any;
  addFirstAidPointer(e) {
    console.log('addFirstAidPointer');
    if (this.firstAidPointer) {
      if (this.firstAidPointer.pickedMesh.id == e.pickedMesh.id) {
        this.broadcastInfo({ src: 'main', event: 'showFirstAidPointer', data: 'firstAidPointer', state: false, sub: e.pickedMesh.id });
        delete this.firstAidPointer
      } else {
        this.firstAidPointer = e;
        this.activityServ.createShapePointer('cube', e);
        setTimeout(() => {
          this.ctrlServ.focusElement({ name: 'firstAidPointer' }, true);
        }, 500);
      }
    } else {
      this.firstAidPointer = e;
      this.activityServ.createShapePointer('cube', e);
      setTimeout(() => {
        this.ctrlServ.focusElement({ name: 'firstAidPointer' }, true);
      }, 500);
    }
  }

  getUIDData() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return Math.random().toString(36).substr(2, 9);
  }
  layoutHeading: any = "";
  showLayout: any = false;
  temporaryCommentData: any;
  LayoutMode: any = false;
  layoutName: any;
  notesElement: any = {};
  layoutData: any = [];
  selectedLayoutList: any = []
  isLayoutnameTyped: any = false;
  createNewLayoutTooltipState: any = false;

  compComments: any;
  isCommentTyped: any = false;
  onComment(e) {
    if (this.compComments) {
      this.isCommentTyped = true;
    } else {
      this.isCommentTyped = false;
    }
  }

  /**
   * for dev get picked point data
   */
  last_pick_pt = null;
  pickedMeshObj: any;
  selectedTagItem: any;
  showRawDataYard() {
    if (this.dfx) {
      const hit = this.dfx.getHitPosition();
      // delete this.rawData;
      if (!hit.hit) {
        return;
      }
      // if (this.noteStatus && !this.isDragmove && this.clickPosition.button == 0) {
      //   console.log("-----", hit, hit.pickedMesh.id);
      //   delete this.saveNotesData.status;
      //   var mesh = hit.pickedMesh;
      //   var pmesh;
      var mesh = hit.pickedMesh;
      if (mesh != null && this.doubleClick === 0) {

      }
      //   if (mesh != null && this.doubleClick === 0) {
      //     if (mesh.name.includes('_slicer') && mesh.name.includes('marker_')) {
      //       this.drawService.selectedMarker = mesh.name.split("_slicer")[0];
      //       if (Object.keys(this.drawService.cselects).length === 0) return;
      //       let markerObj = this.drawService.cselects[this.drawService.selectedMarker];
      //       this.markerColor = markerObj[7] || "#ff0000";
      //       this.fillStatus=!!(markerObj[9])
      //       this.drawService.draw_select_fill=this.fillStatus;
      //     } else {
      //       // this.khaConfig.highlightSelection(mesh,4,null,true);
      //     }
      //     if (this.drawService.cut_mode || this.drawService.draw_select_mode) {
      //       //this.khaConfig.applyCutoutAt(hit.pickedPoint, hit.pickedMesh,null,hit.faceId);
      //       if (this.markerShape === 'polygon' && this.drawing) {
      //         return;
      //       }
      //       //return
      //     }
      //   }
      //   // if (this.cfbport === 'cfbhalifax') {
      //   //   pmesh = this.getMesh("cfb_halifax");
      //   // }
      //   // if (this.cfbport === 'cfbesquimalt') {
      //   //   pmesh = this.getMesh("cfb_esquimalt");
      //   // }
      //   // console.log("--mesh---", pmesh);
      //   let mname = this.ctrlServ.getMeshName(mesh.name);
      //   let str = mesh.name
      //   let narr = str.split(".");
      //   let nstr = narr[narr.length - 1];
      //   let uid = this.getUIDData();
      //   if(!this.selectedLayoutList){
      //     var shapeId = 'cube'
      //   } else {
      //     shapeId = this.selectedLayoutList.shapeId
      //   }
      //   this.pickedMeshObj = { tagShapeId: uid, shapeId: shapeId, position: { x: hit.pickedPoint.x, y: hit.pickedPoint.y, z: hit.pickedPoint.z }, parentMeshId: nstr, port: this.cfbport };
      //   console.log("--mesh---", pmesh, this.pickedMeshObj);
      //   this.selectedTagItem = this.pickedMeshObj;
      //   this.saveNotesData = {}
      //   this.saveNotesData['group'] ={'name': "Group Name", "color":"#BDBDBD"}
      //   this.saveNotesData['status'] ={'name': "Status Name", "value":"#BDBDBD"}
      //   this.broadcastInfo({ src: 'tagPoint', event: 'defaultColor', data:  this.saveNotesData, key: this.selectedTagItem });
      //   this.tagServ.createMatObject("cube", hit, mname);
      //   //this.selectedGroup();
      //   console.log("--mesh---", pmesh, this.pickedMeshObj);
      //   this.selectedTagItem = this.pickedMeshObj;
      //   return;
      // }
      this.laydownArea(hit);
      if(this.clickPosition.button==0){
        this.createCommentsPointer(hit);
      }
      const hpt = hit.pickedPoint;
      console.log("Picked Point main : ", hit.pickedPoint)
      console.log("Picked Point: ", hpt.x, hpt.z)
      if (this.last_pick_pt) {
        let dx = hpt.x - this.last_pick_pt.x;
        let dy = hpt.z - this.last_pick_pt.z;
        let rad = Math.atan2(dy, dx);
        let deg = rad * 180 / Math.PI;
        let ds = Math.sqrt(dx * dx + dy * dy)
        console.log("Picked Angle: ", rad.toFixed(4), deg.toFixed(4));
        console.log("Picked Distance: ", ds.toFixed(4));
      }
      this.last_pick_pt = hpt;
      //rawdata
      if (this.rawDataStatus && this.currentShipList.length > 0) {
        if (hit.pickedMesh.name.split(/-(.+)/) != undefined) {
          let elemId = hit.pickedMesh.name.split(/-(.+)/)[1].split(".")[0];
          let idx = this.currentShipList.findIndex(e => e.name == elemId);
          if (idx > -1) {
            this.rawData = this.currentShipList[idx];
            // this.onSelectedShip(this.currentShipList[idx])
          }
        }
      }
    }
  }
  angle(p1, p2) {
    let dx = p1[0] - p2[0];
    let dy = p1[1] - p2[1];
    let rad = Math.atan2(dy, dx);
    let deg = rad * 180 / Math.PI;
    return [deg, rad]
  }

  /****
   * Create comments pointer and tag
   */
   createCommentsPointer(hit){

    var mesh = hit.pickedMesh;
    let mname = this.ctrlServ.getMeshName(mesh.name);
    console.log("-----", hit.pickedPoint, hit.pickedMesh.id, "-----", mname);
    let str = mesh.name
    let narr = str.split(".");
    let nstr = narr[narr.length - 1];
    let uid = this.getUIDData();
    // if(!this.selectedLayoutList){
    var shapeId = 'sphere';
    // } else {
    //   shapeId = this.selectedLayoutList.shapeId
    // }
 
    var pickedMeshObj = { name: uuid.v4(), commentList: [],status:false,group:'', shapeId: shapeId, position: { x: hit.pickedPoint.x, y: hit.pickedPoint.y, z: hit.pickedPoint.z }, parentMeshId: nstr, port: this.cfbport };
    if (!this._khaConfig.commentData) {
      if (hit.pickedMesh && hit.pickedMesh.id) {
        let idx = this.shipObjects.findIndex(e => 'element-' + e.name == hit.pickedMesh.id.split('.')[0]);
        //  this.shipObjects.findIndex(e => e.name == hit.pickedMesh.id.split('.')[0].split('-')[1]);
        if (idx == -1) {
          console.log("hit-clearGizmoOnEmptyPointerEvent", pickedMeshObj)
          let gizmo = this.dfx.getGizmoManager();
          gizmo.clearGizmoOnEmptyPointerEvent = true;
          if(this._khaConfig.vesselDragState){
            this.tagServ.createCommentsObject(pickedMeshObj);
            this._khaConfig.dragVesselComment.push(pickedMeshObj);
          }
        } else {
          if (this._khaConfig.vesselDragState) {
         
            mname = this.shipObjects[idx]['name'];
            var commentList = { name: mname, commentList: [],status:false,group:'' }
            var elem = this.datauxview.getElementId(mname);

            if (this._khaConfig.dragVesselComment.length > 0) {
              let idx = this._khaConfig.dragVesselComment.findIndex(e => e.name == mname);
              if (idx == -1) {
                this._khaConfig.dragVesselComment.push(commentList);
                // this.tagServ.showCommentTag(commentList,true);
                this.broadcastInfo({ src: 'khaservice', event: 'commentTag', data: commentList, key: true });
                // dfx.addTransformHandlers(elem,{scale:false,position:false,rotation:true})
              }
            } else {
              this._khaConfig.dragVesselComment.push(commentList);
              this.broadcastInfo({ src: 'khaservice', event: 'commentTag', data: commentList, key: true });
              // dfx.addTransformHandlers(elem,{scale:false,position:false,rotation:true})
            }
            console.log("onDragEndObservable", mname, mesh, event, this._khaConfig.dragVesselComment);
          }
        }
      }
    }
    if (this._khaConfig.commentData) {
      this.tagServ.showCommentTag(this._khaConfig.commentData, true);
      delete this._khaConfig.commentData;
      delete this.tagServ.commentData;
      delete this.tagServ.commentId;
      this._khaConfig.urls=[]
    }
   }

  /**
   * synchrolift demo
   * TODO - move to seperate service
   */
  sl_demo_ship;
  sl_platform;
  sl_ship_apos = { x: 2382.80, y: 0, z: 1118.67 }
  sl_ship_spos = { x: 2304.77, y: 9.86, z: 1380.99 }
  //

  prepareSynchroliftDemo() {
    let mship = this.sl_demo_ship = this.getMesh("halifax_demo");
    this.sl_demo_ship.rotationQuaternion = null;
    //mship.setEnabled(false);
    let port = ("cfb_halifax");
    let pmesh = this.getMesh(port);
    let comps = pmesh.getChildMeshes();
    comps.forEach((m) => {
      if (m.id.includes('Jetty_ND_syncrolift')) {
        this.sl_platform = m;
      }
    })
    //this.sl_platform.setEnabled(false);
    /* let pos=this.sl_platform.getBoundingInfo().boundingBox.center
    mship.position.x=pos.x;
   // mship.position.y=pos.y;
    mship.position.z=pos.z; */
  }

  distance(p1, p2) {
    let dx0 = p1.x - p2.x;
    let dz0 = p1.z - p2.z;
    let ds0 = Math.sqrt(dx0 * dx0 + dz0 * dz0)
    return ds0;
  }
  distance3(p1, p2) {
    let dx0 = p1.x - p2.x;
    let dy0 = p1.y - p2.y;
    let dz0 = p1.z - p2.z;
    let ds0 = Math.sqrt(dx0 * dx0 + dy0 * dy0 + dz0 * dz0)
    return ds0;
  }
  resetSLDemo() {
    let mship = this.sl_demo_ship;
    if (mship != null) {
      mship.position.x = this.sl_ship_spos.x;
      mship.position.y = this.sl_ship_spos.y;
      mship.position.z = this.sl_ship_spos.z;
      this.sl_platform.position.y = -3.12;
      // mship.setEnabled(true);
    }
  }
  setSLDemo() {
    let mship = this.sl_demo_ship;
    if (mship != null) {
      mship.position.x = this.sl_ship_apos.x;
      mship.position.y = this.sl_ship_apos.y;
      mship.position.z = this.sl_ship_apos.z;

    }
  }
  resetCraneDemo() {
    /* let mship = this.cr_demo_obj;
    if (mship)
      mship.rotation.y = 0 * Math.PI / 180; */
    this.cr_demo_obj.forEach((m) => {
      m.rotation.y = 0;
    })
    this['crane_mngr_' + this.cfbport].stop();
  }
  animateSynchroLift() {
    this.resetSLDemo();
    this.setSLDemo();
    this.globalanim = 'play'
    let pds = 0.2;
    let sds = 1;
    let pdir = -1;
    let astate = 'pdown';
    let pdlim = -11;
    let sang = 107 * Math.PI / 180;
    let aid = null;
    let dest = { x: 2304.77, z: 1380.99 };
    let dest2 = { x: 246, z: 276 };
    let wait = false;
    let waittime = 60 * 2
    let waitcount = 0;
    if (this.sl_demo_ship != null) {
      this.sl_demo_ship.setEnabled(true);
    }
    let animate = (t) => {
      if (this.globalanim === 'stop') {
        this.broadcastInfo({ src: 'main', event: 'stop', data: null });
        cancelAnimationFrame(aid);
        return;
      }
      if (this.globalanim === 'paused') {
        aid = requestAnimationFrame(animate)
        return;
      }
      if (astate === 'pdown') {
        this.sl_platform.position.y += pds * pdir;
        if (this.sl_platform.position.y <= pdlim) {
          pdir = 1;
          astate = 'ship_in'
        }
      }
      if (astate === 'pup') {
        if (wait) {
          if (waitcount >= waittime) {
            pdir = -1;
            astate = 'ship_down';
            wait = false;
            waitcount = 0;
          }
          waitcount++
        } else {
          this.sl_platform.position.y += pds * pdir;
          this.sl_demo_ship.position.y += pds * pdir;
          if (this.sl_platform.position.y >= -3.12) {
            this.sl_platform.position.y = -3.12;
            //pdir = -1;
            //astate = 'ship_down'
            wait = true;
            waitcount = 0

          }
        }
      }
      if (astate === 'ship_down') {
        this.sl_platform.position.y += pds * pdir;
        this.sl_demo_ship.position.y += pds * pdir;
        if (this.sl_platform.position.y <= pdlim) {
          pdir = 1;
          astate = 'ship_out'
        }
      }
      if (astate === 'ship_in') {
        let dx = sds * Math.cos(sang);
        let dz = sds * Math.sin(sang);
        this.sl_demo_ship.position.x += dx;
        this.sl_demo_ship.position.z += dz;
        let dd = dest;
        let ds = this.distance(this.sl_demo_ship.position, dd);
        if (ds < 5) {
          astate = 'pup';
        }

      }
      if (astate === 'ship_out') {
        if (wait) {
          if (waitcount >= waittime / 2) {
            astate = 'ship_in';
            wait = false;
            waitcount = 0;
          }
          waitcount++
        } else {
          let dx = sds * Math.cos(sang);
          let dz = sds * Math.sin(sang);
          this.sl_demo_ship.position.x -= dx;
          this.sl_demo_ship.position.z -= dz;
          let dd = this.sl_ship_apos;
          let ds = this.distance(this.sl_demo_ship.position, dd);
          if (ds < 5) {
            //astate = 'ship_in';
            wait = true;
          }
        }

      }
      if (astate === 'stop') {
        cancelAnimationFrame(aid);
        return
      }
      aid = requestAnimationFrame(animate)
    }
    aid = requestAnimationFrame(animate)
    // this.dfx.moveCamera({ target: { x: 97.75, y: -35, z: 180 }, distance: 1128, yaw: 43, pitch: 28 })
    /* setTimeout(() => {
      aid = requestAnimationFrame(animate)
    }, 300) */
  }
  cr_demo_obj
  animateCranes() {
    this.resetCraneDemo();
    this.craneanim = 'play'
    let pds = (2 * Math.PI / 180) / 30;
    let sds = 0.2;
    let pdir = -1;
    let astate = 'pdown';
    let pdlim = -30 * Math.PI / 180;
    let sang = 0;//15 * Math.PI / 180;
    let aid
    if (!this.cr_demo_obj || !this.cr_demo_obj.length) {
      /* this.cr_demo_obj = this.getChildMesh('esq_crane_1', 'tower').parent;
      this.cr_demo_obj.rotationQuaternion = null */
      return
    }
    this['crane_mngr_' + this.cfbport].play();
    let animate = (t) => {
      if (this.craneanim === 'stop') {
        this['crane_mngr_' + this.cfbport].stop();
        this.broadcastInfo({ src: 'main', event: 'stop', data: 'crane' });
        cancelAnimationFrame(aid);
        return;
      }
      if (this.craneanim === 'paused') {
        aid = requestAnimationFrame(animate)
        return;
      }
      if (astate === 'pdown') {
        this.cr_demo_obj.forEach((m) => {
          m.rotation.y += pds * pdir;
        })

        if (this.cr_demo_obj[0].rotation.y <= pdlim) {
          pdir = 1;
          astate = 'pup'
        }
      }
      if (astate === 'pup') {
        this.cr_demo_obj.forEach((m) => {
          m.rotation.y += pds * pdir;
        })
        if (this.cr_demo_obj[0].rotation.y >= sang) {
          pdir = -1;
          astate = 'pdown';
        }
      }
      if (astate === 'stop') {
        this['crane_mngr_' + this.cfbport].stop();
        cancelAnimationFrame(aid);
        return
      }
      aid = requestAnimationFrame(animate)
    }
    aid = requestAnimationFrame(animate);
    /* this.dfx.moveCamera({ target: { x: 399, y: -35, z: -437 }, distance: 1128, yaw: 43, pitch: 28 })
    setTimeout(() => {
      aid = requestAnimationFrame(animate)
    }, 1000) */
  }

  /**
   * camera view animation
   */
  animateAID;
  viewIndex = 0;
  intervalTimer = 0;
  int_limit = 30;
  xanimateCameraView() {
    let camviews = [
      { "target": { x: 13.768609001905872, y: 75.2509645343311, z: -366.56632518033075 }, "distance": 200, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 48.97056168955436, y: 97.90386652291863, z: -452.6523980966872 }, "distance": 200, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 75.51513918083629, y: 132.2828428020527, z: -473.19432389300266 }, "distance": 200, "yaw": 76, "pitch": 27.85 },
      { "target": { x: 139.081991061744, y: 139.3592834472656, z: -371.1816836354937 }, "distance": 200, "yaw": 73, "pitch": 27.85 },
      { "target": { x: 205.877170785923, y: 139.35928344726562, z: -278.0056771170589 }, "distance": 300, "yaw": 73, "pitch": 27.85 },
      { "target": { x: 230.50971934788618, y: 136.29796218872065, z: -235.5210063326022 }, "distance": 300, "yaw": 73, "pitch": 27.85 },
      { "target": { x: 113.71716562833552, y: 136.29796218872065, z: -229.2994778610924 }, "distance": 300, "yaw": 73, "pitch": 27.85 },
      { "target": { x: 299.5049529466353, y: 7.950984581839293e-7, z: 94.89339066013645 }, "distance": 300, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 357.84634764253383, y: 0, z: 307.97275301487366 }, "distance": 500, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 433.9639992488112, y: 2.2737367544323206e-13, z: 612.4913987274367 }, "distance": 500, "yaw": 80, "pitch": 27.85 },

      { "target": { x: 536.3804371500777, y: 2.2737367544323206e-13, z: 822.3461230625971 }, "distance": 800, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 581.2502026707534, y: 0, z: 1054.078209332312 }, "distance": 800, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 582.6226720949461, y: 0, z: 1273.8898185190646 }, "distance": 800, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 576.612913961993, y: 4.547473508864641e-13, z: 1496.4324192921404 }, "distance": 800, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 501.4972889715879, y: 2.2737367544323206e-13, z: 1713.9193447892615 }, "distance": 800, "yaw": 84, "pitch": 27.85 },

      { "target": { x: 424.17813029066826, y: 0, z: 423.12692943119595 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 450.08632646331296, y: 0, z: 509.8713430183987 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 498.8143806290415, y: -5.684341886080802e-14, z: 701.4154571822469 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 527.396362765599, y: 0, z: 870.3665928658031 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 586.8709922648396, y: 0, z: 1048.582609694375 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 637.4950256505138, y: -1.1368683772161603e-13, z: 1229.8804880090388 }, "distance": 1200, "yaw": 84, "pitch": 27.85 },
      { "target": { x: 606.1915343066822, y: -1.1368683772161603e-13, z: 1503.1302147203264 }, "distance": 1200, "yaw": 80, "pitch": 27.85 },
      { "target": { x: 516.0247582059473, y: -1.1368683772161603e-13, z: 1717.102903314374 }, "distance": 1200, "yaw": 70, "pitch": 27.85 },

      { "target": { x: 549.8394289932711, y: -5.684341886080802e-14, z: 848.5062543208978 }, "distance": 1200, "yaw": 70, "pitch": 27.85 },
      { "target": { x: 575.7808314498014, y: 5.684341886080802e-14, z: 1052.725335922683 }, "distance": 1200, "yaw": 60, "pitch": 27.85 },
      { "target": { x: 674.2607037741504, y: 5.684341886080802e-14, z: 1265.9765094166123 }, "distance": 1200, "yaw": 60, "pitch": 27.85 },
      { "target": { x: 799.4623526448142, y: 5.684341886080802e-14, z: 1529.6684156676592 }, "distance": 1200, "yaw": 60, "pitch": 27.85 },
      { "target": { x: 626.2441833666791, y: 5.684341886080802e-14, z: 1611.771058543527 }, "distance": 1200, "yaw": 60, "pitch": 27.85 },
      { "target": { x: 527.5450890701339, y: 5.684341886080802e-14, z: 1735.987088069288 }, "distance": 1200, "yaw": 60, "pitch": 27.85 },
      { "target": { x: 646.3379367280122, y: 5.684341886080802e-14, z: 1756.1030999283328 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 689.1946966594936, y: 5.684341886080802e-14, z: 1838.3865113620418 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 707.2840935426044, y: 5.684341886080802e-14, z: 1891.2750690689527 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 737.5618966273804, y: 5.684341886080802e-14, z: 1902.1552231097558 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 767.5618966273804, y: 5.684341886080802e-14, z: 2002.1552231097558 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 787.5618966273804, y: 5.684341886080802e-14, z: 2032.1552231097558 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },
      { "target": { x: 797.5618966273804, y: 5.684341886080802e-14, z: 2102.1552231097558 }, "distance": 1200, "yaw": 50, "pitch": 27.85 },

      { "target": { x: 787.5618966273804, y: 5.684341886080802e-14, z: 2232.1552231097558 }, "distance": 1200, "yaw": 40, "pitch": 27.85 },
      { "target": { x: 767.5618966273804, y: 5.684341886080802e-14, z: 2302.1552231097558 }, "distance": 1200, "yaw": 30, "pitch": 27.85 },
      { "target": { x: 757.5618966273804, y: 5.684341886080802e-14, z: 2432.1552231097558 }, "distance": 1200, "yaw": 30, "pitch": 27.85 },
      { "target": { x: 747.5618966273804, y: 5.684341886080802e-14, z: 2502.1552231097558 }, "distance": 1200, "yaw": 30, "pitch": 27.85 },
      { "target": { x: 700.5618966273804, y: 5.684341886080802e-14, z: 2802.1552231097558 }, "distance": 1200, "yaw": 30, "pitch": 27.85 },
      { "target": { x: 548.3555523827844, y: 5.684341886080802e-14, z: 2902.1552231097558 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 646.3379367280122, y: 5.684341886080802e-14, z: 1756.1030999283328 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },

      { "target": { x: 606.1271127448878, y: 5.684341886080802e-14, z: 1867.7120681631236 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 586.38908558606295, y: 5.1368683772161603e-13, z: 1998.2563135833714 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 506.38908558606295, y: 5.1368683772161603e-13, z: 1998.2563135833714 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 496.38908558606295, y: 5.1368683772161603e-13, z: 1998.2563135833714 }, "distance": 1200, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 686.38908558606295, y: 5.1368683772161603e-13, z: 1756.2563135833714 }, "distance": 1400, "yaw": 20, "pitch": 27.85 },
      { "target": { x: 696.38908558606295, y: 5.1368683772161603e-13, z: 1776.2563135833714 }, "distance": 1400, "yaw": 10, "pitch": 27.85 },
      { "target": { x: 696.38908558606295, y: 5.1368683772161603e-13, z: 1776.2563135833714 }, "distance": 1400, "yaw": -30, "pitch": 27.85 },
      { "target": { x: 666.38908558606295, y: 5.1368683772161603e-13, z: 1676.2563135833714 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },

      { "target": { x: 534.94383344961375, y: 5.684341886080802e-14, z: 1651.0775944300876 }, "distance": 1400, "yaw": -80, "pitch": 27.85 },
      { "target": { x: 524.94383344961375, y: 5.684341886080802e-14, z: 1631.0775944300876 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: 514.94383344961375, y: 5.684341886080802e-14, z: 1621.0775944300876 }, "distance": 1400, "yaw": -160, "pitch": 27.85 },
      { "target": { x: 410.25009575496415, y: 5.684341886080802e-14, z: 1610.1271671850084 }, "distance": 1400, "yaw": 240, "pitch": 27.85 },
      { "target": { x: 400.25009575496415, y: 5.684341886080802e-14, z: 1600.1271671850084 }, "distance": 1400, "yaw": 280, "pitch": 27.85 },
      { "target": { x: 363.7529096759779, y: 0, z: 1477.633200975717 }, "distance": 1400, "yaw": 320, "pitch": 27.85 },
      { "target": { x: 321.0419745859987, y: 2.2737367544323206e-13, z: 1397.6876574091932 }, "distance": 1400, "yaw": 360, "pitch": 27.85 },
      { "target": { x: 258.57815873165214, y: 0, z: 1315.261036880184 }, "distance": 1400, "yaw": -30, "pitch": 27.85 },
      { "target": { x: 360.45151170603935, y: -1.1368683772161603e-13, z: 1471.4036558354019 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },

      { "target": { x: 274.90284046198497, y: 1.1368683772161603e-13, z: 1372.2261235472279 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: 181.0250603647953, y: 1.1368683772161603e-13, z: 1317.2804166703656 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: 121.53308415432821, y: -1.1368683772161603e-13, z: 1263.3053341971236 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: 10.542087093167765, y: 0, z: 1196.5786641106938 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -130.71860103000574, y: -1.1368683772161603e-13, z: 1128.8231387191772 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -256.57339550665245, y: 1.1368683772161603e-13, z: 879.8377759462261 }, "distance": 1400, "yaw": -90, "pitch": 27.85 },
      { "target": { x: -270.02306153731047, y: 1.1368683772161603e-13, z: 699.8548366039554 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -66.84724253671152, y: 102.15145725386435, z: 497.3592572191228 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -155.63733665051325, y: -1.1368683772161603e-13, z: 1019.130378242511 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -109.28683479047498, y: 139.35928344726568, z: 476.6602309437431 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -45.03361165892295, y: 139.35928344726568, z: 414.581552803313 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },
      { "target": { x: -229.54672456240974, y: 1.1368683772161603e-13, z: 794.6241759699261 }, "distance": 1400, "yaw": -60, "pitch": 27.85 },

      { "target": { x: -258.14415726983157, y: 2.2737367544323206e-13, z: 936.0989117025416 }, "distance": 1400, "yaw": -90, "pitch": 27.85 },
      { "target": { x: -376.6626008362555, y: 2.2737367544323206e-13, z: 746.7028383821751 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: -155.72606961851216, y: 72.09913034359306, z: 622.0286713233795 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: -31.253310282748544, y: 61.89028134773025, z: 437.25937759275143 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: 71.46891182536069, y: 118.2001871531761, z: 381.4700805890993 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: 108.42854909230209, y: 52.8457167343513, z: 347.1967511414738 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: 79.19921649271748, y: 115.26851921359253, z: 177.44592293476921 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: 86.07344203467733, y: 51.072962936002, z: 40.38198778935342 }, "distance": 1400, "yaw": -120, "pitch": 27.85 },
      { "target": { x: -8.441619057684647, y: 2.5274493964388967e-7, z: -87.58334990961905 }, "distance": 1400, "yaw": -140, "pitch": 27.85 },
      { "target": { x: -29.23858872353526, y: 2.696507408472826e-7, z: -141.48766814620006 }, "distance": 1400, "yaw": -180, "pitch": 27.85 },
      { "target": { x: 174.03397054926324, y: 134.72529401170925, z: -200.88759093604108 }, "distance": 1400, "yaw": -180, "pitch": 27.85 },
      { "target": { x: 40.76406233675971, y: 5.542951839743182e-7, z: -241.30457334848285 }, "distance": 1400, "yaw": -180, "pitch": 27.85 },
      { "target": { x: 172.26935793382756, y: 51.906691764327434, z: -200.43533601618446 }, "distance": 1400, "yaw": -180, "pitch": 27.85 },

      { "target": { x: 128.57352209322676, y: 27.610279483818545, z: 253.89892012655793 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 104.97645388888668, y: 3.7445715861395e-7, z: 39.018034180224 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: -33.26916401045878, y: 2.4546159238525433e-7, z: -129.3173862674412 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 230.1763516458202, y: 115.10414501924072, z: -227.10024982178714 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 237.03059926863534, y: 65.91641878529401, z: -232.89707119395348 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 271.7398399790675, y: 80.76721115003772, z: -346.9182873135183 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 293.40422779039773, y: 119.92607456293615, z: -372.02021438240928 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 304.2885972163185, y: 121.35458308408329, z: -396.3531524276709 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 312.5649015847373, y: 32.71468163427687, z: -437.14000247212823 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 322.5649015847373, y: 32.71468163427687, z: -447.14000247212823 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 332.5649015847373, y: 32.71468163427687, z: -457.14000247212823 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 342.5649015847373, y: 32.71468163427687, z: -477.14000247212823 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 231.7398399790675, y: 80.76721115003772, z: -496.9182873135183 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
      { "target": { x: 251.19985575934254, y: 4.927329655401991e-7, z: -633.2028185260409 }, "distance": 1400, "yaw": -100, "pitch": 27.85 },
    ]

    let animate = (t) => {
      if (camviews.length >= this.viewIndex) {
        if (this.intervalTimer >= this.int_limit) {
          console.log("************* camera view interval", this.intervalTimer, camviews.length, this.viewIndex);
          let view = camviews[this.viewIndex];
          this.dfx.moveCamera(view);
          this.viewIndex++;
          this.intervalTimer = 0;
          this.animateAID = requestAnimationFrame(animate);
        } else {
          this.intervalTimer++;
          console.log("************* empty interval", this.intervalTimer, camviews.length, this.viewIndex);
          this.animateAID = requestAnimationFrame(animate);
        }
      } else {
        this.resetCameraView();
        console.log("************* stop interval", this.intervalTimer, camviews.length, this.viewIndex);
      }
    }

    if (camviews.length >= this.viewIndex) {
      if (this.viewIndex === 0) {
        let view = camviews[this.viewIndex];
        this.dfx.moveCamera(view);
        this.viewIndex++;
        this.intervalTimer = 0;
        setTimeout(() => {
          this.animateAID = requestAnimationFrame(animate);
        }, 500);
      } else {
        this.animateAID = requestAnimationFrame(animate);
      }
    }
  }
  /**
     *
     */
  scene
  initPathAnim() {
    let guide = this.ctrlServ.getMesh('port-anim-guide');
    let scene = this.scene = this.dfx.getCamera().getScene();
    scene.stopAllAnimations();
    let ag = scene.animationGroups;
    ag.forEach((g) => {
      g.targetedAnimations.forEach((a) => {
        a.target = guide;
      })
      g.reset();
      g.onAnimationEndObservable.add((e) => {
        if (this.cameraanim === 'play') {
          if (e.animation.targetProperty === 'position') {
            console.log("**** Cam Anim End ****")
            //this.resetCameraView()
            this.scene.animationGroups.forEach((anim) => {
              this.cameraanim = 'stop';
              anim.stop();
              anim.reset();
              anim.start(false, 0.25, 0, anim.to);
              this.cameraanim = 'play';
            })
          }
        }

      })
    })
    guide.isVisible = false;
    guide.parent.position.y = 25;
    guide.parent.position.x = -126.5;
    guide.parent.position.z = 131;
  }
  /* * *
  * stop camera view animation
  * * */
  resetCameraView() {
    /**
     * call if attachCameraToTarget is called
     */
    this.cameraanim = 'stop';
    this.dfx.detachCameraFromTarget();
    this.scene.animationGroups.forEach((anim) => {
      anim.stop();
      anim.reset();
    })
    //
    this.viewIndex = 0;
    this.intervalTimer = 0;
    cancelAnimationFrame(this.animateAID);
    setTimeout(() => {
      this.scene._activeCamera.nFrames = 60;
      this.changeCamView('home');
      this.broadcastInfo({ src: 'main', event: 'camera-view-stop', data: 'camera' });
    });
  }
  pausedAt = 0;
  pauseCameraAnim(boo) {
    if (boo) {
      this.pausedAt = this.scene.animationGroups[0].animatables[1].masterFrame;
      this.scene.animationGroups[0].stop();
    } else {
      this.scene.animationGroups[0].start(false, 0.25, this.pausedAt, this.scene.animationGroups[0].to);
      this.pausedAt = 0;
    }
  }
  sr1 = 0.3;
  sr2 = 0.25;
  sr3 = 0.9;
  animateCameraView() {
    let animStarted = false;
    this.scene._activeCamera.nFrames = 240;
    let guide = this.datauxview.getElementId('port-anim-guide');
    let guide_m = this.ctrlServ.getMesh('port-anim-guide');
    //this.scene._activeCamera.distance.value=1500;

    //this.scene._activeCamera.position.y=guide_m.absolutePosition.y;

    let animate = (t) => {
      if (this.scene._activeCamera.animations.length < 1 && !animStarted) {
        this.scene._activeCamera.position = guide_m.absolutePosition.clone();

        animStarted = true;
        this.dfx.attachCameraToTarget(guide, { radius: 0.00001, heightOffset: 0.0000001, rotationOffset: 180, cameraAcceleration: 0.1 });
        this.scene._activeCamera.heightOffset = 0;
        this.scene._activeCamera.rotationOffset = 0;
        this.scene._activeCamera.maxZ = 50000;
        //return;
        this.scene.animationGroups.forEach((anim) => {
          anim.start(false, 0.25, 0, anim.to)
          //anim.animatables.forEach(an=>{an.gotoFrame(0)})
        })
      }
      if (animStarted) {
        /*  let apos=guide_m.absolutePosition
         this.scene._activeCamera.targetX.value=apos.x;
         this.scene._activeCamera.targetY.value=apos.y;
         this.scene._activeCamera.targetZ.value=apos.z;
         this.scene._activeCamera.pitch_deg.value=5
         this.scene._activeCamera.yaw_deg.value=(guide_m.rotationQuaternion.toEulerAngles().y*180/Math.PI)+180; */
        let an = this.scene.animationGroups[0].animatables[1];
        let cf = (an ? an.masterFrame : 0) * 24;
        if (cf < 35) {
          this.scene.animationGroups[0].speedRatio = this.sr1
        } else
          if ((cf > 330 && cf < 440 || (cf > 630 && cf < 790))) {
            this.scene.animationGroups[0].speedRatio = this.sr3
          } else {
            //this.scene._activeCamera.rotationOffset=0
            this.scene.animationGroups[0].speedRatio = this.sr2
          }
      }
      // let rot=guide_m.rotationQuaternion.toEulerAngles();
      //this.scene._activeCamera.rotationOffset = 0;//((rot.y*180/Math.PI)+54)%360;
      this.animateAID = requestAnimationFrame(animate);
    }
    setTimeout(() => {

      this.scene.animationGroups.forEach((anim) => {
        //anim.start(false, 0.25,0,anim.to)
        //anim.stop();
      })
      this.animateAID = requestAnimationFrame(animate);
      //this.moveCameraTo(guide);
      //let yaw=180-((guide_m.rotationQuaternion.toEulerAngles().y*180/Math.PI)+68);
      this.moveCameraTo(null, { target: guide_m.absolutePosition, distance: 150, yaw: -68, pitch: 0 })
    }, 500)
  }
  /* * *
  * change camera position for shearwater and cfad jetties 2D/3D
  * * */
  onChangeExternalJettyCameraMode(control) {
    let home = this.cam_home[this.cfb_externalport];
    let targ = this.cam_home[this.cfb_externalport + "_2D"];
    this.datauxview.venue_orientation = 0.35;
    this.datauxview.yaw_2d = (this.cfb_externalport === 'shearwater' ? -133 : -184);
    this.datauxview.pitch_3d = 27.9;
    this.datauxview.yaw_3d = (this.cfb_externalport === 'shearwater' ? -133 : -184);

    if (control === '2D') {
      this.datauxview.CameraMode(control);
      this.dfx.moveCamera(targ);
    } else {
      this.datauxview.CameraMode(control);
      setTimeout(() => {
        this.dfx.moveCamera(home)
      }, 1200)
    }
  }

  /* * *
  * goto shearwater jetty
  * * */
  gotoExternalJetty(j = "cfad") {
    // this.showJettyLabels(false);
    this.cfb_externalport = j;
    this.tagServ.setExternalPortConfig(j);
    // let hidePorts = (j === 'cfad' ? ['cfb_halifax', 'shearwater'] : ['cfb_halifax', 'cfad']);
    this.hideAllShips();
    // this.tagServ.toggleStaticObj(false);
    // hidePorts.forEach(port => {
    //   this.ctrlServ.hideElement(port);
    // });
    // this.ctrlServ.showElement(j);
    let targ = this.cam_home[j];
    if (this.cameraMode === '2D') {
      this.onChangeExternalJettyCameraMode(this.cameraMode);
    } else {
      this.dfx.moveCamera(targ);
    }

    // this.maintainToggle();
    this.resetSelectedShip();
    // this.hideShoresideObjects(this.cfbport);
    this.broadcastInfo({ src: 'main', event: 'loadcurrentportdata', data: null, key: j });
    // this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });
  }

  /* * *
  * loadHomePort
  * * */
  loadHomePort(control) {
    this.cfb_externalport = '';
    this.tagServ.setExternalPortConfig(this.cfb_externalport);
    // let hidePorts = [];//['shearwater', 'cfad'];
    // this.showJettyLabels(true);
    this.hideAllShips();
    // this.tagServ.toggleStaticObj(true);
    // hidePorts.forEach(port => {
    //   this.ctrlServ.hideElement(port);
    // });
    // this.ctrlServ.showElement('cfb_halifax');
    this.changeCamView(control);
    // this.toggleCraneObjects(this.hideCraneState);
    // this.toggleLightObjects(this.hideLightState);
    // this.maintainToggle();
    this.resetSelectedShip();
    this.broadcastInfo({ src: 'main', event: 'loadcurrentportdata', data: null, key: 'cfbhalifax' });
    // this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });
  }

  /* * *
  * reset selected ship
  * * */
  resetSelectedShip() {
    this.broadcastInfo({ src: 'slider', event: 'hidetag', data: "", key: "" });
    // this.broadcastInfo({ src: 'sidepanel', event: 'selectedship', data: null, key: "" });
  }

  /* * *
  * method for get kiosk data from server
  * * */
  getKioskData(cbck) {
    this.kioskJson = {};
    this.configService.pullJsonData(this.projectConfig.getkioskData, { port: this.cfbport }).then((kioskJson) => {
      if (kioskJson['result'] != 'failed') {
        this.kioskJson = kioskJson;
        console.log("network", this.kioskJson);
        this.kioskAddData();
        // this.kioskJsonOrder();
        this.broadcastInfo({ src: 'main', event: 'kisokdata', data: this.kioskJson, key: "" });
        cbck(true)
      } else {
        this.openPublishDialog('kiosk data not found !!');
        cbck(false);
      }
    }).catch((error) => {
      console.log("error ", error);
      cbck(false);
    });
  }

  kioskAddData() {
    var obj = 0;
    this.kioskJson.formatKioskJson.jettyList.forEach((data1, d1Idx) => {
      data1.location1.forEach((data2, d2Idx) => {
        data2.kiosk.forEach((data3, d3Idx) => {
          this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx]['expand'] = false;
          data3.servicetype.forEach((data4, d4Idx) => {
            // console.log(data3.kiosk, data4.servicetype)

            if (data4.servicetype.trim() == "Power Services" || data4.servicetype.trim() == "Mechanical Services") {
              this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx]['servicetype'] = data4.servicetype.trim();

              var idx = 0;
              // if(d1Idx<50){
              //   this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx]['port']='cfbhalifax';
              // }else{
              //   this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx]['port']='cfbesquimalt';
              // }

              // if(obj<2){
              //   console.log(obj,data1.jetty)
              //   this.createShapeCube(data4,data1.jetty)
              // obj++;
              // }

              data4.service.forEach((element, eleIdx) => {

                if (idx > 2) {
                  if (eleIdx > 5) {
                    idx = idx * 2;
                  }
                  idx = idx - eleIdx;
                }
                this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx]['expand'] = false;
                this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx].service[eleIdx]['comment'] = '';
                this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx].service[eleIdx]['status'] = this.statusColorCode[idx].status;
                // console.log(data3.kiosk, data4.servicetype, element, this.statusColorCode[idx].status)
                idx++;
              });
              // console.log("kioskAddData",data4);
            }
          });
        });
      });
    });
    console.log("kioskAddData", this.kioskJson);
  }
  // kioskJsonOrder(){
  //   var objKey = Object.keys(this.kioskJson.kioskJson);
  //   var kioskArr=[];
  //   var kioskServiceData=[];
  //   objKey.forEach(element => {

  //     kioskArr =kioskArr.concat(this.kioskJson.kioskJson[element]);
  //     console.log(kioskArr.length,kioskArr,this.kioskJson.kioskJson[element],this.kioskJson.kioskJson[element].length)
  //   });
  //   console.log(kioskArr.length,kioskArr);
  //   var idx = 0;
  //   kioskArr.forEach(ele=>{
  //     if (ele.servicetype.trim() == "Power Services" || ele.servicetype.trim() == "Mechanical Services") {
  //       if (idx > 2) {
  //         if (eleIdx > 5) {
  //           idx = idx * 2;
  //         }
  //         idx = idx - eleIdx;
  //       }
  //       ['comment'] = '';
  //       kioskServiceData.push(ele)
  //       this.kioskJson.formatKioskJson.jettyList[d1Idx].location1[d2Idx].kiosk[d3Idx].servicetype[d4Idx].service[eleIdx]['status'] = this.statusColorCode[idx].status;
  //       // console.log(data3.kiosk, data4.servicetype, element, this.statusColorCode[idx].status)
  //       idx++;
  //     }
  //   })
  //   this.kioskJson.['kioskServiceData'] = kioskServiceData;
  // }
  kioskStatusColor(flag) {
    var obj = 0;
    this.kioskColorState = flag;
    this.kioskJson.formatKioskJson.jettyList.forEach((data1, d1Idx) => {
      data1.location1.forEach((data2, d2Idx) => {
        data2.kiosk.forEach((data3, d3Idx) => {
          data3.servicetype.forEach((data4, d4Idx) => {
            // console.log(data3.kiosk, data4.servicetype)
            if (data4.servicetype.trim() == "Power Services" || data4.servicetype.trim() == "Mechanical Services") {
              this.kioskMaterial(data4, flag)
            }
          });
        });
      });
    });
  }
  kioskMaterial(element, flag) {
    var id = element.uid;
    var el = this.datauxview.getElementId(id);
    var material;

    if (el) {
      if (flag) {
        var idx = element.service.findIndex(e => e.status == 'Not operational');
        if (idx > -1) {
          material = 'red';
        } else {
          idx = element.service.findIndex(e => e.status == 'Degraded');
          if (idx > -1) {
            material = 'orange';
          } else {
            idx = element.service.findIndex(e => e.status == 'Operational');
            if (idx > -1) {
              material = 'green';
            }
          }
        }
        this.dfx.modify(el, { profile: material });
      } else {
        this.dfx.modify(el, { profile: 'regular' });
      }
    }

  }
  createShapeCube(data, jetty) {
    this.activityServ.createShapeCube(data, this.cfbport);
    //   var profile=data.port==this.cfbport?'regular':'invisible';
    //   var modelConfig = data.servicetype=="Power Services"?'kiosk-model1':'kiosk-model';
    //   var pos
    //   if(data.servicetype=="Power Services"){
    //     pos={"x": 143.756,"y": 5, "z": -15.067 };
    //   }else{
    //     pos={"x": 303.549,"y": 5, "z": -161.26 };
    //   }
    //   var size=3;
    //   let cube = this.dfx.add({
    //         id: data.uid,
    //         model: 'cube',
    //         profile: profile,
    //         geometry: { position: { x: pos.x, y: pos.y, z: pos.z }, size }
    //       });
    //       console.log("created cube",jetty)
    //       this.attchCyliderObjEvent(cube);
  }

  /*******
 * Start Get Laydown Data
 */


  /*******
* End Get Laydown Data
*/

  /*******
   * Cude for kiosk
   */
  // kioskList:any=[{"id":"kiosk_1","position":{"x": 223.212,"y": 10,"z": 92.112}},{"id":"kiosk_2","position":{"x":0,"y":0,"z":0}}]
  /* * * *
  * create dynamic cube objects
  * * * */
  cubeModelList() {
    // console.log(this.getMesh('kiosk_2'));
    // this.kioskList.jettyList.forEach(data => {
    //   data.location1.forEach(data1 => {
    //     data1.id.forEach(key => {
    //       console.log(this.datauxview.getElementId(key.id));
    //       let el = this.datauxview.getElementId(key.id)
    //       this.attchCyliderObjEvent(el);
    //       if( this.cfbport!= 'cfbhalifax'){
    //         this.dfx.modify(el, { profile: "invisible" });
    //       }else{
    //         this.dfx.modify(el, { profile: "regular" });
    //       }
    //     });
    //   });

    // });
    // let activity = ship['activity'].split(" ").join("").toLowerCase();
    // let posArray = this.activityConfig[activity]['position'];
    // let shipid = ship.name;

    // Object.keys(posArray).forEach((key, idx) => {
    //   let pos = posArray[key];
    //   let size = 1;
    //   let id = 'envelope-' + key + '-' + shipid;
    //   let modelConfig = this.getDynamicCylinderConfig(id);
    //   let s = activity === 'man-aloft' ? 15 : 25;
    //   s = activity === 'radiating' ? 50 : s;
    //   let sh = activity === 'radiating' ? 50 : 5;
    //   let sy = activity === 'radiating' ? 0 : 25;
    //   sy = (ship.model === 'vcsub-model' ? 12 : sy);
    //   let profile = (this.activityState ? this.activityConfig[activity]['color'] : 'hidden');
    //   let cylinder = this.dfx.add({
    //     id: id,
    //     model: modelConfig,
    //     profile: profile,
    //     geometry: { position: { x: pos.x, y: sy, z: pos.z }, size }
    //   });

    //   this.dfx.setElementScale(cylinder, [s, sh, s]);
    //   this.allElements[id] = cylinder;
    //   let ship_el = this.datauxview.getElementId(shipid);
    //   this.dfx.setAsParent(ship_el, [cylinder]);
    //   let cylinder_m = this.datauxview.getElementMesh(cylinder);
    //   if(this.setRGID){
    //     cylinder_m.renderingGroupId=1;
    //   }
    // this.attchCyliderObjEvent(cylinder)
  }

  /* * * * *
  * attch event for Cylinder created ship objects
  * * * * * */
  // attchCyliderObjEvent(el) {
  //   this.datauxview.getDatascape().attach(el, {
  //     actions: {
  //       pickLeft: [(evt, elem) => {
  //         if (evt.button === 0) {
  //           let props = this.dfx.props(el);
  //           // let shipid = props.id.replace("envelope-default-","");
  //           this.broadcastInfo({ src: 'main', event: 'showKioskId', data: props.id, state: null, sub: null });
  //           this.tagServ.showKioskTag(props.id, true)
  //           console.log("pickLeft", props)
  //         }
  //       }]
  //     }
  //   });
  // }
  /* * *
  * maintain toggles
  * * */
  maintainToggle() {
    this.showHideBuildings(this.showBuildingState);
    //this.showHideGround(this.showGroundState);
    this.showHideKioskNames();
    //this.toggleOffOcean(this.toggleOceanState);
  }

  /* * *
  * on change port
  * * */
  onChangePort(port) {
    this.cfbport = port;
    this.currentJetty = this.cfbport;
  }

  /* * *
  * method for remove loader
  * * */
  removeLoader() {
    let ldiv = document.getElementById("babylonjsLoadingDiv");
    if (ldiv) {
      ldiv.remove();
    }
  }

  /* * *
  * method for define data to load server/uploaded data
  * * */
  onLoadData(event) {
    if (event) {
      let type = event.name;
      let metaData = event.metaData;
      this.planType = event.planType;
      if (this.planType.toLowerCase() === 'radhaz') {
        this.showUploadScreen = !true;
        this.showLoading = true;
        this.showRadHazDemo();
        return;
      }
      // if (type === 'port') {
      //   this.cfbport = metaData;
      // }

      this.currentJetty = this.cfbport;
      this.initObjects((boo) => {
        if (type === 'server') {
          this.getModelGeom();

          this.data_event = event;
          this.stopAllAnims()
          this.hideAllShips();

          this.showUploadScreen = !true;
          this.showLoading = true;
          this.loadPort((boo) => {
            this.initLabels();
            this.addShoresideObjects();
            this.showHideSSO();
            this.activityServ.setRGID = !true;
            //this.enableStencilBuffer();
            if (this.cfbport === 'cfbhalifax') {
              //this.activityServ.setRGID = false;
              this.showJettyLabels(true);
              //this.toggleOffOcean(this.toggleOceanState);
              this.prepareSynchroliftDemo();
            } else {

              this.getFirstAidData((foo) => {
                if (foo) {
                  this.setLocationPinArea();
                }
              })
              this.getHazardData((foo) => {
                if (foo) {
                  this.loadPinObjects();
                }
              })
              this.getKioskData((foo) => {
                if (foo) {
                  this.hideKiosk();
                }
              })
            }
            if (boo) {
              //this.hideBuildings();
            }
            this.updateFMFConeStatus()
            this.maintainToggle();
            this.toggleFMFMode(this.fmfmode);
            this.loadServerData();
            this.showLoading = !true;
            this.apploadingStatus = true;
            //this.collectionInfo();
            this.updateCraneObjects();
            this.removeLoader();
            this.initPathAnim();

          });
          console.log("metadata loading from: server");
        }

        if (type === 'upload') {
          this.getModelGeom();

          this.data_event = event;
          this.shipMetaData = [];
          this.shipMetaData = metaData;
          this.stopAllAnims()
          this.hideAllShips();
          this.showUploadScreen = !true;
          this.showLoading = true;
          this.uploadedJsonFile = event.uploadedJsonFile;
          this.loadPort((boo) => {
            this.initLabels();
            this.addShoresideObjects();
            this.showHideSSO();
            this.activityServ.setRGID = !true;
            //this.enableStencilBuffer();
            if (this.cfbport === 'cfbhalifax') {
              //this.activityServ.setRGID = false;
              //this.toggleOffOcean(this.toggleOceanState);
              this.prepareSynchroliftDemo();
            } else {

              this.getFirstAidData((foo) => {
                if (foo) {
                  this.setLocationPinArea();
                }
              })
              this.getHazardData((foo) => {
                if (foo) {
                  this.loadPinObjects();
                }
              })
              this.getKioskData((foo) => {
                if (foo) {
                  this.hideKiosk();
                }
              })
            }
            if (boo) {
              //this.hideBuildings();
            }
            this.updateFMFConeStatus()
            this.maintainToggle();
            this.toggleFMFMode(this.fmfmode);
            this.getShipConfig();
            this.showLoading = !true;
            this.apploadingStatus = true;
            this.updateCraneObjects();
          });
          console.log("metadata loading from: excel");
        }
      })
    }
    this.changeCamView('home');
  }

  /* * *
  * method for removed newly added ship
  * * */
  onRemoveShip() {
    console.log("onRemoveShip");
    if (this.selectedShipElem) {
      this.ctrlServ.hideShip(this.selectedShipElem);
      this.clearRadHaz();
      let idx = this.shipObjects.findIndex(el => el['chit_id'] === this.selectedShipElem['chit_id']);
      if (idx > -1) {
        this.shipObjects.splice(idx, 1);
      }
      let index = this.currentShipList.findIndex(el => el['chit_id'] === this.selectedShipElem['chit_id']);
      if (index > -1) {
        this.currentShipList.splice(index, 1);
      }
      this.updateSidePanelData();
      this.chitService.deleteActivity({ chitId: this.selectedShipElem['chit_id'], port: this.cfbport }).subscribe(response => {
        if (response['result'] === 'success') {
          console.log("ship removed !!");
          this.chitService.deleteChit(this.selectedShipElem['chit_id'])
            .subscribe((res) => {
              console.log("Chit Id Delete Status", res)
            }, error => {
              console.error('There was an error!');
            })

        }
      })
    }
  }

  /* * *
  * get meta data from the server
  * * */
  loadServerData() {
    this.shipMetaData = [];
    this.configService.pullJsonData(this.projectConfig.jsonReadApi, { port: this.cfbport, filename: 'shipObjects' }).then((shipMetaData) => {
      if (shipMetaData['result'] != 'failed') {
        this.shipMetaData = shipMetaData;
        console.log("uploadedJsonFile", shipMetaData);
        if (this.shipMetaData['ships'].length > 0) {
          this.uploadedJsonFile = this.shipMetaData['filets'];
          this.getShipConfig();
        } else {
          this.openPublishDialog('metadata not found !!');
        }
      } else {
        this.openPublishDialog('metadata not found !!');
      }
    }).catch((error) => {
      console.log(error);
    });
    console.log("shipmatta Data", this.shipMetaData)
  }

  getShipLocations() {
    this.shipLocations = [];
    this.locationArry['position'].forEach(pos => {
      if (!pos['defaultPosition']) {
        let location = pos['location'].replace("_", "/");
        let obj = { key: pos['location'], value: location }
        this.shipLocations.push(obj)
      }
    });
    console.log("ship location", this.shipLocations)
  }

  /* * * * *
  * method for get shipconfig and ship locations
  * * * * * */
  getShipConfig() {
    this.locationArry = [];
    this.shipConfig = [];
    this.reportServ.setConfigLastUploadedFile(this.uploadedJsonFile);
    this.configService.pullJsonData(this.projectConfig.jsonReadApi, { port: this.cfbport, filename: 'shipConfig' }).then((shipConfig) => {
      if (shipConfig['result'] != 'failed') {
        this.shipConfig = shipConfig;
        this.configService.pullJsonData(this.projectConfig.jsonReadApi, { port: this.cfbport, filename: 'shipPosition' }).then((Locations) => {
          if (Locations['result'] != 'failed') {
            this.locationArry = Locations;
            this.getShipLocations();
            console.log("loadServerData :", this.shipMetaData, this.shipConfig, this.locationArry);
            this.broadcastInfo({ src: 'main', event: 'chitFormDetails', data: this.shipConfig, key: this.locationArry });
            console.log("VesselName", this.shipConfig)
            if (this.shipConfig) {
              if (this.locationArry['position'].length > 0) {
                this.mapShipData();
              } else {
                this.openPublishDialog('ship location not found !!');
              }
            } else {
              this.openPublishDialog('ship config not found !!');
            }
          } else {
            this.openPublishDialog('ship location not found !!');
          }
        }).catch((error) => {
          console.log(error);
        });;
      } else {
        this.openPublishDialog('ship config not found !!');
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  /* * * * *
  * method for mapping the metadata to ship location and ship model and class
  * * * * * */
  mapShipData() {
    this.shipObjects = [];
    this.jettyMissingShipObjects = [];
    let unkownLocation = this.locationArry['unkownLocation'] ? this.locationArry['unkownLocation'] : [];
    this.shipMetaData['ships'].forEach(obj => {
      let location = (obj.location ? obj.location.split(" ").join("").replace("/", "_") : "");
      this.locationArry['position'].forEach(loc => {
        if (location === loc.location) {
          if (this.shipConfig[obj.ship]) {
            let popupConfig = this.ctrlServ.getPopupConfig();
            let objConfig = this.ctrlServ.getObjectConfig();
            obj['activity'] = obj.activity.toLowerCase();
            objConfig['name'] = uuid.v4(); // obj.ship;
            objConfig['model'] = this.shipConfig[obj.ship]['model'];
            objConfig['class'] = this.shipConfig[obj.ship]['class'];
            objConfig['shipname'] = this.shipConfig[obj.ship]['name'];
            popupConfig['number'] = this.shipConfig[obj.ship]['number'] ? this.shipConfig[obj.ship]['number'] : '';
            objConfig['place']['pos']['x'] = Number(loc.position[0].toFixed(5));
            objConfig['place']['pos']['y'] = (objConfig['model'] === 'vcsub-model' ? 7 : Number(loc.position[1].toFixed(5)));
            objConfig['place']['pos']['z'] = Number(loc.position[2].toFixed(5));
            objConfig['place']['rot']['y'] = Number(loc.direction.toFixed(5));
            objConfig['ship_status'] = (loc['defaultPosition'] ? 'hide' : 'show');

            const LocationFound = unkownLocation.some(el => el === location);
            if (!LocationFound) {
              objConfig['location_status'] = 'known';
            } else {
              objConfig['location_status'] = 'unknown';
            }
            var ship = Object.assign({}, objConfig, obj, popupConfig);
            this.shipObjects.push(ship);
          } else {
            console.log("invalid ship config ", obj);
          }
        }
      });
      const found = this.locationArry['position'].some(el => el.location === location);
      if (!found) {
        if (obj['location']) {
          this.jettyMissingShipObjects.push(obj);
        }
      } else {
        if ((obj['location'] === 'NA') || (obj['location'] === 'NN')) {
          this.jettyMissingShipObjects.push(obj);
        }
      }
    });
    console.log("jettyMissingShipList ", this.jettyMissingShipObjects);
    this.reportServ.setMissingJettyShipList(this.jettyMissingShipObjects);
    this.updateShipMetadata();
  }

  /* * * * *
  * method for update ship meta data from slider
  * * * * * */
  updateShipMetadata(search = null) {
    this.reportServ.setShipObjects(this.shipObjects);
    let obj = { "shipObjects": this.shipObjects, "jettyMissingShipObjects": this.jettyMissingShipObjects };
    let shipAdded = this.newAddedShipObj ? true : false;
    this.broadcastInfo({ src: 'main', event: 'updateshipmetadata', data: obj, key: shipAdded });
  }

  /* * * * *
  * update the object position based on position json
  * * * * * */
  onUpdateObjectPosition(data) {
    // var currentDate = new Date();
    var currentDate = data['date'];
    this.changeCamView('home');
    // if (this.navyFilterState == 'commanding') {
    //   this.broadcastInfo({ src: 'main', event: 'navyfilterDate', data: currentDate, key: undefined });
    // }
    this.showNonBlockLoading = true;
    this.objIndex = 0;
    this.percentageValue = 0;
    this.shipOccLocation = [];
    this.isReport = data['isReport'];
    this.jettyMissingShipList = data['jettyMissingShipList'];
    this.currentShipList = data['currentShipData'];
    this.currentShipData = data['currentShipData'];
    this.historyShipList = data['currentShipData'];
    this.shipObj = data['shipObj'];
    console.log("currentShipList ", this.currentShipList, this.jettyMissingShipList);
    delete this.navyFilterShip;
    this.ctrlServ.isDayShipsLoaded = false;
    this.updateSidePanelData();
    setTimeout(() => {
      this.startObjectProcess()
      this.attchEventLaydown();
    }, 100);
    var currentDateFormate = this.datePipe.transform(currentDate, 'dd-MMM-yy');

    let selectedLocation = this.currentShipList.filter(
      m => new Date(m.startdate) >= new Date(currentDateFormate) && new Date(m.enddate) <= new Date(currentDateFormate)
    );

    // if (selectedLocation?.length > 0) {
    //   setTimeout(() => {
    //     this.ctrlServ.focusElement(selectedLocation[0]);
    //     setTimeout(() => {
    //       this.broadcastInfo({ src: 'main', event: 'activeShipDate', data: selectedLocation[0], key: '0' });
    //     }, 1500);
    //   }, 1000);

    // } else {
    //   if (this.currentShipList.length == 1 && this.navyFilterState) {
    //     setTimeout(() => {
    //       this.ctrlServ.focusElement(this.currentShipList[0]);
    //     }, 1500);
    //   }
    // }

    // if (this.currentShipList.length == 1 && this.navyFilterState) {
    //   setTimeout(() => {
    //     this.ctrlServ.focusElement(this.currentShipList[0]);
    //   }, 1500);
    // }

    // this.broadcastInfo({ src: 'main', event: 'shipDataList', data: this.currentShipList });

    // this.broadcastInfo({ src: 'main', event: 'navyfilterState', key: undefined });
    // delete this.navyFilterState;
  }

  /* * * * *
  * method for update side panel data
  * * * * * */
  updateSidePanelData() {
    let data = { "currentShipList": this.currentShipList, "shipData": this.shipMetaData['ships'] }
    this.broadcastInfo({ src: 'main', event: 'updateshipdata', data: data });
  }

  /* * * * * *
  * percenrage calculator for progress bar
  * * * * * */
  percentageCalculator() {
    let percent = 100 / (this.shipObj.length / this.numberOfObjectLoad);
    this.percentageValue = this.percentageValue + percent;
    this.percentageValue = Number(this.percentageValue.toFixed(4));
  }

  /**
   * method for newly added ship object
   */
  checkNewShipCollision() {
    if (this.newAddedShipObj) {
      let chitId = this.newAddedShipObj['chit_id'];
      let ship = this.shipObjects.find(el => el.chit_id === chitId);
      if (ship) {
        this.selectedShipElem = ship;
        setTimeout(() => {
          this.checkForRadHaz(true);
        }, 1000);
        delete this.newAddedShipObj;
      }
    }
  }

  profiles: any = {
    "regular": { material: 'transparentZ', transition: 0, 'selectable': false },
    "transparent": { material: 'transparentZ' },
    "red": { material: 'red' },
    "pink": { material: 'see_me_pink' },
    "amber": { material: 'amber' },
    "green": { material: 'green' },
    "hidden": { material: 'hidden_obj', visible: false, 'selectable': false }
  }
  /***
   * Temporary invisible cylinder pickable
   */
  // tempActCylinderPick(){
  //   // console.log(this.activityServ.radhaz_cylinders)
  //   // console.log(this.activityServ.ant_radhaz_cylinders)
  //   // console.log(this.activityServ.ant_rot_cylinders)
  //   var _radhaz = Object.keys(this.activityServ.radhaz_cylinders);
  //   var _ant_radhaz = Object.keys(this.activityServ.ant_radhaz_cylinders);
  //   var _ant_rot = Object.keys(this.activityServ.ant_rot_cylinders);
  //   if(_radhaz.length>0){
  //     _radhaz.forEach((el)=>{
  //       var _radhazChild = Object.keys(this.activityServ.radhaz_cylinders[el]);
  //       if(_radhazChild.length>0){
  //         _radhazChild.forEach(child=>{
  //           let elemItem = this.activityServ.radhaz_cylinders[el][child];
  //           let props = this.datauxview.getDatascape().props(elemItem);
  //           // console.log('_radhaz',props,props.profile.visible);
  //           if(props&&props.profile&&!props.profile.visible){
  //             let cm = this.dfx.getElementMesh(elemItem);
  //             cm.isPickable = false;
  //             // let props = this.datauxview.getDatascape().props(elemItem);
  //             console.log('_radhaz-aft',props);
  //           }
  //         });       
  //       }
  //     })
  //   }

  //   if(_ant_radhaz.length>0){
  //     _ant_radhaz.forEach((el)=>{
  //       var _ant_radhazChild = Object.keys(this.activityServ.radhaz_cylinders[el]);
  //       if(_ant_radhazChild.length>0){
  //         _ant_radhazChild.forEach(child=>{
  //           let elemItem = this.activityServ.radhaz_cylinders[el][child];
  //           let props = this.datauxview.getDatascape().props(elemItem);
  //           console.log('_ant_radhaz',props,props.profile.visible);
  //           if(props&&props.profile&&!props.profile.visible){
  //             let cm = this.dfx.getElementMesh(elemItem);
  //             cm.isPickable = false;
  //             // this.dfx.modify(elemItem, { profile:{ material: 'hidden_obj', visible: false,'selectable': false } });
  //           }
  //         });       
  //       }
  //     })
  //   }

  //   if(_ant_rot.length>0){
  //     _ant_rot.forEach((el)=>{
  //       var _ant_rotChild = Object.keys(this.activityServ.radhaz_cylinders[el]);
  //       if(_ant_rotChild.length>0){
  //         _ant_rotChild.forEach(child=>{
  //           let elemItem = this.activityServ.radhaz_cylinders[el][child];
  //           let props = this.datauxview.getDatascape().props(elemItem);
  //           console.log('_ant_rot',props,props.profile.visible);
  //           if(props&&props.profile&&!props.profile.visible){
  //             let cm = this.dfx.getElementMesh(elemItem);
  //             cm.isPickable = false;
  //             // this.dfx.modify(elemItem, { profile:{ material: 'hidden_obj', visible: false,'selectable': false } });
  //           }
  //         });       
  //       }
  //     })
  //   }

  // }

  /* * * * * *
  * start creating Object instance
  * * * * * */
  startObjectProcess() {
    this.percentageCalculator();
    if (this.shipObj.length > this.objIndex) {
      let obj = this.shipObj.slice(this.objIndex, this.objIndex + this.numberOfObjectLoad);
      this.createObjects(obj);
    } else {
      let obj = this.shipObj.slice(this.objIndex, this.shipObj.length);
      if (obj.length > 0) {
        this.createObjects(obj);
      } else {
        // this.getActivityChangedShips();
        this.ctrlServ.isDayShipsLoaded = true;
        this.showNonBlockLoading = false;
        this.getUserData();
        // this.tempActCylinderPick();
        // this._khaConfig.enableVesselDrag(this.shipObj);
        this.checkNewShipCollision();
        // sidepanel list selected if the start day is different from selected/current day
        if (this.isReport) {
          if (!this.jettyLabelState) {
            this.showJettyLabels(!this.jettyLabelState);
            this.jettyLabelState = false;
          } else {
            this.showJettyLabels(this.jettyLabelState);
          }

          if (this.unknownLocationState) {
            this.showUnknownLocationFlag(false);
          }
          if (this.locationErrorState) {
            this.assignProperShipLocation();
          }
          this.resetSelectedShip();
          this.showAllActivity(false);
          this.reportServ.showDayReportView();
          this.isReport = !this.isReport;
        } else {
          // this.showJettyLabels(false);
          if (this.tagServ.cfb_externalport) {
            this.broadcastInfo({ src: 'main', event: 'loadcurrentportdata', data: null, key: this.tagServ.cfb_externalport });
          } else {
            this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });
          }
          this.sendLoadedMsgToHost();
          // if unknown location state is on
          if (this.unknownLocationState) {
            this.onUnknownLocationToggle(this.unknownLocationState);
          }
          // if location error state is on
          if (this.locationErrorState) {
            this.assignProperShipLocation(true);
          } else {
            this.assignProperShipLocation();
          }
        }
      }
    }

  }

  /* * * * *
  * create dynamic objects based on json data
  * * * * * */
  shipOccLocation: any = [];
  createObjects(obj) {
    this.datauxview.addElements(obj, (objects) => {
      this.tagServ.attachFlag(objects);
      objects.forEach(_obj => {
        let ship = (_obj.name);
        let mesh = this.getMesh(ship);
        mesh.rotationQuaternion = null;
        this.tagServ.attchDynamicEvent(_obj.name);
        let shipel = this.datauxview.getElementId(ship);
        let size = [1, 1, 1]
        this.tagServ.attachLabel(ship, shipel, this.getCurrentShipData(ship), this.getElemRadius(shipel), size);
        // code for dry dock
        let location = _obj.location.split(" ").join("");
        if (location === 'FMFDryDock') {
          if (_obj.model === 'vcsub-model') {
            // this.applyStencilRender(_obj.name);
          }
        }
        // code for not allow same location to place the ship
        const found = this.shipOccLocation.some(el => el === _obj.location);
        if (!found) {
          this.activityServ.setShipActivity(_obj);
          this.shipOccLocation.push(_obj.location);
          this.ctrlServ.hideShip(_obj);
        } else {
          this.activityServ.setShipActivity(_obj);
          this.ctrlServ.hideShip(_obj);
        }
        if (_obj.model === 'Halifax') {
          this.radhazVisServ.addRadHazActivity(_obj);
        } else {
          this.radhazVisServ.addCollisionShips(_obj);
        }
      });

      this.objIndex = this.objIndex + this.numberOfObjectLoad;
      setTimeout(() => {
        this.startObjectProcess()
      }, 100);
    }, (id, pointer) => this.attchObjectEvents(id, pointer));
  }

  /* * * * *
  * method for Dry DOck
  * * * * * */
  applyStencilRender(el) {
    let engine = this.game_engine;
    let m2: any = this.getMesh(el);
    let mesh2: any = m2.getChildMeshes().find((e) => e.name.includes('Victoria_primitive10'));
    if (mesh2) {
      mesh2.onBeforeRenderObservable.add(() => {
        engine.setStencilOperationPass(7681);
        engine.setStencilMask(0xFF);
        engine.setStencilFunction(519);
        engine.setStencilFunctionReference(1);
      });
      mesh2.onAfterRenderObservable.add(() => {
        engine.setStencilFunctionReference(0);
      });
    }
    let mesh3: any = m2.getChildMeshes().find((e) => e.name.includes('Victoria_primitive9'));
    if (mesh3) {
      mesh3.onBeforeRenderObservable.add(() => {
        engine.setStencilOperationPass(7681);
        engine.setStencilMask(0xFF);
        engine.setStencilFunction(519);
        engine.setStencilFunctionReference(1);
      });
      mesh3.onAfterRenderObservable.add(() => {
        engine.setStencilFunctionReference(0);
      });
    }
  }

  /* * * * *
  * method config current day ships
  * * * * * */
  currentDayShipList: any = [];
  updateCurrentDayShip(dayShipList) {
    this.currentDayShipList = dayShipList;
  }

  /* * * * *
  * method searched ships only to show
  * * * * * */
  fiterShownShips = [];
  onShowFilteredShips(filterdData) {
    let transObj = [];
    this.fiterShownShips = [];
    if (filterdData !== null) {
      if (filterdData.length > 0) {
        transObj = this.currentDayShipList.filter(function (ship) {
          return filterdData.every(function (data) {
            return data.name !== ship.name;
          });
        })
      } else {
        transObj = this.currentDayShipList;
      }
      this.showObjects(filterdData);
      this.transparentObjects(transObj);
    } else {
      this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });
    }
  }

  /* * * * *
  * filter ship object show
  * * * * * */
  showObjects(obj) {
    obj.forEach(ship => {
      let startDateTime = this.reportServ.currentViewDate;
      let shipStartDateTime = new Date(ship.startdate + ", 00:00:00");
      let shipEndDateTime = new Date(ship.enddate + ", 23:59:00");
      if ((startDateTime >= shipStartDateTime) && (startDateTime <= shipEndDateTime)) {
        const found = this.fiterShownShips.some(el => el.location === ship.location);
        if (!found) {
          this.fiterShownShips.push(ship);
          this.ctrlServ.showShip(ship);
        } else {
          // if initially loaded without activity ship in location check if same location have acitivty
          if (ship['activity']) {
            let index = this.fiterShownShips.findIndex(el => el.location === ship.location);
            if (index > -1) {
              if (this.fiterShownShips[index]['activity']) {
                this.ctrlServ.hideShip(ship);
                // this.ctrlServ.showShip(ship);
                this.ctrlServ.showShip(this.fiterShownShips[index]);
              } else {
                this.ctrlServ.hideShip(this.fiterShownShips[index]);
                this.ctrlServ.showShip(ship);
              }
            }
          } else {
            this.ctrlServ.hideShip(ship);
          }
        }
      } else {
        this.ctrlServ.hideShip(ship);
      }
    });
  }

  /* * * * *
  * filter ship object show other objects transparent
  * * * * * */
  transparentObjects(obj) {
    obj.forEach(ship => {
      let startDateTime = this.reportServ.currentViewDate;
      let shipStartDateTime = new Date(ship.startdate + ", 00:00:00");
      let shipEndDateTime = new Date(ship.enddate + ", 23:59:00");
      if ((startDateTime >= shipStartDateTime) && (startDateTime <= shipEndDateTime)) {
        const found = this.fiterShownShips.some(el => el.location === ship.location);
        if (!found) {
          this.fiterShownShips.push(ship);
          if (this.hideUnselectedState) {
            this.ctrlServ.transparentShip(ship);
            // this.ctrlServ.showShip(ship);
          } else {
            this.ctrlServ.showShip(ship);
          }
        } else {
          this.ctrlServ.hideShip(ship);
        }
      } else {
        this.ctrlServ.hideShip(ship);
      }
    });
  }

  /* * * * *
  * selected ship object only highlighted other trnsparent
  * * * * * */
  onSelectedShip(ship) {
    this.unknownLocationShipList = [];
    this.clearShipSelection = true;
    this.selectedShipElem = ship;
    let location = [];
    if (ship) {
      this.currentShipList.forEach(elem => {
        if (ship['ship_status'] === 'show') {
          if (elem.name === ship.name) {
            this.tagServ.unselectTagElement();
            this.ctrlServ.focusElement(ship);
            // this.tagServ.setTagProperties(ship.name, true);
            // this.broadcastInfo({ src: 'main', event: 'detailPanel', data: '', key: true });

            if (this.rawDataStatus) {
              this.rawData = ship;
            }
          } else {
            // const found = location.some(el => el === elem.location);
            // if (!found) {
            //   location.push(elem.location);
            //   this.ctrlServ.transparentShip(elem);
            // } else {
            //   this.ctrlServ.hideShip(elem);
            // }
            // this.broadcastInfo({ src: 'main', event: 'detailPanel', data: '', key: true });
            this.tagServ.setTagProperties(elem.name, false);

          }
        }
      })
    } else {
      this.tagServ.unselectTagElement();
      this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });
      // this.showAllShips();
    }
  }

  // onSelectedLaydown(laydown){
  //   this.selectedLaydownElem = laydown;
  //   console.log("elemenet id ", this.selectedLaydownElem)
  //   if (laydown) {
  //     this.tagServ.setTagProperties(laydown._id, true);
  //   }
  // }

  /* * * * *
  * method for detail tag close
  * * * * * */
  tagCurrentClose(obj) {
    let ship = obj['ship'];
    let type = obj['type'];
    delete this.selectedShipElem;
    if (type === 'staticobj_popup') {
      this.tagServ.unselectStaticObjTagElement();
    }
    else if (ship['ship_status'] === 'hide') {
      this.clearShipSelection = false;
      this.unknownLocationShipList = [];
    } else {
      let location = [];
      this.clearShipSelection = false;
      this.tagServ.unselectTagElement();
      this.broadcastInfo({ src: 'main', event: 'update_time_view', data: '', key: "" });

      // this.currentShipList.forEach(elem => {
      //   const found = location.some(el => el === elem.location);
      //   if (!found) {
      //     location.push(elem.location);
      //     this.ctrlServ.showShip(elem);
      //   } else {
      //     this.ctrlServ.hideShip(elem);
      //   }
      // });
    }
  }

  /* * * * *
  * method for show unknown location ship popup
  * * * * * */
  OnshowUnknownLocPopup(ship) {
    this.unknownLocationShipList = [];
    if (ship) {
      this.clearShipSelection = true;
      this.unknownLocationShipList.push(ship);
    }
  }

  /* * * * *
  * method for hide current showing ships
  * * * * * */
  hideAllShips() {
    this.currentShipList.forEach(ship => {
      if (ship['ship_status'] === 'show') {
        this.ctrlServ.hideShip(ship);
      }
    });
  }

  /* * * * *
  * method for show current showing ships
  * * * * * */
  showAllShips(e) {
    let location = [];
    this.currentShipList.forEach(ship => {
      if (ship['ship_status'] === 'show') {
        const found = location.some(el => el === ship.location);
        if (!found) {
          location.push(ship.location);
          this.ctrlServ.showShip(ship);
        } else {
          this.ctrlServ.hideShip(ship);
        }
      }
    });
  }

  /* * * * *
  * method for to show tag for all showing current ships
  * * * * * */
  // RAJ-COMMENT: recommend to move tags html and logic to a separate component
  onShowAllTag(e) {
    this.tagServ.configMutiTagProperties(e.state);
    this.currentShipList.forEach(element => {
      if (element['ship_status'] === 'show') {
        this.tagServ.setMultiTagProperties(e.state, element.name);
      }
    });
  }

  /* * * *
  * Zoom event to zoom in / out the venue
  * * * */
  isMouseDown = false;
  Zoom(key) {
    this.isMouseDown = true;
    this.datauxview.startZoom(key);
  }

  stopZoom() {
    this.isMouseDown = !true;
    this.datauxview.stopZoom();
  }

  @HostListener('document:mouseup', ['$event'])
  handleMouseUpEvent(event: MouseEvent) {
    // this.tagEnableClick=true;
    if (this.isMouseDown) {
      this.stopZoom();
    }
    // if ((<HTMLInputElement>event.target).id == "renderCanvas") {
    //   this.showRawDataYard();
    // }
  }
  onMouseDownN(d = 1) {
    this.doubleClick += 1;
  }

  onMouseUpN() {
    setTimeout(() => {
      this.doubleClick = 0;
    }, 200);
  }

  @HostListener('document:pointerdown', ['$event'])
  handleMouseDownEvent(event: MouseEvent) {
    // if ((<HTMLInputElement>event.target).id == "renderCanvas") {
    //   this.showRawDataYard();
    // }
    // this._khaConfig.restrictGizmoScale();
    this.mousestate = "down";
    if (event.target['nodeName'] === 'CANVAS') {
      this.onMouseDownN();
      let drawaction = this.drawService.draw_select_mode || this.drawService.cut_mode
      if (drawaction && (event.which === 1 || event.button === 0)) {
        let dr = this.drawService.doDraw()
        this.drawing = dr;
      }
      // for color picker tool outside close
      let dom: any = document.getElementsByClassName("btn btn-custom-ok")[0];
      if (dom) {
        dom.click();
      }
    }
  }

  @HostListener('click', ['$event']) onMousedown(event) {
    this.isMouseDown = false;
    this.isDragmove = false;
  }
  // @HostListener('mousemove', ['$event']) onMousemove(event) {
  //   // this.isMouseDown = false;
  //   // this.isDragmove = false;
  //   if(this.isMouseDown){
  //     console.log(event,this.pickdownElem);
  //   }

  // }
  isShiftDown: boolean = false;
  @HostListener('document:keyup', ['$event'])
  handleKeyboardUPEvent(event: KeyboardEvent) {
    this.isShiftDown = false;
    if (event.key) {
      const key = event.key.toString().toLowerCase();
      if (event.shiftKey && key === 't') {
        this.controlPanelState = !this.controlPanelState;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 1008) {
      // window.lockOrientation('landscape')
      //       console.log( window.screen.orientation)
      // // console.log( window.screen.orientation.lock('landscape'))
      // window.screen.orientation
      //     .lock("landscape")
      //     .then(
      //         success => console.log(success),
      //         failure => console.log(failure)
      //     )
      // console.log( window.screen.orientation)
    }
    // if (event.target.innerWidth < 680) {
    //   this.mobileView=true;
    // }else{
    //   this.mobileView=false;
    // }
  }

  layoutState: any = false;
  layoutPanel() {
    this.layoutState = true;
    this.broadcastInfo({ src: 'navyApp', event: 'reconstruct', data: '' });
  }
  /* * * * *
  * Camera Position event to move the camera to different view / angle
  * * * * * */
  onChangeCameraPosition(camView) {
    console.log("camView ", camView);
    this.datauxview.Camera(camView);
  }

  /* * * * *
  * Control Tool
  * * * * * */
  controlToolEvent(control) {
    if (control.name === 'home') {
      if (this.cameraMode == '2D') {
        if (this.cfb_externalport == '') {
          this.onChangeCameraMode(this.cameraMode);
          this.changeCamView(this.cameraMode);
        } else {
          if (this.cfbport === 'cfbhalifax') {
            this.currentJetty = 'cfbhalifax';
            this.cfb_externalport = '';
            this.tagServ.setExternalPortConfig(this.cfb_externalport);
            this.onChangeCameraMode(this.cameraMode);
            this.changeCamView(this.cameraMode);
          }
          // this.onChangeExternalJettyCameraMode(this.cameraMode);
        }
      } else {
        if (this.cfb_externalport == '') {
          this.changeCamView(control.name);
        } else {
          if (this.cfbport === 'cfbhalifax') {
            this.currentJetty = 'cfbhalifax';
            this.cfb_externalport = '';
            this.tagServ.setExternalPortConfig(this.cfb_externalport);
            this.changeCamView(control.name);
            // this.gotoExternalJetty(this.cfb_externalport);
          }
        }
      }
    } else if (control.name === 'left') {
      this.changeCamView(control.name);
    } else if (control.name === 'right') {
      this.changeCamView(control.name);
    } else if (control.name === 'back') {
      this.changeCamView(control.name);
    } else if (control.name === 'top') {
      this.changeCamView(control.name);
    } else if (control.name === 'front') {
      this.changeCamView(control.name);
    } else if (control.name === 'BC') {
      this.changeCamView(control.name);
    } else if (control.name === 'DF') {
      this.changeCamView(control.name);
    } else if (control.name === 'GH') {
      this.changeCamView(control.name);
    } else if (control.name === 'J') {
      this.changeCamView(control.name);
    } else if (control.name === 'Y') {
      this.changeCamView(control.name);
    } else if (control.name === 'ML') {
      this.changeCamView(control.name);
    } else if (control.name === 'C') {
      this.changeCamView(control.name);
    } else if (control.name === 'AB') {
      this.changeCamView(control.name);
    } else if (control.name === 'FMF') {
      this.changeCamView(control.name);
    } else if (control.name === 'roof') {
      this.changeCamView(control.name);
    } else if (control.icon === 'dimension') {
      control.name = control.state ? '2D' : '3D';
      this.cameraMode = control.name;
      if (this.cfb_externalport == '') {
        if (control.name === '2D') {
          this.onChangeCameraMode(control.name);
          this.changeCamView(control.name);
          // this.moveCameraTo(null, this.camviews[this.cfbport]['2D']);
        } else {
          this.onChangeCameraMode(control.name);
          setTimeout(() => {
            this.changeCamView('home');
          }, 1300)
        }
      } else {
        this.onChangeExternalJettyCameraMode(control.name);
      }
    } else if (control.name === 'label') {
      this.onShowAllTag(control);
    } else if (control.name === 'pdf') {
      this.reportGenerate(control, 'pdf');
    } else if (control.name === 'setting') {
      this.controlPanelState = true;
    } else if (control.name === 'preview') {
      this.reportGenerate(control, 'preview');
    } else if (control.name === 'building') {
      // this.currentJetty = control.jetty;
      //this.showHideBuildings(control.state);
      let state = control.state ? 'exterior' : 'w_interiors';
      this.toggleFMFState = control.state;
      this.toggleFMFMode(state)
    } else if (control.name === 'ground') {
      this.showHideGround(control.state);
    } else if (control.name === 'water') {
      this.toggleOffOcean(control.state);
    } else if (control.name === 'stateBoard') {
      console.log("stateBoard", control);
      if (control.state) {
        this.userRole = this.configService['loginInfo']['role'];
      } else {
        delete this.userRole;
      }
      this.broadcastInfo({ src: 'sidepanel', event: 'stateBoardClose', data: control.state, key: this.userRole });
    } else if (control.name === 'dashboard') {
      this.broadcastInfo({ src: 'navyApp', event: 'dashboard', data: true });
    } else if (control.name === 'cameraAnimation') {
      let action = control.state ? 'play' : 'stop';
      this.broadcastInfo({ src: 'animcontrol', event: action, data: { type: 'cameraanim' }, key: "" });
    } else if (control.name === 'drag') {
      if (control.state) {
        // this._khaConfig.vesselDragState = true;
        // this.broadcastInfo({ src: 'navyApp', event: 'cameraMode', data: { type: '2D' }, key: "" });
        this._khaConfig.enableVesselDrag(this.shipObj);
      } else {
        // this._khaConfig.vesselDragState = false;
        this._khaConfig.removeDragAll();
        let dfx = this.datauxview.getDatascape();
        dfx.enableTransormHandlers({ scale: false, position: false, rotation: false })
        // this.broadcastInfo({ src: 'navyApp', event: 'cameraMode', data: { type: '3d' }, key: "" });
        // delete this._khaConfig.commentData;
        // delete this.tagServ.commentData;
        // delete this.tagServ.commentId;
      }
      // this.broadcastInfo({ src: 'main', event: 'commentTag', data: control.state, key: "" });
    }
    else if (control.name === 'comments') {
      if (control.state) {
        this._khaConfig.vesselDragState = true;
        // this.broadcastInfo({ src: 'navyApp', event: 'cameraMode', data: { type: '2D' }, key: "" });
        // this._khaConfig.enableVesselDrag(this.shipObj);
      } else {
        this._khaConfig.vesselDragState = false;
        // this._khaConfig.removeDragAll();
        // let dfx = this.datauxview.getDatascape();
        // dfx.enableTransormHandlers({ scale: false, position: false, rotation: false })
        // this.broadcastInfo({ src: 'navyApp', event: 'cameraMode', data: { type: '3d' }, key: "" });
        delete this._khaConfig.commentData;
        delete this.tagServ.commentData;
        delete this.tagServ.commentId;
         this._khaConfig.urls=[]
      }
      this.broadcastInfo({ src: 'main', event: 'commentTag', data: control.state, key: "" });
    }
  }
  /**
  * set camera position for shearwater and cfad jetties
  */
  cam_home = {
    "cfad": { target: { x: 4662, y: -80, z: 201 }, distance: 1000, yaw: 130, pitch: 35 },
    "shearwater": { target: { x: -7840, y: -100, z: 512 }, distance: 1000, yaw: 180, pitch: 35 },
    "cfad_2D": { target: { x: 4562, y: 0, z: 281 }, distance: 1000, yaw: 140 },
    "shearwater_2D": { target: { x: -7810, y: 0, z: 652 }, distance: 1000, yaw: 180, }
  }
  camviews = {
    "cfbhalifax": {
      "top": { "target": { "x": 236.347, "y": -17.878, "z": -166.979 }, "distance": 3700, "yaw": 43.306, "pitch": 89.9 },
      "left": { "target": { "x": 336.347, "y": -17.878, "z": -166.979 }, "distance": 3000, "yaw": -10, "pitch": 27.85 },
      "right": { "target": { "x": 140.347, "y": -17.878, "z": 46.979 }, "distance": 3000, "yaw": 90, "pitch": 27.85 },
      "back": { "target": { "x": 236.347, "y": -17.878, "z": -166.979 }, "distance": 3700, "yaw": (43.306 + 180), "pitch": 27.85 },
      "front": { "target": { "x": 236.347, "y": -17.878, "z": -166.979 }, "distance": 3700, "yaw": 43.306, "pitch": 27.85 },
      "pdf": { "target": { "x": -2000.7315, "y": -17.878, "z": 1358 }, "distance": 2800, "yaw": 4, "pitch": 89.9 },
      "currentTarget": { "target": { "x": 0, "y": 0, "z": 0 }, "distance": 3700, "yaw": 43.306, "pitch": 27.85 },
      "home": { "target": { "x": -2051.7315, "y": -17.878, "z": 1258.9549 }, "distance": 2600, "yaw": 4, "pitch": 27.85 },
      "2D": { "target": { "x": -2000.7315, "y": -17, "z": 1358.9549 }, "distance": 2800, "yaw": 4 },
      "BC": { "target": { "x": -2551, "y": -17.878, "z": 1328 }, "distance": 800, "yaw": 20, "pitch": 18.85 },
      "DF": { "target": { "x": -2190, "y": -17.878, "z": 1339 }, "distance": 1100, "yaw": 20, "pitch": 35.85 },
      "GH": { "target": { "x": -1814, "y": -25.878, "z": 1333 }, "distance": 800, "yaw": 2, "pitch": 35.85 },
      "J": { "target": { "x": -1358, "y": -25.878, "z": 1429 }, "distance": 1600, "yaw": -87, "pitch": 34.85 },
      "FMF": { "target": { "x": -2119, "y": -17.878, "z": 1382 }, "distance": 1200, "yaw": 92, "pitch": 89.9 },

      "BC_2D": { "target": { "x": -183.710, "y": -17.878, "z": 474.007 }, "distance": 1400, "yaw": 63.306, "pitch": 12.85 },
      "DF_2D": { "target": { "x": 177.379, "y": -17.878, "z": 86.084 }, "distance": 1400, "yaw": 63.306, "pitch": 12.85 },
      "GH_2D": { "target": { "x": 513.247, "y": -25.878, "z": -237.126 }, "distance": 1400, "yaw": 43.306, "pitch": 12.85 },
      "J_2D": { "target": { "x": 1001.347, "y": -25.878, "z": -646.979 }, "distance": 1800, "yaw": -45, "pitch": 34.85 },
    },
    "cfad": {
      "top": { target: { x: 4582, y: 0, z: 281 }, distance: 1000, yaw: 140, "pitch": 89 },
      "left": { "target": { x: 4582, y: 0, z: 271 }, "distance": 1000, "yaw": -105, "pitch": 27.85 },
      "right": { "target": { "x": 4576, "y": 0, "z": 280 }, "distance": 1000, "yaw": 77, "pitch": 27.85 },
      "back": { "target": { "x": 4606, "y": 157.878, "z": 40 }, "distance": 1000, "yaw": -4, "pitch": 27.85 },
      "front": { "target": { x: 4662, y: -80, z: 201 }, distance: 1000, yaw: 130, pitch: 35 },
      "home": { "target": { x: 4662, y: -80, z: 201 }, distance: 1000, yaw: 130, pitch: 35 },
      "2D": { "target": { x: 4662, y: -80, z: 181 }, "distance": 1000, "yaw": 140, "pitch": 27.85 },
    },
    "shearwater": {
      "top": { target: { x: -7810, y: 0, z: 652 }, distance: 1000, yaw: 180, "pitch": 89 },
      "left": { "target": { "x": -7830, "y": -17.878, "z": 632 }, "distance": 1000, "yaw": -90, "pitch": 27.85 },
      "right": { "target": { "x": -8140, "y": 157.878, "z": 652 }, "distance": 1000, "yaw": 90, "pitch": 27.85 },
      "back": { "target": { "x": -7820, "y": 157.878, "z": 402 }, "distance": 1000, "yaw": 0, "pitch": 27.85 },
      "front": { target: { x: -7840, y: -100, z: 512 }, distance: 1000, yaw: 180, pitch: 35 },
      "home": { target: { x: -7840, y: -100, z: 512 }, distance: 1000, yaw: 180, pitch: 35 },
      "2D": { target: { x: 130, y: 0, z: 10 }, distance: 2000, yaw: -133 },
    },
    // "cfbesquimalt": {
    //   "top": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": 43.306, "pitch": 89.9 },
    //   "left": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": (43.306 - 90), "pitch": 27.85 },
    //   "right": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": (43.306 + 90), "pitch": 27.85 },
    //   "back": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": (43.306 + 180), "pitch": 27.85 },
    //   "front": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": 43.306, "pitch": 27.85 },
    //   "pdf": { "target": { "x": 346.347, "y": -17.878, "z": -100.979 }, "distance": 4000, "yaw": 225.306, "pitch": 89.9 },
    //   "currentTarget": { "target": { "x": 0, "y": 0, "z": 0 }, "distance": 4000, "yaw": 43.306, "pitch": 27.85 },
    //   "home": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": 43.306, "pitch": 27.85 },
    // },
    "cfbesquimalt": {
      "top": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4800, "yaw": 43.306, "pitch": 89.9 },
      "left": { "target": { "x": -280.347, "y": -17.878, "z": -230.979 }, "distance": 4000, "yaw": (43.306 - 90), "pitch": 27.85 },
      "right": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": (43.306 + 90), "pitch": 27.85 },
      "back": { "target": { "x": -100.347, "y": -17.878, "z": -210.979 }, "distance": 4000, "yaw": (43.306 + 180), "pitch": 27.85 },
      "front": { "target": { "x": -500.347, "y": -17.878, "z": -116.979 }, "distance": 4000, "yaw": 43.306, "pitch": 27.85 },
      "pdf": { "target": { "x": -70, "y": 0.878, "z": -40 }, "distance": 2500, "yaw": -105, "pitch": 89.9 },
      "currentTarget": { "target": { "x": 0, "y": 0, "z": 0 }, "distance": 4000, "yaw": 43.306, "pitch": 27.85 },
      "home": { "target": { "x": -160, "y": -17.878, "z": -140 }, "distance": 2500, "yaw": -68, "pitch": 27.85 },
      "2D": { "target": { "x": -120, "y": -17.878, "z": -60 }, "distance": 3000, "yaw": -100 },

      "AB": { "target": { "x": -140, "y": -17.878, "z": 380 }, "distance": 1000, "yaw": 70, "pitch": 27.85 },
      "C": { "target": { "x": -30, "y": -17.878, "z": 80 }, "distance": 600, "yaw": -90, "pitch": 17.85 },
      "ML": { "target": { "x": -300, "y": -28.878, "z": -80 }, "distance": 800, "yaw": -60, "pitch": 18.85 },

      "Y": { "target": { "x": 160, "y": -17.878, "z": -350 }, "distance": 600, "yaw": -160, "pitch": 27.85 },

      "FMF": { "target": { "x": -300, "y": -17.878, "z": 20 }, "distance": 1600, "yaw": -180, "pitch": 89.9 },

      "AB_2D": { "target": { "x": 349.644, "y": -17.878, "z": -498.812 }, "distance": 1600, "yaw": 188, "pitch": 27.85 },
      "C_2D": { "target": { "x": -174.784, "y": -17.878, "z": -422.078 }, "distance": 1400, "yaw": 23.306, "pitch": 17.85 },
      "ML_2D": { "target": { "x": -401.183, "y": -26.878, "z": -99.151 }, "distance": 1200, "yaw": 53.306, "pitch": 18.85 },
      "Y_2D": { "target": { "x": -848.007, "y": -20.878, "z": -561.163 }, "distance": 1600, "yaw": -49.306, "pitch": 17.85 },
    },
  }

  changeCamView(v, vobj = false) {
    let view = vobj ? v : this.camviews[this.currentJetty][v];
    if (this.cameraMode == '2D') {
      if (v == 'Y' || v == 'ML' || v == 'C' || v == 'AB' || v == 'BC' || v == 'DF' || v == 'GH' || v == 'J') {
        view = vobj ? v + '_' + this.cameraMode : this.camviews[this.currentJetty][v + '_' + this.cameraMode];
      }
    }
    this.moveCameraTo(null, view)
  }

  moveCameraTo(el, view = null) {
    let dfx = this.datauxview.getDatascape();
    let camera = dfx.getCamera();
    let _view = view;
    if (!view) {
      let dr = this.getElemRadius(el);
      let target = this.getElemCenter(el);
      let ds = dr / Math.tan(camera.fov / 2);
      ds = Math.max(20, ds);
      _view = { distance: ds, target }
    }
    dfx.moveCamera(_view);
  }
  getElemCenter(el) {
    let dfx = this.datauxview.getDatascape();
    let id = dfx.props(el).id;
    let target;
    let mesh = dfx.getElementMesh(el);
    // if(this.extras.includes(id)){
    // target=this.getAverageCenter(mesh);
    // }else{
    let c = mesh.getBoundingInfo().boundingSphere.centerWorld;
    target = { x: c.x, y: c.y, z: c.z }
    // }
    return target;
  }

  getElemRadius(el) {
    let dfx = this.datauxview.getDatascape();
    let id = dfx.props(el).id;
    let mesh = dfx.getElementMesh(el);
    let c = id ? this.getMaxRadius(mesh) : mesh.getBoundingInfo().boundingSphere.radiusWorld;
    return c;
  }

  getMaxRadius(m) {
    let meshes = m.getChildMeshes();
    let l = meshes.length;
    let c = Number.MIN_VALUE
    meshes.forEach((mesh) => {
      if (mesh.isEnabled() && mesh.isVisible && mesh.material.alpha) {
        let pt = mesh.getBoundingInfo().boundingSphere.radiusWorld;
        c = Math.max(c, pt)
      }
    });
    return c;
  }

  /* * * * *
  * method for to get current target view
  * * * * * */
  getCurrentTarget() {
    let dfx = this.datauxview.getDatascape();
    let cameraProps = dfx.getCamera();
    this.camviews[this.cfbport]['currentTarget']['target']['x'] = Number(cameraProps['targetX']['value'].toFixed(4));
    this.camviews[this.cfbport]['currentTarget']['target']['y'] = Number(cameraProps['targetY']['value'].toFixed(4));
    this.camviews[this.cfbport]['currentTarget']['target']['z'] = Number(cameraProps['targetZ']['value'].toFixed(4));
    this.camviews[this.cfbport]['currentTarget']['distance'] = Number(cameraProps['distance']['value'].toFixed(4));
    this.camviews[this.cfbport]['currentTarget']['yaw'] = Number(cameraProps['yaw_deg']['value'].toFixed(4));
    this.camviews[this.cfbport]['currentTarget']['pitch'] = Number(cameraProps['pitch_deg']['value'].toFixed(4));
  }

  /* * * * *
  * generate pdf
  * * * * * */
  reportGenerate(e, key) {
    if (key == 'pdf') {
      this.showPDFMode = !this.showPDFMode;
      this.getCurrentTarget();
      this.moveCameraTo(null, this.camviews[this.cfbport]['pdf']);
      this.broadcastInfo({ src: 'main', event: 'showtable', key: '' });
      setTimeout(() => {
        this.showBlockLoading = true;
        this.reportServ.generatePDF('1');
      }, 200);
    } else if (key == 'preview') {
      this.showPDFPreView(key);
    }
  }

  /* * * * *
  * change cameta mode
  * * * * * */
  onChangeCameraMode(camView) {
    if (this.cfb_externalport == '') {
      this.datauxview.venue_orientation = 0.35;
      this.datauxview.yaw_2d = (this.cfbport === 'cfbesquimalt' ? -100 : 45);
      this.datauxview.yaw_3d = (this.cfbport === 'cfbesquimalt' ? -100 : 43.4);
      this.datauxview.pitch_3d = 27.9;

    } else {
      if (camView == 'home' || camView == '2D') {
        let home = this.cam_home[this.cfb_externalport];
        let targ = this.cam_home[this.cfb_externalport + "_2D"];
        this.datauxview.venue_orientation = 0.35;
        this.datauxview.yaw_2d = (this.cfb_externalport === 'shearwater' ? 180 : 180);
        this.datauxview.pitch_3d = 27.9;
        this.datauxview.yaw_3d = (this.cfb_externalport === 'shearwater' ? 180 : 180);

        if (camView === '2D') {
          this.datauxview.CameraMode(camView);
          this.dfx.moveCamera(targ);
        } else {
          this.datauxview.CameraMode(camView);
          setTimeout(() => {
            this.dfx.moveCamera(home)
          }, 1200)
        }
      }
    }
    this.datauxview.CameraMode(camView);
  }

  selectedElement = {
    "id": "none",
    "geometry": {
      "position": { "x": 0, "y": 0, "z": 0 },
      "size": 0,
      "orientation": { "x": 0, "y": 0, "z": 0 },
    }
  };

  /* * * *
  * Get the handle to the element selected from list
  * * * */
  onGetElementProperties(key) {
    var elem = this.datauxview.getObjectProperties(key);
    this.selectedElement = elem;
    console.log("this.selectedElement :", this.selectedElement);
  }

  /* * * * *
  * Change the position / coordinates on the selected object
  * * * * * */
  onChangeObjectPosition(objProp) {
    const obj = {
      "name": this.selectedElement.id,
      "place": {
        "pos": objProp.position,
        "rot": { "x": null, "y": null, "z": null }
      }
    };
    this.datauxview.modifyElement(obj);
  }

  /* * * * *
  * Change the size on the selected object
  * * * * * */
  onChangeObjectSize(objProp) {
    const obj = {
      "name": this.selectedElement.id,
      "place": {
        "pos": { "x": null, "y": null, "z": null },
        "rot": { "x": null, "y": null, "z": null },
        "size": objProp.size
      }
    };
    this.datauxview.modifyElement(obj);
  }

  /* * * * *
  * change object Orientation
  * * * * * */
  onChangeObjectOrientation(objProp) {
    const obj = {
      "name": this.selectedElement.id,
      "place": {
        "pos": { "x": null, "y": null, "z": null },
        "rot": { "x": null, "y": objProp.orientation, "z": null },
        "size": null
      }
    };
    this.datauxview.modifyElement(obj);
  }

  /* * * * *
  * trigger Event
  * * * * * */
  ontrigger(keycode) {
    this.datauxview.triggerKey(keycode);
  }

  /* * * * *
  * Animate Event
  * * * * * */
  animate(id, pointer) {
    if (pointer == 'pickLeft') {
    }
  }

  /* * * * *
  * attchObjectEvents
  * * * * * */
  allElements = [];
  attchObjectEvents(id, pointer) {
    console.log(this.isDragmove);
    setTimeout(() => {
      if (!this.isDragmove) {
        if (pointer == 'pickLeft') {
          console.log('showClickShip', id)
          this.broadcastInfo({ src: 'main', event: 'showclickedship', key: id, state: null, sub: null });
        }
      }
    }, 500);
  }

  showDetailTagStaticShip() {
    this.cfbstatic_ships.forEach(ship => {
      let el = this.datauxview.getElementId(ship.name);
      if (el) {
        this.attchStaticObjEvent(el);
      }

    });
  }

  /* * * * *
  * attch event for static created kiosk objects
  * * * * * */
  attchKioskObjEvent(el) {
    this.datauxview.getDatascape().attach(el, {
      actions: {
        pickLeft: [(evt, elem) => {
          if (evt.button === 0) {
            let props = this.dfx.props(el);
            console.log(" kiosk ", props.id)
            this.broadcastInfo({ src: 'main', event: 'showKioskId', data: props.id, state: null, sub: null });
            this.tagServ.showKioskTag(props.id, true)
          }
        }],
        hoverOn: [(evt, elem) => {
          let props = this.dfx.props(el);
          console.log(" kiosk ", props.id)
          this.broadcastInfo({ src: 'main', event: 'onHoverKioskId', data: props.id, state: null, sub: null });
          this.tagServ.onHoverHideShow(props.id, true)

        }],
        hoverOff: [(evt, elem) => {
          let props = this.dfx.props(el);
          console.log(" kiosk ", props.id)
          this.broadcastInfo({ src: 'main', event: 'offHoverKioskId', data: props.id, state: null, sub: null });
          this.tagServ.onHoverHideShow(props.id, false)
        }]
      }
    });
  }

  dragPrePosition: any;
  dragPrePositionFirstAid: any;
  /* * * * *
  * attch event for static created ship objects
  * * * * * */
  attchStaticObjEvent(el) {
    this.datauxview.getDatascape().attach(el, {
      actions: {
        pickLeft: [(evt, elem) => {
          if (evt.button === 0) {
            let props = this.dfx.props(el);
            if (props.id.includes('hfx_crane')) {
              this.tagServ.unselectStaticObjTagElement();
              this.ctrlServ.focusStaticElement(props.id);
              this.tagServ.showStaticObjTag(props.id, true);
            }
            if (props.id.includes('bld')) {
              // console.log("bld ", props)
            }
            if (props.id.includes('ship_')) {
              this.tagServ.unselectStaticObjTagElement();
              this.ctrlServ.focusStaticElement(props.id);
              this.tagServ.showStaticObjTag(props.id, true);
            }
          }
        }],
        pickDown: [(evt, elem) => {
          if (evt.button === 0) {
            let props = this.dfx.props(el);
            if (props.id.includes('pin')) {
              console.log("pickDown pin ", props);
              this.selectedConeId = props.id;
              this.moveConePin(props.id);
              this.dragPrePosition = props.geometry.position;
              this.pickdownElem = evt;
              this.isMousedown = true;
            }
            if (props.id.includes("locator_")) {
              console.log("pickDown pin ", props);
              this.selectedLocationId = props.id
              this.moveLocationPin(props.id);
              this.dragPrePositionFirstAid = props.geometry.position;
              this.pickdownElem = evt;
            }
          }
        }],
        pickUp: [(evt, elem) => {
          if (evt.button === 0) {
            if (this.pickdownElem) {
              let props = this.dfx.props(el);
              if (this.pickdownElem.cilentX != evt.clientX && this.pickdownElem.clientY != evt.clientY) {
                if (props.id.includes('pin')) {
                  console.log("pickUp pin ", props.geometry.position);
                  if (this.dragPrePosition) {
                    // this.positionConfirmHazard(props);
                  }
                }
              } else {
                if (props.id.includes('pin')) {
                  let cone = this.coneList.find(cone => props.id === cone._id);
                  if (cone) {
                    this.selectedConeElem = cone;
                    this.tagServ.showHazardTag(cone['_id'], false);
                    this.ctrlServ.focusStaticElement(cone['_id']);
                    this.tagServ.showHazardTag(cone['_id'], true);
                    this.broadcastInfo({ src: 'main', event: 'showconepopup', data: this.selectedConeElem });
                  }
                }
                if (props.id.includes("locator_")) {
                  let pin = this.fistAidJson.find(pin => props.id === pin._id);
                  if (pin) {
                    this.selectedLocationObj = pin;
                    this.broadcastInfo({ src: 'main', event: 'first_Aid_data', data: this.selectedLocationObj, key: "" });
                    this.tagServ.locationPointerTag(pin['_id'], false);
                    this.ctrlServ.focusStaticElement(pin['_id']);
                    this.tagServ.locationPointerTag(pin['_id'], true);
                  }
                }
              }
            }
          }
        }],
        pickDouble: [(evt, elem) => {
          if (evt.button === 0) {
          }
        }]
      }
    });
  }
  positionChangeHazard(e) {
    let prop = this.datauxview.getElementId(e.data._id);
    if (prop) {
      if (!e.key) {
        this.dfx.modify(prop, { geometry: { position: this.dragPrePosition } });
        delete this.dragPrePosition;
      } else {
        let cone = this.coneList.find(el => el._id == e.data._id);
        if (cone) {
          this.updateHazard(e.data._id, cone);
        }
      }
    }
  }
  positionConfirmHazard(id) {
    let idx = this.coneList.findIndex(e => e._id == id)
    if (idx > -1) {
      this.broadcastInfo({ src: 'main', event: 'hazardPosition', data: this.coneList[idx] });
    }
  }
  positionChangeFirstAid(e) {
    let prop = this.datauxview.getElementId(e.data._id);
    if (prop) {
      if (!e.key) {
        this.dfx.modify(prop, { geometry: { position: this.dragPrePositionFirstAid } });
        delete this.dragPrePositionFirstAid;
      } else {
        let obj = this.fistAidJson.find(el => el._id == e.data._id);
        if (obj) {
          this.updateFirstAidArea(e.data._id, obj);
        }
      }
    }
  }
  positionConfirmFirstAid(id) {
    let idx = this.fistAidJson.findIndex(e => e._id == id)
    if (idx > -1) {
      this.broadcastInfo({ src: 'main', event: 'hazardPositionFirstAid', data: this.fistAidJson[idx] });
    }
  }
  /* * * *
   * method for selected manu based to show port
   * * * * */
  onSelectedMenu(e) {
    var selElem = e.key;
    for (let element of this.allElements) {
      var showObj = (element == selElem ? 'regular' : 'invisible');
      var _obj = { "profile": showObj };
      let prop = this.datauxview.getElementId(element);
      this.dfx.modify(prop, _obj);
    }
  }

  tblToggleState(e) {
    if (e) {
      this.pdfStatus = e;
      this.canvasHeight = (window.innerHeight - 350) + 'px';
    } else {
      this.canvasHeight = (window.innerHeight) + 'px';
      this.pdfStatus = e;
      this.showBlockLoading = this.pdfStatus;
      if (this.showPDFMode) {
        this.showPDFMode = !this.showPDFMode;
        this.moveCameraTo(null, this.camviews[this.cfbport]['currentTarget']);
      }
    }
    // this.datauxview.triggerWindowResize();
  }

  rawDataState(e) {
    console.log("rawDataState", this.rawDataStatus);
    this.rawDataStatus = e;
    if (this.selectedShipElem != '' && this.rawDataStatus == true) {
      this.onSelectedShip(this.selectedShipElem);
    }
  }

  settingPanelState(e) {
    this.controlPanelState = e;
  }

  /**
   * method for activity show/hide
   */
  showAllActivity(show) {
    this.activityServ.setActivityState(show);
    this.currentShipList.forEach(ship => {
      if (ship['ship_status'] === 'show') {
        this.activityServ.showAllActivity(ship);
      }
    });
  }

  /**
   * method for toggle activity show/hide
   */
  toggleActivity(e) {
    let show = e.show;
    let activity = e.activity;
    this.currentShipList.forEach(ship => {
      let shipid = ship['name'];
      if (ship['activity'].split(" ").join("").toLowerCase() === activity) {
        if (show) {
          if (this.tagServ.selTagElement) {
            if (this.tagServ.selTagElement === shipid) {
              this.activityServ.showActivity(ship);
            } else {
              this.activityServ.transparentActivity(ship);
            }
          } else {
            this.activityServ.showActivity(ship);
          }
        } else {
          this.activityServ.hideActivity(ship);
        }
      }
    });
  }

  /* * * *
  * method for if previous location has ship/not
  * * * */
  checkPrevLocation(location) {
    let flag = false;
    for (let ship of this.currentShipList) {
      if (ship['ship_status'] === 'show') {
        let shipLocation = (ship.location ? ship.location.replace(" ", "").replace("/", "_") : "");
        let targetLocation = (location ? location.replace(" ", "").replace("/", "_") : "");
        if (shipLocation === targetLocation) {
          let shipid = ship.name;
          let show = this.ctrlServ.isObjVisible(shipid);
          if (show) {
            flag = show;
            break;
          }
        }
      }
    }
    return flag;
  }

  /* * * *
   * method change the ship location
   * * * */
  moveShipLocation(idx, targetLocation) {
    let Location = (targetLocation ? targetLocation.replace(" ", "").replace("/", "_") : "");
    let posIndex = this.locationArry['position'].findIndex(jetty => jetty.location === Location);
    if (posIndex > -1) {
      let model = this.currentShipList[idx]['model'];
      let shipid = this.currentShipList[idx]['name']
      let loc = this.locationArry['position'][posIndex];
      let geometry = {
        "place": {
          "pos": {
            "x": Number(loc.position[0].toFixed(5)),
            "y": (model === 'vcsub-model' ? 7 : Number(loc.position[1].toFixed(5))),
            "z": Number(loc.position[2].toFixed(5)),
          },
          "rot": {
            "x": 0,
            "y": Number(loc.direction.toFixed(5)),
            "z": 0
          }
        }
      };
      const obj = Object.assign({ name: shipid }, { place: geometry['place'] });
      this.datauxview.modifyElement(obj);
    }
  }

  /* * * *
   *method for if location has ship/not
   * * * */
  checkLocationHasShip(location, parentShipId, showFlag) {
    let chckFirstLocation = false;
    let chckSecondLocation = false;
    if (location.length > 1) {
      if (location[1] === '3') {

        chckFirstLocation = this.checkPrevLocation(location[0]);
        chckSecondLocation = this.checkPrevLocation(location[0] + ',2');
        if (chckFirstLocation === false && chckSecondLocation === false) {
          if (showFlag) {
            this.tagServ.showFlag(parentShipId);
          } else {
            this.tagServ.hideFlag(parentShipId, true);
          }
          let idx = this.currentShipList.findIndex(el => el.name === parentShipId);
          if (idx > -1) {
            this.currentShipList[idx]['location_changed'] = true;
            this.moveShipLocation(idx, location[0]);
          }
        }
        else if (chckFirstLocation === true && chckSecondLocation === false) {
          if (showFlag) {
            this.tagServ.showFlag(parentShipId);
          } else {
            this.tagServ.hideFlag(parentShipId, true);
          }
          let idx = this.currentShipList.findIndex(el => el.name === parentShipId);
          if (idx > -1) {
            this.currentShipList[idx]['location_changed'] = true;
            this.moveShipLocation(idx, location[0] + ',2');
          }
        }
      } else {
        chckFirstLocation = this.checkPrevLocation(location[0]);
        if (!chckFirstLocation) {
          if (showFlag) {
            this.tagServ.showFlag(parentShipId);
          } else {
            this.tagServ.hideFlag(parentShipId, true);
          }
          let idx = this.currentShipList.findIndex(el => el.name === parentShipId);
          if (idx > -1) {
            this.currentShipList[idx]['location_changed'] = true;
            this.moveShipLocation(idx, location[0]);
          }
        }
      }
    }
  }

  /* * * *
   * assign correct ship location if assigned invalid position
   * * */
  assignProperShipLocation(showFlag = false) {
    this.currentShipList.forEach(ship => {
      if (ship['ship_status'] === 'show') {
        let shipid = ship.name;
        let location = ship.location.split(',');
        delete ship['location_changed'];
        if (location.length > 1) {
          this.checkLocationHasShip(location, shipid, showFlag);
        }
      }
    });
    if (showFlag) {
      this.onLocationErrorToggle(showFlag);
    }
  }

  /* * * *
   * make ship actual position
   * * */
  moveDefaultShipLocation(ship, idx, flag = true) {
    let shipid = ship.name;
    let location = ship.location;
    if (flag) {
      this.tagServ.showFlag(shipid);
    }
    this.moveShipLocation(idx, location);
  }
  /* * *
   * location error flag show/Hide
   * * */
  hazardShowToggle(state) {
    console.log(this.coneList, state);
    if (this.coneList.length > 0) {
      this.coneList.forEach(element => {
        let el = this.pinObjects[element._id];
        if (el) {
          if (state) {
            this.dfx.modify(el, { profile: element.color });
          } else {
            this.dfx.modify(el, { profile: 'hidden' });
          }

        }
      });
    }
  }
  /* * *
   * location error flag show/Hide
   * * */
  onLocationErrorToggle(flag) {
    this.locationErrorState = flag;
    this.currentShipList.forEach((ship, idx) => {
      if (ship['ship_status'] === 'show') {
        let shipid = ship.name;
        let location = ship.location.split(',');
        if (flag) {
          if (ship['location_changed']) {
            if (location.length > 1) {
              this.moveDefaultShipLocation(ship, idx);
            }
          }
        } else {
          if (location.length > 1) {
            this.checkLocationHasShip(location, shipid, false);
            // this.tagServ.hideFlag(shipid, true);
          }
        }
      }
    });

    // location error is off load if unknown loaction is on loaded
    if (!this.locationErrorState) {
      if (this.unknownLocationState) {
        this.showUnknownLocationFlag(this.unknownLocationState);
      }
    }
  }

  /* *
  * method for if already changed position means rest the position then check
  * * */
  showShipDefaultPosition() {
    this.currentShipList.forEach((ship, idx) => {
      if (ship['ship_status'] === 'show') {
        let location = ship.location.split(',');
        if (ship['location_changed']) {
          if (location.length > 1) {
            this.moveDefaultShipLocation(ship, idx, false);
          }
        }
      }
    });
  }

  /* *
   * maintain ship error toggles while change day
   * * */
  maintainShipErrorToggle(e) {
    this.showUnknownLocationFlag(this.unknownLocationState);
    if (this.locationErrorState) {
      this.assignProperShipLocation(true);
    } else {
      this.showShipDefaultPosition();
      // setTimeout(() => {
      this.assignProperShipLocation();
      // })
    }
  }

  /* *
   * unknown location falg show/hide
   * * */
  showUnknownLocationFlag(show) {
    this.currentShipList.forEach(ship => {
      if (ship['ship_status'] === 'show' && ship['location_status'] === 'unknown') {
        let shipid = ship.name;
        if (show) {
          this.tagServ.showFlag(shipid);
        } else {
          this.tagServ.hideFlag(shipid, true);
        }
      }
    });
  }

  /* * *
   * unknown location state
   * * */
  onUnknownLocationToggle(flag) {
    this.unknownLocationState = flag;
    this.showUnknownLocationFlag(flag);
    // unknown location is off load if location error is on loaded
    if (!this.unknownLocationState) {
      if (this.locationErrorState) {
        this.assignProperShipLocation(this.locationErrorState);
      }
    }
  }

  /**
   * show flag popup message
   */
  showFlagMessage(shipid) {
    for (let ship of this.currentShipList) {
      if (ship.name === shipid) {
        if (ship['ship_status'] === 'show' && ship['location_status'] === 'unknown') {
          let location = ship.location.split(",");
          let message = ' Coordinates not available for ' + ship['location'];
          if (ship['location_changed']) {
            message = ' Coordinates not available for ' + ship['location'] + ' and ' + ship['ship'] + ' is parked at ' + ship['location'] + ' when there is no ship in ' + location[0];
          }
          this.openPublishDialog(message);
          break;
        } else {
          let location = ship.location.split(",");
          let message = ship['ship'] + ' is parked at ' + ship.location + ' when there is no ship in ' + location[0];
          this.openPublishDialog(message);
          break;
        }
      }
    }
  }

  msgTagView() {
    this.magTagStatus = true;
  }

  /* * *
  * method for load Plan Day screen
  * * */
  loadHomeScreen(planType) {
    this.planType = planType
    this.showUploadScreen = !this.showUploadScreen;
    delete this.rawData;
    this.controlPanelState = false;
    this.pdfStatus = false;
    this.canvasHeight = (window.innerHeight) + 'px';
  }

  loadMessageScreen(e) {
    this.magTagStatus = !this.magTagStatus;
  }
  radhaz_collides = { checked: false, collides: false };
  radhaz_collidesShip: any = [];
  checkForRadHaz(def = false) {
    this.clearRadHaz()
    if (!this.selectedShipElem) {
      this.openPublishDialog("Select the radiating ship!");
    }

    this.radhaz_collides.checked = true;
    if (this.radhaz_demo_mode && (this.selectedShipElem['model'] === "Halifax" && (this.radhazVisServ.selectedActivity.toLowerCase() === 'radiating' || this.radhazVisServ.selectedActivity.toLowerCase() === 'man-aloft'))) {
      let shipId = this.selectedShipElem['name'];
      let collisions = this.radhazVisServ.checkCollisions(shipId);
      console.log("collisions ", collisions);
      var shipIdx = collisions.shipData.findIndex(obj => obj != this.selectedShipElem.name)
      console.log(shipIdx)
      var collisionShipDetails = this.currentShipList.filter(obj => obj.name == collisions.shipData[shipIdx] && this.datePipe.transform(new Date(obj.startdate), 'dd-MMM-yy') <= this.datePipe.transform(new Date(this.reportWFM.Date), 'dd-MMM-yy'))
      console.log(collisionShipDetails)
      if (collisionShipDetails.length != 0) {
        this.collisionShipDetatils = collisionShipDetails[0]
      }
      if (collisions) {
        this.broadcastInfo({ src: 'sidepanel', event: 'collision', data: '' })
        this.radhaz_collides.collides = collisions.radhaz_colllision;
        this.chitNotification['editStatus'] = true;
        //this.openPublishDialog('confirm-box');

      } else {
        this.radhaz_collides.collides = false;
      }
    } else {
      if (this.selectedShipElem.activity == 'radiating') {
        if (this.collitionState) {
          this.radhaz_collides.collides = this.activityServ.showActivityIntersect("radiating", this.selectedShipElem);
          let collisions = this.activityServ.selectedCollisionships;
          console.log("collisions ", collisions);
          var shipIdx = collisions.findIndex(obj => obj.name != this.selectedShipElem.name)
          console.log(shipIdx)
          var collisionShipDetails = this.currentShipList.filter(obj => obj.name == collisions[shipIdx].name && this.datePipe.transform(new Date(obj.startdate), 'dd-MMM-yy') <= this.datePipe.transform(new Date(this.reportWFM.Date), 'dd-MMM-yy'))
          console.log(collisionShipDetails)
          if (collisionShipDetails.length != 0) {
            this.collisionShipDetatils = collisionShipDetails[0]
          }
          if (collisions) {
            this.chitNotification['editStatus'] = true;
          } else {
            this.radhaz_collides.collides = false;
          }
        } else {
          this.radhaz_collides.collides = this.activityServ.showActivityIntersect("radiating", this.selectedShipElem);
        }


      } else {
        this.radhaz_collidesShip = this.activityServ.checkActivityCollisionByOtherShips("Man-Aloft", this.selectedShipElem);
        console.log("radhaz collidesShip", this.radhaz_collidesShip)
        if (this.radhaz_collidesShip?.length > 0) {
          //this.broadcastInfo({ src: 'main', event: 'collision', data:this.collisionShipDetatils , key: "" });
          //this.openPublishDialog('confirm-box');
          this.radhaz_collides.collides = true;
        } else {
          this.radhaz_collides.collides = false;
        }
      }

      var radiatingShip = this.activityServ.selectedCollisionships;
      if (radiatingShip.length > 0) {
        // radiatingShip=radiatingShip
        this.chitService.addRadiate({ data: radiatingShip, port: this.cfbport }).subscribe(response => {
          if (response['result'] === 'success') {
            console.log('data sent', response['radiatesData']);
            this.radiatesList = response['radiatesData'];
          }
        })
      }

    }

    if (def) {
      if (this.radhaz_collides.collides) {
        if (this.chitNotification['editStatus']) {
          if (this.collitionState == true) {
            this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'collisionDetection', data: this.collisionShipDetatils, key: "" });
          } else {
            this.broadcastInfo({ src: 'navyApp', event: 'collisionDetection', data: this.collisionShipDetatils, key: "" });
          }
          //this.openPublishDialog('collision-confirm-box');
        } else {
          if (this.collitionState == true) {
            this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'chitNotification', data: 'yes', key: "" });
          } else {
            this.broadcastInfo({ src: 'navyApp', event: 'chitNotification', data: 'yes', key: "" });
          }
        }
      } else {
        if (this.collitionState == true) {
          this.broadcastIframeInfo({ iframeConnection: 'dockyard', event: 'chitNotification', data: 'yes', key: "" });
        } else {
          this.broadcastInfo({ src: 'navyApp', event: 'chitNotification', data: 'yes', key: "" });
        }

      }
    }
  }
  clearRadHaz() {
    this.activityServ.clearFlagObjects('radhaz');
    this.radhaz_collides = { checked: false, collides: false };
  }

  // onToggleJetty(show) {
  //   this.activityServ.showActivityIntersect('NB', 'radiating');
  // }

  /* * *
  * switch port
  * * */
  switchPort() {
    this.tagServ.cfbstatic_obj_hfx.forEach(obj => {
      if (this.cfbport === 'cfbhalifax') {
        this.ctrlServ.showElement(obj);
        if (this.tagServ.cfbstatic_pos_hfx[obj]) {
          this.ctrlServ.modifyElement(obj, 'geometry', this.tagServ.cfbstatic_pos_hfx[obj])
        }
      }
      if (this.cfbport === 'cfbesquimalt') {
        if (!obj.includes('tug'))
          this.ctrlServ.hideElement(obj);
      }
    });
    this.tagServ.cfbstatic_obj_esq.forEach(obj => {
      if (this.cfbport === 'cfbesquimalt') {
        this.ctrlServ.showElement(obj);
        if (this.tagServ.cfbstatic_pos_esq[obj]) {
          this.ctrlServ.modifyElement(obj, 'geometry', this.tagServ.cfbstatic_pos_esq[obj])
        }
      }
      if (this.cfbport === 'cfbhalifax') {
        if (!obj.includes('tug'))
          this.ctrlServ.hideElement(obj);
      }
    });
    this.allPortElements.forEach(elem => {
      this.ctrlServ.hideElement(elem.name);
    });
  }

  switchStaticObjects() {
    this.tagServ.cfbstatic_obj_hfx.forEach(obj => {
      if (this.cfbport === 'cfbhalifax') {
        this.ctrlServ.showElement(obj);
        if (this.tagServ.cfbstatic_pos_hfx[obj]) {
          this.ctrlServ.modifyElement(obj, 'geometry', this.tagServ.cfbstatic_pos_hfx[obj])
        }
      }
      if (this.cfbport === 'cfbesquimalt') {
        if (!obj.includes('tug'))
          this.ctrlServ.hideElement(obj);
      }
    });
    this.tagServ.cfbstatic_obj_esq.forEach(obj => {
      if (this.cfbport === 'cfbesquimalt') {
        this.ctrlServ.showElement(obj);
        if (this.tagServ.cfbstatic_pos_esq[obj]) {
          this.ctrlServ.modifyElement(obj, 'geometry', this.tagServ.cfbstatic_pos_esq[obj])
        }
      }
      if (this.cfbport === 'cfbhalifax') {
        if (!obj.includes('tug'))
          this.ctrlServ.hideElement(obj);
      }
    });
  }

  /* * *
  * already loaded port just the existing port
  * * */
  changePort() {
    let hidePort = (this.cfbport === 'cfbhalifax' ? 'cfbesquimalt' : 'cfbhalifax');
    let showObjects = this.cfbport_geom[this.cfbport]['objects'];
    let hideObjects = this.cfbport_geom[hidePort]['objects'];
    hideObjects.forEach(obj => {
      this.ctrlServ.hideElement(obj.name);
    });
    showObjects.forEach(port => {
      this.ctrlServ.showElement(port.name);
    });
    this.switchStaticObjects();
  }

  /* * *
  * init port
  * * */
  loadPort(cbck = null) {
    let config = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" };
    let checkPort = this.datauxview.getElementId(config[this.cfbport]);
    this.drawService.cfbport = config[this.cfbport]
    // if port is already loaded
    if (checkPort) {
      let show = this.ctrlServ.isObjVisible(config[this.cfbport]);
      if (!show) {
        this.changePort();
        cbck(false);
      } else {
        cbck(false);
      }
    }

    // port loading first time
    else {
      let def = {};
      for (let m in this.cfbport_path[this.cfbport]) {
        def[m] = this.cfbport_path[this.cfbport][m];
      };
      this.switchPort();
      this.tagServ.setPortConfig(this.cfbport);
      this.dfx.addDynamicShapes(def).then(() => {
        let shapes = this.cfbport_geom[this.cfbport]['shapes'];
        let objects = this.cfbport_geom[this.cfbport]['objects'];

        this.datauxview._createModels(shapes, (boo) => {
          this.datauxview.addElements(objects, (portObjects) => {
            if (this.cfbport === 'cfbhalifax') {
              /* portObjects.forEach(port => {
                if (port.name === 'shearwater' || port.name === 'cfad') {
                  this.ctrlServ.hideElement(port.name);
                }
              }); */
            }
            if (this.cfbport === 'cfbesquimalt' || this.cfbport === 'cfbhalifax') {
              let engine = this.game_engine;
              let m = this.cfbport === 'cfbesquimalt' ? this.getMesh('cfb_esquimalt') : this.getMesh('cfb_halifax');
              let mesh: any = m.getChildMeshes().find((e) => e.name.includes('drydock'));
              /* if (mesh) {
                mesh.onBeforeRenderObservable.add(() => {
                  engine.setStencilOperationPass(7681);
                  engine.setStencilMask(0xFF);
                  engine.setStencilFunction(519);
                  engine.setStencilFunctionReference(1);
                });
                mesh.onAfterRenderObservable.add(() => {
                  engine.setStencilFunctionReference(0);
                });
              }
              let mesh2: any = m.getChildMeshes().find((e) => e.name.includes('EGD_drydock'));
              if (mesh2) {
                mesh2.onBeforeRenderObservable.add(() => {
                  engine.setStencilOperationPass(7681);
                  engine.setStencilMask(0xFF);
                  engine.setStencilFunction(519);
                  engine.setStencilFunctionReference(1);
                });
                mesh2.onAfterRenderObservable.add(() => {
                  engine.setStencilFunctionReference(0);
                });
              }
              let mesh21: any = m.getChildMeshes().find((e) => e.name.includes('irving_drydock'));
              if (mesh21) {
                mesh21.onBeforeRenderObservable.add(() => {
                  engine.setStencilOperationPass(7681);
                  engine.setStencilMask(0xFF);
                  engine.setStencilFunction(519);
                  engine.setStencilFunctionReference(1);
                });
                mesh21.onAfterRenderObservable.add(() => {
                  engine.setStencilFunctionReference(0);
                });
              }
              let m2: any = this.getMesh("ship_vis3");
              let mesh3: any = m2;//.getChildMeshes().find((e) => e.name.includes('Victoria_primitive10'));
              if (mesh3) {
                mesh3.onBeforeRenderObservable.add(() => {
                  engine.setStencilOperationPass(7681);
                  engine.setStencilMask(0xFF);
                  engine.setStencilFunction(519);
                  engine.setStencilFunctionReference(1);
                });

                mesh3.onAfterRenderObservable.add(() => {
                  engine.setStencilFunctionReference(0);
                });
              } */
              // let mesh3: any = m2.getChildMeshes().find((e) => e.name.includes('Victoria_primitive9'));
              // if (mesh3) {
              //   mesh3.onBeforeRenderObservable.add(() => {
              //     engine.setStencilOperationPass(7681);
              //     engine.setStencilMask(0xFF);
              //     engine.setStencilFunction(519);
              //     engine.setStencilFunctionReference(1);
              //   });

              //   mesh3.onAfterRenderObservable.add(() => {
              //     engine.setStencilFunctionReference(0);
              //   });
              // }
            }
            if (cbck) {
              this.allPortElements = portObjects;
              cbck(true);
            }
          }, (id, pointer) => { })
        }, (id, pointer) => { })
      });
    }
  }
  getMeshName(id, mesh = null) {
    let _mesh
    if (mesh) {
      _mesh = mesh
    } else {
      let el = this.datauxview.getElementId(id);
      _mesh = this.dfx.getElementMesh(el);
    }
    let name = null;
    if (_mesh) {
      let str = _mesh.id
      let arr = str.split(".");
      name = arr[arr.length - 1];
    }
    return name;
  }
  getMesh(id) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    return mesh;
  }
  getChildMesh(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildMeshes();
    let idx = meshes.findIndex(e => e.name.includes("." + cid));
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  getChildMeshEx(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildMeshes();
    let idx = meshes.findIndex(e => this.getMeshName(null, e) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  getChildTransEx(id, cid) {
    let el = this.datauxview.getElementId(id);
    let mesh = this.dfx.getElementMesh(el);
    let meshes = mesh.getChildTransformNodes();
    let idx = meshes.findIndex(e => this.getMeshName(null, e) === cid);
    if (idx > -1) {
      return meshes[idx];
    }
    return null;
  }
  rawDataClose(e) {
    if (!e) {
      delete this.rawData
    }
  }

  getCurrentShipData(elemId) {
    let idx = this.currentShipList.findIndex(e => e.name == elemId);
    if (idx > -1) {
      return this.currentShipList[idx];
    }
    return null;
  }

  seePlanOpen(event) {
    this.tblSeePlanOpen = event;
    this.onChangeCameraMode('2D');
  }

  seeplanclose(e) {
    this.tblSeePlanOpen = e;
    this.onChangeCameraMode('3D');
  }

  /* * * * *
  * method for check port if in external means load main port
  * * * * * */
  currentTargetPort: any = '';
  checkPort(cbck) {
    if (this.cfbport === 'cfbhalifax') {
      if (this.cfb_externalport) {
        this.currentTargetPort = this.cfb_externalport;
        this.loadHomePort('home');
        setTimeout(() => { cbck(); }, 1200);
      } else {
        this.currentTargetPort = this.cfbport;
        cbck();
      }
    } else {
      cbck();
    }
  }

  /* * * * *
  * method for show prevew mode
  * * * * * */
  showPDFPreView(key) {
    this.getCurrentTarget();
    if (window.innerWidth < 1000) {
      this.camviews[this.cfbport]['pdf']['distance'] = 5000;
      window.screen.orientation
        .lock("landscape")
        .then(
          success => console.log(success),
          failure => console.log(failure)
        )
    }
    this.checkPort(() => {
      this.datauxview.venue_orientation = 0.35;
      this.datauxview.yaw_2d = this.camviews[this.cfbport]['pdf']['yaw'];
      this.datauxview.pitch_3d = 27.9;
      this.datauxview.yaw_3d = this.camviews[this.cfbport]['pdf']['yaw'];
      this.datauxview.CameraMode('2D');
      this.moveCameraTo(null, this.camviews[this.cfbport]['pdf']);
      setTimeout(() => {
        this.reportServ.getReportRangeData();
        this.openPublishDialog('pdfPreview');
      }, 2000);
    })
  }

  /* * * * *
  * method for load last shown port
  * * * */
  changeDefultPort(cbck) {
    if (this.cfbport === 'cfbhalifax') {
      if (this.currentTargetPort === 'cfbhalifax') {
        cbck();
      } else {
        this.gotoExternalJetty(this.currentTargetPort);
        setTimeout(() => { cbck(); }, 1500);
      }
    } else {
      cbck();
    }
  }

  /* * * * *
  * method for hide prevew mode
  * * * * * */
  closePDFPreView() {
    this.showJettyLabels(this.jettyLabelState);
    this.showLabelsForPDF(false);
    this.showAllActivity(true);
    this.changeDefultPort(() => {
      this.datauxview.yaw_2d = this.camviews[this.cfbport]['currentTarget']['yaw'];
      this.datauxview.pitch_3d = 27.9;
      this.datauxview.yaw_3d = this.camviews[this.cfbport]['currentTarget']['yaw'];
      this.datauxview.CameraMode('3D');
      setTimeout(() => {
        this.moveCameraTo(null, this.camviews[this.cfbport]['currentTarget']);
        this.broadcastInfo({ src: 'main', event: 'reset_preview', data: '', key: "" });
      }, 1300);
    })
  }
  timeProgressToggle(e) {
    this.timeProgress = e;
  }
  openPublishDialog(e): void {
    let width = '285px';
    let type = 'error';
    if (e == 'publish') {
      type = 'publish';
      width = '350px'
    }
    if (e == 'confirm-popup') {
      type = 'confirm-popup';
    }
    if (e == 'confirm-box') {
      type = 'confirm-box';
      width = '430px'
      console.log(this.reportWFM)
      console.log(this.configService.loginInfo)
    }
    if (e == 'collision-confirm-box') {
      type = 'collision-confirm-box';
      console.log(this.collisionShipDetatils)
    }
    if (e == 'daterange-confirm-box') {
      type = 'daterange-confirm-box';
    }
    if (e == 'pdfPreview') {
      type = 'pdfPreview';
      width = window.innerWidth / 0.3 + 'px';
      width = '1080px';
      if (window.innerWidth < 1000) {
        width = window.innerWidth + 'px';
        // this.dialogRef.updateSize(event.target.innerWidth+'px', '');
      }
    }
    if (e == 'wfmReport_hazard' || e == 'wfmReport_aed') {
      type = e;
      width = window.innerWidth / 0.3 + 'px';
      width = '1080px';
      if (window.innerWidth < 1000) {
        width = window.innerWidth + 'px';
        // this.dialogRef.updateSize(event.target.innerWidth+'px', '');
      }
    }
    this.dialogType = type
    const dialogRef = this.dialog.open(PublishDialog, {
      panelClass: 'full-width-dialog',
      width: width,
      data: { value: '', error: e, type: type, port: this.cfbport, dataList: this.reportWFM, shipData: this.collisionShipDetatils },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (this.dialogType == 'pdfPreview') {
        this.closePDFPreView();
        if (window.innerWidth < 1000) {
          window.screen.orientation
            .lock("portrait")
            .then(
              success => console.log(success),
              failure => console.log(failure)
            )
        }
      }
      if (result) {
        if (result.toLowerCase() === 'group-delete-yes') {
          this.broadcastInfo({ src: 'main', event: 'deleteGroupData', data: "", sub: null });
        }
        if (result.toLowerCase() === 'status-delete-yes') {
          this.broadcastInfo({ src: 'main', event: 'deleteStatusData', data: "", sub: null });
        }
        if (result.toLowerCase() === 'layout-delete-yes') {
          this.broadcastInfo({ src: 'main', event: 'deleteLayoutData', data: "", sub: null });
        }
        if (result.toLowerCase() === 'layout-notes-yes') {
          this.broadcastInfo({ src: 'main', event: 'deleteNotesData', data: "", sub: null });
        }
        if (result.toLowerCase() === 'yes') {
          let api = this.configService.project_config.publishPlan;
          if (this.uploadedJsonFile) {
            this.configService.pullJsonData(api, { 'port': this.cfbport, 'filets': this.uploadedJsonFile }).then((response) => {
              console.log("response ", response);
              if (response) {
                this.openPublishDialog('Plan Published !!');
              }
            }).catch((error) => {
              console.log(error);
            });
          } else {
            this.openPublishDialog('Please Upload Valid Excel Then Do Publish !!');
          }
        }
        if (result.toLowerCase() === 'yes-confirm') {
          // this.sendInfo(this.chitNotification);
          this.broadcastInfo({ src: 'main', event: 'chitNotificationYes', data: 'yes', key: "" });
        }
        if (result.toLowerCase() === 'no-confirm') {
          // this.onRemoveShip();
          if (this.selectedShipElem['model'] === "Halifax" && (this.radhazVisServ.selectedActivity.toLowerCase() === 'radiating' || this.radhazVisServ.selectedActivity.toLowerCase() === 'man-aloft')) {
            this.radhazVisServ.resetCollisions();
          }
          this.broadcastInfo({ src: 'main', event: 'chitNotificationNo', data: 'no', key: "" });
        }
        if (result.toLowerCase() === 'yes-confirm-collision') {
          this.broadcastInfo({ src: 'main', event: 'chitNotificationYesRequest', data: 'yes', key: "", collisionShip: this.collisionShipDetatils });
        }
        if (result.toLowerCase() === 'no-confirm-collision') {
          this.broadcastInfo({ src: 'main', event: 'collisionNotificationNo', data: 'no', key: "" });
        }
        if (result.toLowerCase() === 'yes-datechange') {
          let range = this.ctrlServ.selectedDateRange;
          this.ctrlServ.defaultDateRange = range;
          this.broadcastInfo({ src: 'main', event: 'updateDateRange', data: '', key: true });
          this.broadcastInfo({ src: 'main', event: 'changeDateRange', data: range, key: "" });
        }
        if (result.toLowerCase() === 'no-datechange') {
          this.broadcastInfo({ src: 'main', event: 'updateDateRange', data: '', key: false });
        }
        if (result.toLowerCase() === 'userList-Add-yes') {
          this.broadcastInfo({ src: 'main', event: 'addUserList', data: '' });
        }
      }
    });
  }
  /**
   * TODO move BABYLON method to dataux
   * @param hide
   */
  ground
  toggleOffOcean(hide = true) {
    let water

    if (!this.ground) {
      if (this.cfbport === 'cfbhalifax') {
        water = this.getChildMesh('cfb_halifax', 'hfx_water');
      } else {
        water = this.getChildMesh('cfb_esquimalt', 'esq_water');
      }
      this.ground = water;//this.getMesh('ground');
      //this.ground.material = this.getGroundMaterial();
    }

    if (!hide) {
      if (this.ocean) {
        if (this.ocean._mesh != null) {
          this.ocean._mesh.setEnabled(false);
        }
      }
      if (this.ground != null) {
        this.ground.setEnabled(true);
      }
    }
    else {
      if (this.ocean) {
        if (this.ocean._mesh != null) {
          this.ocean._mesh.setEnabled(true);
        }
      } else {
        this.addOcean();
      }
      if (this.ground != null) {
        this.ground.setEnabled(false);
      }
    }
  }
  xtoggleOffOcean(hide = true) {
    if (!this.ground) {

      this.ground = this.getMesh('ground');
      this.ground.material = this.getGroundMaterial();
      if (this.cfbport.includes('esq')) {
        this.ground.setEnabled(!true);
      }
    }
    if (!hide) {
      if (this.ocean) {
        if (this.ocean._mesh != null) {
          this.ocean._mesh.setEnabled(false);
        }
      }
      if (this.ground != null) {

        if (this.cfbport.includes('esq')) {
          this.ground.setEnabled(!true);
        } else {
          this.ground.setEnabled(true);
        }
      }
    }
    else {
      if (this.ocean) {
        if (this.ocean != null) {
          this.ocean._mesh.setEnabled(true);
        }
      }
      if (this.ground != null) {
        this.ground.setEnabled(false);
      }
    }
  }
  getGroundMaterial() {
    let gm = new BABYLON.GridMaterial("ocean_grid", window['scene']);
    gm.mainColor = new BABYLON.Color3(0.2, 0.44, 0.57);
    gm.lineColor = new BABYLON.Color3(0.3, 0.54, 0.67);
    return gm
  }

  /* * *
  * hide un selected toggle for ship transparent
  * * */
  hideUnselectedToggle(status) {
    this.hideUnselectedState = status;
    if (this.selectedShipElem) {
      if (this.filterData.length != 0 || this.filterData == null) {
        this.onSelectedShip(this.selectedShipElem);
      }
    }
    if (this.filterData != null) {
      if (this.filterData.length > 0) {
        this.onShowFilteredShips(this.filterData)
      }

    }
  }

  /* * *
  * method for hide crane
  * * */
  hideCraneToggle(show) {
    this.hideCraneState = show;
    this.toggleCraneObjects(show);
  }

  /* * *
  * method for hide light
  * * */
  hideLightToggle(show) {
    this.hideLightState = show;
    this.toggleLightObjects(show);
  }
  /**
   * update cranes for animation
   */
  updateCraneObjects() {
    this.cr_demo_obj = []
    if (this.cfbport === 'cfbhalifax') {
      let m = this.getChildMesh('hfx_crane_1', 'engine_house');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
        //m.parent.scaling.x *= -1
      }
      m = this.getChildMesh('hfx_crane_2', 'engine_house');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
        //m.parent.scaling.x *= -1
      }
      m = this.getChildMesh('hfx_crane_3', 'engine_house');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
      }
    } else {
      let m = this.getChildMesh('esq_crane_1', 'tower').parent;
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
      }
      //ebco_crane_engine_house
      m = this.getChildMesh('esq_crane_2', 'C_Jetty_crane_engine_house');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
      }
      m = this.getChildMesh('esq_crane_3', 'kone_crane_office');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
      }
      m = this.getChildMesh('esq_crane_4', 'ebco_crane_engine_house');
      this.cr_demo_obj.push(m);
      if (m.rotationQuaternion) {
        m.rotationQuaternion = null;
      }
    }
    let crarr = [];
    let sso = this['sso_' + this.cfbport];
    let pkeys = this['crpath_' + this.cfbport];
    this.cr_demo_obj.forEach((cr, idx) => {
      let crobj = { crane: null, props: null };
      crobj.crane = cr.parent;
      crobj.props = { start: sso[idx], path: pkeys[sso[idx].name] }
      crarr.push(crobj);
    })
    if (this["crane_mngr_" + this.cfbport]) {
      this["crane_mngr_" + this.cfbport].destroy();
    }
    this["crane_mngr_" + this.cfbport] = new CraneManager(crarr, this.translate, this.language);
  }
  bridgeViewToggle(e) {
    let el = this.datauxview.getElementId('bridge_1');
    let mesh = this.getMesh('bridge_1')
    if (e) {
      this.dfx.modify(el, { profile: "regular" });
    } else {
      this.dfx.modify(el, { profile: "invisible" });
    }

  }
  /**
   * FMF - process cone status
   */
  cones_cfbhalifax = [
    "hfx_above_water_weapons_shop_cone",
    "hfx_brush_plating_cone",
    "hfx_ice_shop_cone.001",
    "hfx_drdc_lab_cone",
    "hfx_grinding_area_cone",
    "hfx_heavy_electrical_shop_cone",
    "hfx_hydraulic_shop_cone",
    "hfx_ice_shop_cone",
    "hfx_injector_shop_cone",
    "hfx_machine_shop_cone",
    "hfx_marine_machinery_shop_cone",
    "hfx_misc_shop_cone",
    "hfx_chemical_cleaning_cone",
    "hfx_plate_shop_cone",
    "hfx_refrigeration_shop_cone",
    "hfx_sheet_metal_shop_cone",
    "hfx_under_water_weapons_shop_cone",
    "hfx_welding_shop_cone"
  ];
  cones_cfbesquimalt = ["esq_area_a_cone", "esq_area_b_cone", "esq_area_c_cone", "esq_area_d_cone", "esq_area_e_cone", "esq_area_f_cone", "esq_area_g_cone", "esq_area_h_cone", "esq_area_i_cone", "esq_area_j_cone", "esq_area_k_cone", "esq_area_osf_cone"];
  updateFMFConeStatus() {
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
    let pmesh = this.getMesh(mc[this.cfbport]);
    let carr = this["cones_" + this.cfbport];
    let meshes = pmesh.getChildMeshes();
    let subarr = this.pickRandom(carr, this.status_cone_mats.length)
    meshes.forEach((m) => {
      let mid = m.name.split(".");
      let mstr = mid[mid.length - 1];
      let sp = mstr.split("_primitive");
      let n = sp[0];
      let p = sp[1];
      if (carr.includes(n)) {
        if (m.material) {
          let _idx = subarr.includes(n) ? subarr.indexOf(n) : null;
          if (_idx !== null) {
            m.material = this.getRandomFMFConeMat(null, _idx);
          } else {
            if (p != '4') {
              m.material = this.getRandomFMFConeMat(null, _idx);
            }
          }

        }
      }
    })
  }
  getRandomFMFConeMat(matid = null, idx = null) {
    let l = this.status_cone_mats.length;
    let r = Math.floor((Math.random() * l));
    if (idx !== null) {
      r = idx;
    }
    let mat = matid || this.status_cone_mats[r];
    let scene = window['scene'];
    return scene.getMaterialByID(mat);
  }
  fmfmode = "w_interiors";//"exterior"
  toggleFMFMode(e) {
    //FMF_CB_exterior
    this.fmfmode = e;
    if (this.fmfmode === 'exterior') {
      this.fmfmode = 'w_interiors';
    } else {
      this.fmfmode = 'exterior'
    }

    let match = "FMF_CS_";
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" }
    if (this.cfbport === 'cfbesquimalt') {
      this.showHideLocationPin();
      //mname = "FMF_CB_" + this.fmfmode;
      match = "FMF_CB_";
    }
    let showItem = match + this.fmfmode;
    let hideItem = match + e;

    // mname = "FMF_CS_" + this.fmfmode;
    let cmesh = this.getMesh(mc[this.cfbport]);
    if (cmesh) {
      cmesh.getChildMeshes().forEach((m) => {

        if (m.name.includes(showItem)) {
          m.setEnabled(true)
        }
        if (m.name.includes(hideItem)) {
          m.setEnabled(false)
        }

      })
    }

    if (this.toggleConeState) {
      this.toggleFMFCone(this.toggleConeState);
    }
  }
  rnd(l) {
    return Math.floor(Math.random() * l);
  }
  pickRandom(arr, num = 1) {
    const res = [];
    for (let i = 0; i < num;) {
      const random = this.rnd(arr.length);
      if (res.indexOf(arr[random]) !== -1) {
        continue;
      };
      res.push(arr[random]);
      i++;
    };
    return res;
  };
  demopoints = [];
  debugmode = false;
  enableDrag(child) {
    let dfx = this.datauxview.getDatascape();
    let cam = dfx.getCamera();
    let b = dfx.getDragBehavior([0, 1, 0])
    b.useObjectOrienationForDragging = false;
    b.updateDragPlane = false;
    child.addBehavior(b);
    child.custombehav = b;
    b.onDragStartObservable.add((event) => {
      if (child.name.includes('locator')) {
        //child.rotation.y=cam.yaw_deg * Math.PI/180
        //child.billboardMode=0;

      }
      if (this.debugmode) {
        let rot = child.rotation;
        let pos = child.position;
        console.log('Start Drag', rot, pos);
      }
    })
    b.onDragEndObservable.add((event) => {
      console.log(event)
      if (child.name.includes('locator')) {
        //child.rotation.y=0
        //child.billboardMode=2
      }
      if (this.debugmode) {
        let rot = child.rotation;
        let pos = child.position;
        console.log('End Drag', rot, pos);
      }
      let pos = child.position;
      let x = parseFloat(pos.x.toFixed(4));
      let fx = (Math.sign(parseFloat(pos.x.toFixed(4))) === 1 || Math.sign(parseFloat(pos.x.toFixed(4))) === 0 ? - parseFloat(pos.x.toFixed(4)) : parseFloat(pos.x.toFixed(4)))
      let _x = (Math.sign(parseFloat(pos.x.toFixed(4))) === 1 || Math.sign(parseFloat(pos.x.toFixed(4))) === 0 ? - parseFloat(pos.x.toFixed(4)) : -parseFloat(pos.x.toFixed(4)))
      let y = parseFloat(pos.y.toFixed(4));
      let z = parseFloat(pos.z.toFixed(4));
      if (this.selectedLocationId) {
        if (this.dragPrePositionFirstAid) {
          if ((this.dragPrePositionFirstAid.x.toFixed(0) != fx.toFixed(0)) || (this.dragPrePositionFirstAid.z.toFixed(0) != z.toFixed(0))) {
            this.positionConfirmFirstAid(this.selectedLocationId);
            this.updateLocationPinPos({ x: _x, y, z }, { x, y, z });
          }
        }
      }
      if (this.selectedConeId) {
        if (this.dragPrePosition) {
          if ((this.dragPrePosition.x.toFixed(0) != x.toFixed(0)) || (this.dragPrePosition.z.toFixed(0) != z.toFixed(0))) {
            this.positionConfirmHazard(this.selectedConeId)
            this.updateHazardPosition({ x, y, z });
          }
        }
      }
    })
    b.onDragObservable.add((event) => {
      if (this.debugmode) {
        let pos = child.position;
        let x = parseFloat(pos.x.toFixed(2));
        let y = parseFloat(pos.y.toFixed(2));
        let z = parseFloat(pos.z.toFixed(2));
        this.demopoints.push({ x, y, z });
      }
    })
  }
  removeDrag(el) {
    let dfx = this.datauxview.getDatascape();
    let child = this.getMesh(el);
    child.removeBehavior(child.custombehav);
  }
  enableCraneDrag() {
    this.cr_demo_obj.forEach((m) => {
      this.enableDrag(m.parent);
    })
  }
  /******
   *Laydown Hide/Show
   */
  toggleLaydownToggle(e) {
    var pmesh, bid;
    if (this.cfbport === 'cfbhalifax') {
      pmesh = this.getMesh("cfb_halifax");
      bid = "laydown";
    }
    if (this.cfbport === 'cfbesquimalt') {
      pmesh = this.getMesh("cfb_esquimalt");
      bid = "FMF_CB._laydowns";
    }

    let bld = pmesh.getChildren().find(e => { return e.id.includes(bid) })
    if (bld != null) {
      bld.setEnabled(!e);
    }
  }

  /* *
   * multicolor cone Hide/Show
   */
  toggleFMFCone(boo) {
    this.toggleConeState = boo;
    let mc = { "cfbhalifax": "cfb_halifax", "cfbesquimalt": "cfb_esquimalt" };
    let esq_cones = ['esq_area_a_cone_primitive', 'esq_area_b_cone_primitive', 'esq_area_c_cone_primitive', 'esq_area_d_cone_primitive', 'esq_area_e_cone_primitive', 'esq_area_f_cone_primitive', 'esq_area_g_cone_primitive', 'esq_area_h_cone_primitive', 'esq_area_j_cone_primitive', 'esq_area_k_cone_primitive', 'esq_osf_cone_primitive']
    let hfx_cones = ['hfx_above_water_weapons_shop_cone_primitive', 'hfx_brush_plating_cone_primitive', 'hfx_drdc_lab_cone_primitive', 'hfx_grinding_area_cone_primitive', 'hfx_heavy_electrical_shop_cone_primitive', 'hfx_hydraulic_shop_cone_primitive', 'hfx_ice_shop_cone_primitive', 'hfx_injector_shop_cone_primitive', 'hfx_machine_shop_cone_primitive', 'hfx_marine_machinery_shop_cone_primitive', 'hfx_marine_machinery_shop_cone_primitive', 'hfx_misc_shop_cone_primitive', 'hfx_chemical_cleaning_cone_primitive', 'hfx_plate_shop_cone_primitive', 'hfx_refrigeration_shop_cone_primitive', 'hfx_sheet_metal_shop_cone_primitive', 'hfx_under_water_weapons_shop_cone_primitive', 'hfx_welding_shop_cone_primitive', 'hfx_ice_shop_cone'];
    let cmesh = this.getMesh(mc[this.cfbport]);
    let cones = this.cfbport === 'cfbhalifax' ? hfx_cones : esq_cones;
    if (cmesh) {
      cmesh.getChildMeshes().forEach((m) => {
        const found = cones.some(cone => m.name.includes(cone))
        if (found) {
          m.setEnabled(!boo)
        }
      })
    }
  }

  attchEventLaydown() {
    // var  pmesh,bid;
    // if (this.cfbport === 'cfbhalifax') {
    //   pmesh = this.getMesh("cfb_halifax");
    //   bid = "laydown";
    // }
    // if (this.cfbport === 'cfbesquimalt') {
    //   pmesh = this.getMesh("cfb_esquimalt");
    //   bid = "FMF_CB._laydowns";
    // }
    // let eleLaydown = pmesh.getChildren().find(e => { return e.id.includes(bid) });
    // console.log("attchEventLaydown", eleLaydown._children);
    // if (eleLaydown != null) {
    //   eleLaydown.setEnabled(false);
    // }

  }

  /* * * * *
  * method for kiosk status change
  * * * * * */
  onChangeKioskStatus(obj) {
    // this.broadcastInfo({ src: 'main', event: 'broadCastMsg', data: obj,state: null, sub: null });
    if (this.socket !== undefined) {
      obj['userId'] = this.userId;
      this.socket.emit('changeKioskStatus', obj);
    }
    // obj['port']= this.cfbport;
    // this.updateKioskService(obj,(data)=>{
    //   if(data){
    //     console.log("updateKioskService",data);
    //     this.getKioskData((foo) => {
    //       if (foo) {
    //         this.hideKiosk();
    //       }
    //     })
    //   }
    // });

  }



  /* * *
* method for update kiosk data to server
* * */
  // updateKioskService(data,cbck){
  //   this.configService.pullJsonData(this.projectConfig.updatekioskdata, data).then((kioskJson) => {
  //     console.log("updateKioskService",kioskJson)
  //     if (kioskJson['result'] != 'failed') {

  //       cbck(true)
  //     } else {
  //       this.openPublishDialog('kiosk data not found !!');
  //       cbck(false);
  //     }
  //   }).catch((error) => {
  //     console.log("error ", error);
  //     cbck(false);
  //   });
  // }

  /* * * * *
  * method for update kiosk status
  * * * * * */
  updateKioskStatus(data) {
    if (this.userId !== data['userId']) {
      console.log("updateKioskStatus ", data);
      let message = data['kiosk'] + ' ' + data['service'] + ' status changed to ' + data['status'];
      // this.ctrlServ.openDialogBox(message);
      this.broadcastInfo({ src: 'main', event: 'broadCastMsg', data: data, state: null, sub: null });
      this.broadcastInfo({ src: 'main', event: 'updatekioskstatus', data: data['uid'], service: data['service'], status: data['status'] });
      this.broadcastInfo({ src: 'main', event: 'showKioskId', data: data['uid'], state: null, sub: null });
      this.tagServ.showKioskTag(data['uid'], true)
    }
  }

  /**
  * Hazrad Area
  */

  /* * *
  * method for get hazard data from server
  * * */
  getHazardData(cbck) {
    this.coneList = [];
    this.configService.getHazardData().then((hazard: any) => {
      if (hazard) {
        hazard = hazard.map(v => ({ ...v, expand: false }))
        this.coneList = hazard;
        console.log("network", this.coneList);
        cbck(true)
      } else {
        this.openPublishDialog('hazard data not found !!');
        cbck(false)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  createHazard(conedata) {
    this.configService.createHazard(conedata).then(data => {
      if (data) {
        console.log("cone created ", data)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  updateHazard(_id, conedata) {
    this.configService.updateHazard(_id, conedata).then(data => {
      if (data) {
        console.log("cone updated ", data);
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  onDeleteHazard(_id) {
    this.configService.deleteHazard(_id).then(data => {
      if (data) {
        console.log("cone deleted ", data)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  getCurrentPosition() {
    const hit = this.dfx.getHitPosition();
    if (!hit.hit) {
      return;
    }
    const hpt = hit.pickedPoint;
    console.log("current Point: ", hpt.x, hpt.z)
  }
  pinObjects = {};
  CAPlotMode(boo) {
    this.plotmode_ca = boo;
  }
  getPlotLoc() {
    const h = this.dfx.getHitPosition();
    if (!h.hit) {
      return null;
    }
    return h.pickedPoint;
  }
  addConePin(id, pos, material, def = false,) {
    let shape = 'cone_m';
    let profiles = {
      hidden: { material: 'hidden_obj' },
      regular: { material: 'custom-included' },
      cone_red: { material: 'cone_red' },
      cone_orange: { material: 'cone_orange' },
      cone_green: { material: 'cone_green' }
    };
    let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': pos, 'size': 0.33 } };
    // this.dfx.modify(el, {  'geometry': {'position': pos} })
    this.datauxview.addElement(shape, id, profiles, settings);
    this.pinObjects[id] = this.datauxview.getElementId(id);
    this.getCurrentPosition();
    let obj = { "_id": id, "activity": "", "color": "cone_orange", "startdate": "", "enddate": "", "starttime": "", "endtime": "", "notes": "", "position": pos, "port": this.cfbport, "status": "new" };

    if (def) {
      this.selectedConeElem = obj;
      this.toggleCautionState = false;
      this.tagServ.showHazardTag(obj['_id'], false);
      this.tagServ.showHazardTag(obj['_id'], true);
      this.toggleCautionMode();
    }

    this.setPinColor(id, material);
    this.attchStaticObjEvent(this.pinObjects[id]);
    console.log("coneList ", this.coneList)
  }
  removeConePin(id) {
    let el = this.pinObjects[id];
    this.dfx.remove(el)
    this.pinObjects[id] = null;
    delete this.pinObjects[id];
  }
  selectedConeId: any;
  moveConePin(id) {
    let m = this.getMesh(id);
    this.enableDrag(m)
  }
  moveConePinStop(id) {
    console.log("moveConePinStop", id, this.getMesh(id))
    this.removeDrag(id)
  }
  plotPin() {
    let loc = this.getPlotLoc();
    loc.x = -loc.x;
    loc.y = 3.3;
    // let c = this.coneList.length + 1;
    let pid = "pin_" + uuid.v4(); // Math.random().toString(36).substr(2, 5);/**replace with better ID */
    this.addConePin(pid, loc, 'cone_orange', true);
  }
  setPinColor(id, prf) {
    let el = this.pinObjects[id];
    this.dfx.modify(el, { profile: prf });
  }
  setPinProps() {
  }
  loadPinObjects() {
    this.coneList.forEach(cone => {
      if (cone['position']) {
        this.addConePin(cone['_id'], cone['position'], cone['color']);
      }
    });
  }
  onRemoveCone() {
    if (this.selectedConeElem) {
      this.removeConePin(this.selectedConeElem['_id']);
      this.tagServ.showHazardTag(this.selectedConeElem['_id'], false);
      this.selectedConeElem = null;
    }
  }
  toggleCautionMode() {
    this.CAPlotMode(this.toggleCautionState);
  }
  OnCautionPopupClose() {
    this.tagServ.showHazardTag(this.selectedConeElem['_id'], false);
    this.selectedConeElem = null;
    this.broadcastInfo({ src: 'main', event: 'showconepopup', data: this.selectedConeElem });
    // this.toggleCautionMode();
  }
  onUpdateConeData(obj) {
    if (obj) {
      if (this.coneList.length > 0) {
        let idx = this.coneList.findIndex(e => e['_id'] == obj['_id'])
        if (idx > -1) {
          this.coneList[idx]['activity'] = obj['activity'];
          this.coneList[idx]['startdate'] = obj['startdate'];
          this.coneList[idx]['enddate'] = obj['enddate'];
          this.coneList[idx]['color'] = obj['color'];
          this.coneList[idx]['notes'] = obj['notes'];
          this.coneList[idx]['expand'] = false;
          this.updateHazard(obj['_id'], this.selectedConeElem);
        } else {
          this.selectedConeElem['activity'] = obj['activity'];
          this.selectedConeElem['startdate'] = obj['startdate'];
          this.selectedConeElem['enddate'] = obj['enddate'];
          this.selectedConeElem['color'] = obj['color'];
          this.selectedConeElem['notes'] = obj['notes'];
          this.selectedConeElem['expand'] = false;
          this.coneList.push(this.selectedConeElem);
          this.createHazard(this.selectedConeElem);
        }
      } else {
        this.selectedConeElem['activity'] = obj['activity'];
        this.selectedConeElem['startdate'] = obj['startdate'];
        this.selectedConeElem['enddate'] = obj['enddate'];
        this.selectedConeElem['color'] = obj['color'];
        this.selectedConeElem['notes'] = obj['notes'];
        this.selectedConeElem['expand'] = false;
        this.coneList.push(this.selectedConeElem);
        this.createHazard(this.selectedConeElem);
      }
      this.setPinColor(obj['_id'], obj['color']);
    }
  }
  onActiveConeElem(obj) {
    if (this.selectedConeElem != null) {
      if (this.selectedConeElem['_id'] != obj['_id']) {
        this.selectedConeElem = obj;
        this.tagServ.showHazardTag(obj['_id'], false);
        this.ctrlServ.focusStaticElement(obj['_id']);
        this.tagServ.showHazardTag(obj['_id'], true);
        this.broadcastInfo({ src: 'main', event: 'showconepopup', data: this.selectedConeElem });
      } else {
        this.selectedConeElem = null;
        this.tagServ.showHazardTag(obj['_id'], false);
        this.broadcastInfo({ src: 'main', event: 'showconepopup', data: this.selectedConeElem });
      }
    } else {
      if (obj) {
        this.selectedConeElem = obj;
        this.tagServ.showHazardTag(obj['_id'], false);
        this.ctrlServ.focusStaticElement(obj['_id']);
        this.tagServ.showHazardTag(obj['_id'], true);
        this.broadcastInfo({ src: 'main', event: 'showconepopup', data: this.selectedConeElem });
      }

    }
  }
  deleteHazard(cone) {
    if (cone) {
      let idx = this.coneList.findIndex(el => el._id === cone['_id']);
      if (idx > -1) {
        this.removeConePin(cone['_id']);
        this.onDeleteHazard(cone['_id']);
        this.coneList.splice(idx, 1);
        this.tagServ.showHazardTag(cone['_id'], false);
        this.selectedConeElem = null;
        console.log(this.coneList)
      }
    }
  }
  updateHazardPosition(pos) {

    this.coneList.forEach(cone => {
      if (cone['_id'] === this.selectedConeId) {
        let el = this.datauxview.getElementId(this.selectedConeId);
        this.dfx.modify(el, { 'geometry': { 'position': pos } })
        cone['position'] = pos;
      }
    });
    this.selectedConeId = null;
  }
  /* *
  * end of hazard area
  * */

  /**
  * RADHAZ demo
  */
  ship_map = {}
  color_map = {};
  collision_ships = [];
  radhaz_comps = {
    "01__NAV_RADAR-B": { "antenna": true, "rotating": true, "position": {}, "radius": 2, "height": null, "state": false, "name": "NAV RADAR B", "id": "NAV_radar_B", "index": 1 },
    "02__NAV_RADAR-A": { "antenna": true, "rotating": true, "position": {}, "radius": 3, "height": null, "state": false, "name": "NAV RADAR A", "id": "NAV_radar_A", "index": 2 },
    "11__SIRIUS": { "antenna": false, "rotating": true, "position": {}, "radius": 0.8, "height": null, "state": false, "name": "SIRIUS", "id": "SIRIUS_sensors", "index": 11 },
    "16__FBB-500": { "antenna": true, "rotating": false, "position": {}, "radius": 2, "height": null, "state": false, "name": "FBB 500", "id": "FBB_500", "index": 16 },
    "31__SG-180": { "antenna": true, "rotating": true, "position": {}, "radius": 17, "height": null, "state": false, "name": "SG-180", "id": "SG-180", "index": 31 },
    "43__RAMSES": { "antenna": true, "rotating": false, "position": {}, "radius": 35, "height": null, "state": false, "name": "RAMSES", "id": "RAMSES", "index": 43 },
    "44__NMT_PORT": { "antenna": true, "rotating": false, "position": {}, "radius": 45, "height": null, "state": false, "name": "NMT PORT", "id": "NMT_PORT", "index": 44 },
    "45__NMT_STBD": { "antenna": true, "rotating": false, "position": {}, "radius": 45, "height": null, "state": false, "name": "NMT STBD", "id": "NMT_STBD", "index": 45 },
    "46__CEROS_200_fwd": { "antenna": true, "rotating": true, "position": {}, "radius": 75, "height": null, "state": false, "name": "FWD CEROS", "id": "CEROS_200_fwd", "index": 46 },
    "47__CEROS_200_aft": { "antenna": true, "rotating": true, "position": {}, "radius": 75, "height": null, "state": false, "name": "AFT CEROS", "id": "CEROS_200_aft", "index": 47 },
    "48__SEOSS": { "antenna": true, "rotating": false, "position": {}, "radius": 66, "height": null, "state": false, "name": "SEOSS", "id": "SEOSS", "index": 48 },
    "49__Smart_S_radar": { "antenna": true, "rotating": true, "position": {}, "radius": 30.4, "height": null, "state": false, "name": "Smart-S", "id": "Smart_S_radar", "index": 49 },
    "60__white_Sailor_100_GX": { "antenna": true, "rotating": false, "position": {}, "radius": 55, "height": null, "state": false, "name": "Sailor 100 GX", "id": "Sailor_100_GX", "index": 60 },
    "54__MSCU": { "antenna": true, "rotating": false, "position": {}, "radius": 153, "height": null, "state": false, "name": "lMSCU", "id": "lMSCU", "index": 54 },
    "55__CIWS_sensors": { "antenna": true, "rotating": true, "position": {}, "radius": 189, "height": null, "state": false, "name": "CIWS RF ONLY", "id": "CIWS_sensors", "index": 55 },
    "56__HF_18ft_whip": { "antenna": true, "rotating": false, "position": {}, "radius": 18.5, "height": null, "state": false, "name": "HF 18' Whip", "id": "HF_18ft_whip", "index": 56 },
    "56__HF_35ft_whip": { "antenna": true, "rotating": false, "position": {}, "radius": 10, "height": null, "state": false, "name": "HF 35' Whip", "id": "HF_35ft_whip", "index": 56 },
    "57__HF_Emergency": { "antenna": true, "rotating": false, "position": {}, "radius": 7.3, "height": null, "state": false, "name": "HF Emergency", "id": "HF_Emergency", "index": 57 },
    "58__CEROS_200_fwd": { "antenna": true, "rotating": false, "position": {}, "radius": 245, "height": null, "state": false, "name": "FWD CWI", "id": "CEROS_200_fwd", "index": 58 },
    "59__CEROS_200_aft": { "antenna": true, "rotating": false, "position": {}, "radius": 245, "height": null, "state": false, "name": "AFT CWI", "id": "CEROS_200_aft", "index": 59 }

  }
  radhaz_comps_2 = JSON.parse(JSON.stringify(this.radhaz_comps));
  radhaz_comps_3 = {
    "AIS Antenna": {
      "position": {},
      "radius": 2.2,
      "height": null,
      "state": false,
      "name": "AIS Antenna",
      "id": "AIS Antenna",
      "index": 0
    },
    "Combat Net Radio": {
      "position": {},
      "radius": 15.7,
      "height": null,
      "state": false,
      "name": "Combat Net Radio",
      "id": "Combat Net Radio",
      "index": 0
    },
    "HF DSC Transceiver #1": {
      "position": {},
      "radius": 19.7,
      "height": null,
      "state": false,
      "name": "HF DSC Transceiver #1",
      "id": "HF DSC Transceiver #1",
      "index": 0
    },
    "HF DSC Transceiver #2": {
      "position": {},
      "radius": 19.7,
      "height": null,
      "state": false,
      "name": "HF DSC Transceiver #2",
      "id": "HF DSC Transceiver #2",
      "index": 0
    },
    "HF Narrow Band transmitter": {
      "position": {},
      "radius": 19.7,
      "height": null,
      "state": false,
      "name": "HF Narrow Band transmitter",
      "id": "HF Narrow Band transmitter",
      "index": 0
    },
    "HF NVIS Transmitter": {
      "position": {},
      "radius": 14.9,
      "height": null,
      "state": false,
      "name": "HF NVIS Transmitter",
      "id": "HF NVIS Transmitter",
      "index": 0
    },
    "HF Transceiver 35' Whip # 1": {
      "position": {},
      "radius": 29.7,
      "height": null,
      "state": false,
      "name": "HF Transceiver 35' Whip # 1",
      "id": "HF Transceiver 35' Whip # 1",
      "index": 0
    },
    "HF Transceiver 35' Whip #2": {
      "position": {},
      "radius": 29.7,
      "height": null,
      "state": false,
      "name": "HF Transceiver 35' Whip #2",
      "id": "HF Transceiver 35' Whip #2",
      "index": 0
    },
    "IFF Interrogator": {
      "position": {},
      "radius": 46.1,
      "height": null,
      "state": false,
      "name": "IFF Interrogator",
      "id": "IFF Interrogator",
      "index": 0
    },
    "IFF Transponder": {
      "position": {},
      "radius": 0.9,
      "height": null,
      "state": false,
      "name": "IFF Transponder",
      "id": "IFF Transponder",
      "index": 0
    },
    "INMARSATC": {
      "position": {},
      "radius": 0.6,
      "height": null,
      "state": false,
      "name": "INMARSATC",
      "id": "INMARSATC",
      "index": 0
    },
    "Iridium Vessel Tracking Unit": {
      "position": {},
      "radius": 0.53,
      "height": null,
      "state": false,
      "name": "Iridium Vessel Tracking Unit",
      "id": "Iridium Vessel Tracking Unit",
      "index": 0
    },
    "KuBand SATCOM PORT": {
      "position": {},
      "radius": 80,
      "height": null,
      "state": false,
      "name": "KuBand SATCOM PORT",
      "id": "KuBand SATCOM PORT",
      "index": 0
    },
    "KuBand SATCOM STBD": {
      "position": {},
      "radius": 80,
      "height": null,
      "state": false,
      "name": "KuBand SATCOM STBD",
      "id": "KuBand SATCOM STBD",
      "index": 0
    },
    "SATCOM Internet (QoL)": {
      "position": {},
      "radius": 44,
      "height": null,
      "state": false,
      "name": "SATCOM Internet (QoL)",
      "id": "SATCOM Internet (QoL)",
      "index": 0
    },
    "SBand Navigation Radar": {
      "position": {},
      "radius": 5,
      "height": null,
      "state": false,
      "name": "SBand Navigation Radar",
      "id": "SBand Navigation Radar",
      "index": 0
    },
    "Surveillance Radar": {
      "position": {},
      "radius": 22,
      "height": null,
      "state": false,
      "name": "Surveillance Radar",
      "id": "Surveillance Radar",
      "index": 0
    },
    "UHF Flight Deck Wireless": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "UHF Flight Deck Wireless",
      "id": "UHF Flight Deck Wireless",
      "index": 0
    },
    "UHF WB #1": {
      "position": {},
      "radius": 3.4,
      "height": null,
      "state": false,
      "name": "UHF WB #1",
      "id": "UHF WB #1",
      "index": 0
    },
    "UHF WB #2": {
      "position": {},
      "radius": 4.6,
      "height": null,
      "state": false,
      "name": "UHF WB #2",
      "id": "UHF WB #2",
      "index": 0
    },
    "VHF Marine #1 (GMDSS)": {
      "position": {},
      "radius": 3.5,
      "height": null,
      "state": false,
      "name": "VHF Marine #1 (GMDSS)",
      "id": "VHF Marine #1 (GMDSS)",
      "index": 0
    },
    "VHF Marine #2 (GMDSS)": {
      "position": {},
      "radius": 3.5,
      "height": null,
      "state": false,
      "name": "VHF Marine #2 (GMDSS)",
      "id": "VHF Marine #2 (GMDSS)",
      "index": 0
    },
    "VHF Marine 1": {
      "position": {},
      "radius": 1.8,
      "height": null,
      "state": false,
      "name": "VHF Marine 1",
      "id": "VHF Marine 1",
      "index": 0
    },
    "VHF Marine 2": {
      "position": {},
      "radius": 1.8,
      "height": null,
      "state": false,
      "name": "VHF Marine 2",
      "id": "VHF Marine 2",
      "index": 0
    },
    "VHF Marine 3": {
      "position": {},
      "radius": 1.8,
      "height": null,
      "state": false,
      "name": "VHF Marine 3",
      "id": "VHF Marine 3",
      "index": 0
    },
    "VHF Marine 4": {
      "position": {},
      "radius": 1.8,
      "height": null,
      "state": false,
      "name": "VHF Marine 4",
      "id": "VHF Marine 4",
      "index": 0
    },
    "VHF/UHF Air #1": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #1",
      "id": "VHF/UHF Air #1",
      "index": 0
    },
    "VHF/UHF Air #2": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #2",
      "id": "VHF/UHF Air #2",
      "index": 0
    },
    "VHF/UHF Air #3": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #3",
      "id": "VHF/UHF Air #3",
      "index": 0
    },
    "VHF/UHF Air #4": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #4",
      "id": "VHF/UHF Air #4",
      "index": 0
    },
    "VHF/UHF Air #5": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #5",
      "id": "VHF/UHF Air #5",
      "index": 0
    },
    "VHF/UHF Air #6": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #6",
      "id": "VHF/UHF Air #6",
      "index": 0
    },
    "VHF/UHF Air #7": {
      "position": {},
      "radius": 3.2,
      "height": null,
      "state": false,
      "name": "VHF/UHF Air #7",
      "id": "VHF/UHF Air #7",
      "index": 0
    },
    "XBand Navigation Radar": {
      "position": {},
      "radius": 9,
      "height": null,
      "state": false,
      "name": "XBand Navigation Radar",
      "id": "XBand Navigation Radar",
      "index": 0
    },
    "XBand SATCOM PORT": {
      "position": {},
      "radius": 82,
      "height": null,
      "state": false,
      "name": "XBand SATCOM PORT",
      "id": "XBand SATCOM PORT",
      "index": 0
    },
    "XBand SATCOM STBD": {
      "position": {},
      "radius": 82,
      "height": null,
      "state": false,
      "name": "XBand SATCOM STBD",
      "id": "XBand SATCOM STBD",
      "index": 0
    }
  }

  aloft_comps = {
    "BRIDGE_TOP": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Bridge Top", "id": "BRIDGE_TOP", "index": 0 }
    , "HANGAR_TOP": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Hangar Top", "id": "HANGAR_TOP", "index": 0 }
    , "MAST": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Mast", "id": "MAST", "index": 0 }
    , "FUNNEL_TOP": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Funnel Top", "id": "FUNNEL_TOP", "index": 0 }
    , "HELO_TOP": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Helo Top", "id": "HELO_TOP", "index": 0 }
    , "DIVER_DOWN": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Diver Down", "id": "DIVER_DOWN", "index": 0 }
    , "INTAKES_TOP": { "position": {}, "radius": 1, "height": null, "state": false, "name": "Intakes Top", "id": "INTAKES_TOP", "index": 0 }
  }
  aloft_comps_2 = JSON.parse(JSON.stringify(this.aloft_comps));
  aloft_comps_3 = { "bridge_top": { "position": {}, "radius": 1, "height": null, "state": false, "name": "bridge_top", "id": "bridge_top", "index": 0 }, "aft_mast_area": { "position": {}, "radius": 1, "height": null, "state": false, "name": "aft_mast_area", "id": "aft_mast_area", "index": 0 }, "boat_deck": { "position": {}, "radius": 1, "height": null, "state": false, "name": "boat_deck", "id": "boat_deck", "index": 0 }, "flight_deck": { "position": {}, "radius": 1, "height": null, "state": false, "name": "flight_deck", "id": "flight_deck", "index": 0 }, "forecastle": { "position": {}, "radius": 1, "height": null, "state": false, "name": "forecastle", "id": "forecastle", "index": 0 }, "funnel_area": { "position": {}, "radius": 1, "height": null, "state": false, "name": "funnel_area", "id": "funnel_area", "index": 0 }, "fwd_mast_area": { "position": {}, "radius": 1, "height": null, "state": false, "name": "fwd_mast_area", "id": "fwd_mast_area", "index": 0 }, "quarterdeck": { "position": {}, "radius": 1, "height": null, "state": false, "name": "quarterdeck", "id": "quarterdeck", "index": 0 } }
  radhaz_comps_2nd = this.clone(this.radhaz_comps_2);
  aloft_comps_2nd = this.clone(this.aloft_comps_2);
  showRadHazDemo() {

    this.setVenueLightsIntensity(3.5);
    this.createBasicShapes();
    this.activityServ.init(this.datauxview);
    this.generateCompCols();
    this.addRadHazDemoObj();
    this.apploadingStatus = true;
  }
  generateCompCols() {
    for (let m in this.radhaz_comps) {
      let cdata = this.radhaz_comps[m];
      let col = cdata.color;
      if (!col) {
        col = "#FFA500"
      }
      this.addNewProfileColor(col);
    }
    //#ff0000
    this.addNewProfileColor('#bb0000', true, "", null, 0.8);
    this.addNewProfileColor('#00ff00');
    this.addNewProfileColor('#ff0000');
    this.addNewProfileColor('#337e9f');
    this.addNewProfileColor('#aaEEaa');
  }
  addShipToVenue(shipobj) {
    let shape = shipobj.class;
    let id = shipobj.id;
    let orientation = shipobj.orientation || { x: 0, y: 0, z: 0 };
    let position = shipobj.position || { x: 0, y: 0, z: 0 };
    let profiles = {
      regular: { material: 'custom-included' },
      invisible: { material: 'custom-included', visible: false },
      red: { material: 'envelope_red' }
    };
    let settings = { 'geometry': { 'orientation': orientation, 'position': position, 'size': 1 } };
    this.datauxview.addElement(shape, id, profiles, settings);
  }
  addRadHazDemoObj() {
    this.ship_map["hfx_radhaz"] = { name: "HMCS Halifax", colluded: false }
    this.ship_map["hfx_radhaz_2"] = { name: "HMCS Vancouver", colluded: false }
    this.ship_map["hfx_radhaz_3"] = { name: "AOPS", colluded: false }
    let ship1 = { class: "Halifax", id: "hfx_radhaz", orientation: { x: 0, y: 0, z: 0 }, position: { x: 30, y: 0, z: 0 } };
    let ship2 = { class: "KYS_AOPS", id: "hfx_radhaz_3", orientation: { x: 0, y: 0, z: 0 }, position: { x: -30, y: -4, z: 40 } };
    let ship3 = { class: "Halifax", id: "hfx_radhaz_2", orientation: { x: 0, y: 0, z: 0 }, position: { x: -30, y: 0, z: 0 } };
    this.addShipToVenue(ship1);
    this.addShipToVenue(ship2);
    this.addShipToVenue(ship3);
    let hfx = this.datauxview.getElementId(ship1.id);
    let hfx2 = this.datauxview.getElementId(ship3.id);
    let hfx3 = this.datauxview.getElementId(ship2.id);
    let m = this.dfx.getElementMesh(hfx);
    let m2 = this.dfx.getElementMesh(hfx3);
    let m3 = this.getMesh(ship3.id);
    this.processHFXForRHMAT(m);
    this.processHFXForRHMAT(m2, true);
    this.processHFXForRHMAT(m3);
    this.collision_ships.push(m);
    this.collision_ships.push(m2);
    this.collision_ships.push(m3);
    let c = this.getChildMeshEx("hfx_radhaz", "WARNINGS_V1");
    c.setEnabled(false);
    c = this.getChildMeshEx("hfx_radhaz_2", "WARNINGS_V1");
    c.setEnabled(false);
    /* let c1 = this.getChildTransEx("hfx_radhaz_3", "RadHaz MELS");
    c1.setEnabled(false); */

    this.processHFXForRH('hfx_radhaz', this.radhaz_comps);
    this.processHFXForRH('hfx_radhaz_2', this.radhaz_comps_2);
    this.processHFXForRH('hfx_radhaz_3', this.radhaz_comps_3);
    this.processHFXForRH('hfx_radhaz', this.aloft_comps, true);
    this.processHFXForRH('hfx_radhaz_2', this.aloft_comps_2, true);
    this.processHFXForRH('hfx_radhaz_3', this.aloft_comps_3, false);
    this.moveCameraTo(null, { "target": { "x": 0, "y": 0, "z": 0 }, "distance": 340, "yaw": 0, "pitch": 15 })
    this.showLoading = !true;

    this.activityServ.createCylinderModel_RADHAZ(this.radhaz_comps, 'hfx_radhaz');
    this.activityServ.createCylinderModel_RADHAZ(this.radhaz_comps_2, 'hfx_radhaz_2');
    this.dragDemoShip(m);
    this.dragDemoShip(m2);
    this.dragDemoShip(m3);
    /* this.attachEventForRadhaz(hfx)
    this.attachEventForRadhaz(hfx2)
    this.attachEventForRadhaz(hfx3) */
    this.showHideRHIndiAll(false, '_3');
    m2.setEnabled(false);
  }
  dragDemoShip(m2) {
    this.enableDrag(m2);
    let bh = m2.custombehav;
    bh.onDragObservable.add((event) => {
      this.checkCollisions();
    })
    bh.onDragEndObservable.add((event) => {
      this.checkCollisions();
    })
    /* bh.onDragStartObservable.add((event) => {

   }) */
  }
  setElemProfile(id, profile) {
    let el = this.datauxview.getElementId(id);
    this.dfx.modify(el, profile);
  }
  setMeshProfile(id, mat) {
    let el = this.getMesh(id);
    el.material = mat;
  }
  setShipProfile(ship, profile, sid = "") {
    let el = sid == 'hfx_radhaz_3' ? ship : ship.getChildren()[0];
    let c = el.getChildMeshes();
    let scene = this.dfx.getCamera().getScene();
    let mat = profile === 'regular' ? 'def' : scene.getMaterialByName(profile);
    c.forEach((m) => {
      if (m.parent.name.includes(" MELS")) {
        return;
      }
      let def = m.defMat;
      let _mat = mat === 'def' ? scene.getMaterialByName(def) : mat;
      m.material = _mat;
    })
  }
  /**
   * code to toggle AOPS
   */
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
  ship_2_name = "HMCS VANCOUVER"
  toggleDemoShips(s = 'AOPS') {
    this.ship_2_name = s;
    let ship2 = this.getMesh("hfx_radhaz_2");
    let ship3 = this.getMesh("hfx_radhaz_3");
    this.resetDemoShipProfile();
    if (s === 'AOPS') {
      ship3.setEnabled(true);
      ship2.setEnabled(false);
      this.radhaz_comps_2nd = (this.radhaz_comps_3);
      this.aloft_comps_2nd = (this.aloft_comps_3);
    } else {
      ship3.setEnabled(!true);
      ship2.setEnabled(!false);
      this.radhaz_comps_2nd = (this.radhaz_comps_2);
      this.aloft_comps_2nd = (this.aloft_comps_2);
    }
  }
  checkCollisions() {
    this.resetDemoShipProfile();
    /* this.collision_db={}
     this.collision_ships.forEach((ship)=>{
      this.checkCollision(ship);
     }) */
    this.ship_map["hfx_radhaz"].colluded = false;
    this.ship_map["hfx_radhaz_2"].colluded = false;
    this.ship_map["hfx_radhaz_3"].colluded = false;
    this.resetMACollision(this.aloft_comps);
    this.resetMACollision(this.aloft_comps_2);
    this.resetMACollision(this.aloft_comps_3);
    this.checkSelfCollision("hfx_radhaz", this.radhaz_comps, this.aloft_comps);
    if (this.ship_2_name === 'AOPS') {
      this.checkSelfCollision("hfx_radhaz_3", this.radhaz_comps_3, this.aloft_comps_3);
    } else {
      this.checkSelfCollision("hfx_radhaz_2", this.radhaz_comps_2, this.aloft_comps_2);
    }
    this.reapplyProfiles("hfx_radhaz", this.radhaz_comps, this.aloft_comps)
    this.reapplyProfiles("hfx_radhaz_2", this.radhaz_comps_2, this.aloft_comps_2)
    this.reapplyProfiles("hfx_radhaz_3", this.radhaz_comps_3, this.aloft_comps_3)
  }
  collision_db = {}
  checkCollision(m) {

  }
  reapplyProfiles(ship, src, comp) {
    let scene = this.dfx.getCamera().getScene();
    let p = ship === "hfx_radhaz" ? "" : "_2";
    p = ship === "hfx_radhaz_3" ? "_3" : p;
    if (this.ship_map[ship].colluded) {
      return;
    }
    for (let m in src) {
      let item = src[m];
      let id = item.id;
      let mesh = this.getChildMeshEx(ship, id);
      let istate = item.istate
      let estate = item.state
      let matid = mesh.defMat;
      if (estate) {
        matid = item.matid;
      }
      if (istate) {
        //matid = item.matid2;
      }
      if (item.incollision && item.incollision.length) {

      }

      let mat = scene.getMaterialByName(matid);
      mesh.material = mat;
    }
    for (let m in comp) {
      let item = comp[m];
      let id = item.id + this['aloft_version' + p];
      let mesh = this.getChildMeshEx(ship, id);
      if (mesh) {
        let istate = item.istate
        let estate = item.state
        let matid = mesh.defMat;
        let mat3 = this.isDiverEnvp(id) ? item.matid4 : item.matid3
        if (estate) {
          matid = item.matid5;
        }
        if (istate) {
          matid = mat3;
        }
        if (item.colluded) {
          matid = "envelope_red"
        }

        let mat = scene.getMaterialByName(matid);
        mesh.material = mat;
      }
    }
  }
  resetMACollision(comp) {
    for (let m in comp) {
      comp[m].colluded = false;
    }
  }
  checkSelfCollision(ship, src, comp) {
    let keys = Object.keys(src);
    /* for(let m in comp){
      comp[m].colluded=false;
    } */
    keys.forEach((s) => {
      let sobj = src[s];
      let state = sobj.istate;
      //if(state){
      let id = sobj.id;
      let key = s + '-' + ship;
      let k = 'envelope-' + key;
      let mel = this.activityServ.radhaz_cylinders[ship] ? this.activityServ.radhaz_cylinders[ship][k] : null;
      let mmel = mel ? this.dfx.getElementMesh(mel) : null;
      let aops = this.radhaz_demo_mode && this.ship_2_name === 'AOPS' && ship == "hfx_radhaz_3";
      let rad = sobj.radius
      if (aops) {
        ship = "hfx_radhaz_3"
        mmel = this.getChildMeshEx(ship, s + " MEL");
        key = s;
        rad = rad * 2
      }
      if (!mmel) {
        sobj.incollision = []
        return
      }
      let ship_name = this.radhaz_demo_mode ? this.getMesh(ship).name : ship;
      let colls = this.checkCollisionWithMA(ship, mmel, comp, rad);
      let colls2 = this.checkCollisionWithShipsMA(ship, mmel, rad);
      let colls3 = this.radhaz_demo_mode ? this.checkCollisionWithShips(ship_name, mmel, rad) : [];
      sobj.incollision = [].concat(colls, colls2, colls3);
      mmel.oncollision = sobj.incollision && sobj.incollision.length;
      if (state) {
        if (aops) {
          this.activityServ.showHideRHCylinderMesh(mmel, sobj.istate, ship);
        } else {
          this.activityServ.showHideRHCylinder(key, sobj.istate, ship);
        }

      }
      //}
    })
  }
  checkCollisionWithMA(ship, mel, comp, rad) {
    let ckeys = Object.keys(comp);
    let colls = [];
    let p = ship === "hfx_radhaz" ? "" : "_2"
    let sid = this.getDemoShipName(ship);
    ckeys.forEach((s) => {
      let sobj = comp[s];
      let state = sobj.istate;
      if (state && mel.isVisible) {
        let id = sobj.id + this['aloft_version' + p];
        let mesh = this.getChildMeshEx(ship, id);
        if (mel.intersectsMesh(mesh, !true) && this.verifyCollision2(mel, mesh, rad)) {
          colls.push(sid + "/" + sobj.name);
          sobj.colluded = true;
        } else {
          //sobj.colluded=!true;
        }
      } else {
        //sobj.colluded=!true;
      }
    })
    return colls;
  }
  checkCollisionWithShips(cship, mel, rad) {
    let colls = []
    let sid;
    this.collision_ships.forEach((ship) => {
      if (cship != ship.name && ship.isEnabled()) {
        sid = ship.name.split("element-")[1];
        let act = false;
        if (mel.isVisible) {
          let comps = ship.getChildMeshes();
          let boo = false;
          comps.every((c) => {
            let diver = this.isDiverEnvp(c.name);
            if (!c.isEnabled()) {
              return true
            }
            if (!c.isVisible || (diver && !this.isDiverDown(sid))) {
              return true
            }
            if (mel.intersectsMesh(c, !true) && this.verifyCollision2(mel, c, rad)) {

              if (diver) {
                boo = false;
                this.diverCompColluded(sid);
                let _sid = this.getDemoShipName(sid);
                colls.push("DIVER DOWN (" + _sid + ")");
              } else {
                boo = true;
              }
              console.log("Inter", c.name);
              return false;
            }
            return true
          })
          if (boo) {
            let _sid = sid;
            if (this.ship_map[sid]) {
              _sid = this.ship_map[sid].name;
              this.ship_map[sid].colluded = true;
            }
            colls.push(_sid);

            act = true;
          } else {
            //this.setMeshProfile(sid,{profile:'regular'})
          }
        }
        if (act) {
          this.setShipProfile(ship, 'envelope_red', sid)
        } else {
          // this.setShipProfile(ship,'regular')
        }
      }
    })
    return colls;
  }
  checkCollisionWithShipsMA(cship, mel, rad) {
    let colls = []
    let sid;
    this.collision_ships.forEach((ship) => {
      if (ship.isEnabled()) {
        sid = ship.name.split("element-")[1];
        let act = false;
        if (sid === cship) {
          return false;
        }
        let comp = sid === 'hfx_radhaz' ? this.aloft_comps : this.aloft_comps_2;
        comp = sid === 'hfx_radhaz_3' ? this.aloft_comps_3 : comp;
        if (mel.isVisible) {
          colls = colls.concat(this.checkCollisionWithMA(sid, mel, comp, rad))
        }
        /* if (act) {
          this.setShipProfile(ship, 'envelope_red')
        } else {
          // this.setShipProfile(ship,'regular')
        } */
      }
    })
    return colls;
  }
  verifyCollision(m1, m2, r) {
    let p1 = m1.getAbsolutePosition();
    let p2 = m2.getAbsolutePosition();
    let d = this.distance3(p1, p2);
    let r1 = m2.getBoundingInfo().boundingSphere.radiusWorld;
    let dr = d - r1;
    return dr <= (r / 2);
  }
  verifyCollision2(m1, m2, dia) {
    let sphere = m1.getAbsolutePosition();
    let min = m2.getBoundingInfo().boundingBox.minimumWorld;
    let max = m2.getBoundingInfo().boundingBox.maximumWorld;
    let box = { minX: min.x, minY: min.y, minZ: min.z, maxX: max.x, maxY: max.y, maxZ: max.z }
    // get box closest point to sphere center by clamping
    var x = Math.max(box.minX, Math.min(sphere.x, box.maxX));
    var y = Math.max(box.minY, Math.min(sphere.y, box.maxY));
    var z = Math.max(box.minZ, Math.min(sphere.z, box.maxZ));

    // this is the same as isPointInsideSphere
    var distance = Math.sqrt((x - sphere.x) * (x - sphere.x) +
      (y - sphere.y) * (y - sphere.y) +
      (z - sphere.z) * (z - sphere.z));

    return distance < dia / 2;
  }
  xcheckCollision(cship) {

    //let melobj=ship.getChildren();
    let mels = cship.getChildren();
    let sid
    this.collision_ships.forEach((ship) => {
      if (cship.name != ship.name && ship.isEnabled()) {
        sid = ship.name.split("element-")[1];
        let act = false;

        this.collision_db[sid] = []

        mels.forEach((m) => {
          let mel = m;
          if (m.name.includes("envelope-") && mel.isVisible) {
            if (ship.intersectsMesh(mel, !true)) {
              //this.setMeshProfile(sid,{profile:'red'})
              this.collision_db[sid].push(this.getMelName(m.name));
              act = true;
            } else {
              //this.setMeshProfile(sid,{profile:'regular'})
            }
          }
        })
        if (act) {
          this.setShipProfile(ship, 'envelope_red', sid)
        } else {
          this.setShipProfile(ship, 'regular', sid)
        }
      }
    })

  }
  getDemoShipName(sid) {
    let _sid = sid;
    if (this.ship_map[sid]) {
      _sid = this.ship_map[sid].name;

    }
    return _sid
  }
  isDiverEnvp(e) {
    return e.includes("DIVER");
  }
  isDiverDown(ship) {
    let comp = this.aloft_comps_2
    if (ship === 'hfx_radhaz') {
      comp = this.aloft_comps;
    }
    return comp["DIVER_DOWN"].istate
  }
  diverCompColluded(ship) {
    let comp = this.aloft_comps_2
    if (ship === 'hfx_radhaz') {
      comp = this.aloft_comps;
    }
    comp["DIVER_DOWN"].colluded = true;
  }
  getMelName(str) {
    let arr = str.split("-")[2].split("__");
    return arr[1];
  }
  resetDemoShipProfile() {
    let sid
    this.collision_ships.forEach((ship) => {
      if (ship.isEnabled()) {
        sid = ship.name.split("element-")[1];
        this.setShipProfile(ship, 'regular', sid)
      }
    })
  }
  processHFXForRHMAT(m, p = false) {
    let mesh = p ? m : m.getChildren()[0];
    let meshes = mesh.getChildMeshes();
    meshes.forEach((m) => {
      let n = m.material.name;
      m.defMat = n;
    })
  }
  processHFXForRH(m, cp, hide = false) {
    let comps = Object.keys(cp);
    let scene = this.dfx.getCamera().getScene();
    comps.forEach((c) => {
      let id = cp[c].id
      let child = this.getChildMeshEx(m, id);
      let p = cp[c].color || "#FFA500";
      let p2 = cp[c].color2 || "#00ff00";
      let p3 = cp[c].color3 || "#ffff00";
      let p4 = cp[c].color4 || "#337e9f";
      let p5 = cp[c].color5 || "#aaEEaa";
      let matid = "dfx_" + p;
      let matid2 = "dfx_" + p3 + "_transparent";
      let matid3 = "dfx_" + p2 + "_transparent";
      let matid4 = "dfx_" + p4 + "_transparent";
      let matid5 = "dfx_" + p5 + "_transparent";
      /* let mat=scene.getMaterialByName(matid);
      child.material=mat; */
      cp[c].matid = matid;
      cp[c].matid2 = matid2;
      cp[c].matid3 = matid3;
      cp[c].matid4 = matid4;
      cp[c].matid5 = matid5;
      cp[c].position = child.position;
      if (hide) {
        child.isPickable = false;
      }
    });
  }
  showHideRHIndicator(id, boo, p = "") {
    let aops = this.radhaz_demo_mode && (p === "_3" || (this.ship_2_name === 'AOPS' && p != ""));
    let cp = this['radhaz_comps' + p];
    let key = id + "-hfx_radhaz" + p;
    if (aops) {
      key = this.getChildMeshEx('hfx_radhaz_3', id + " MEL");
      this.activityServ.showHideRHCylinderMesh(key, boo, 'hfx_radhaz_3');
    } else {
      this.activityServ.showHideRHCylinder(key, boo, 'hfx_radhaz' + p);
    }

    cp[id].istate = boo;
    if (boo && !cp[id].state) {
      this.showHideRHComp(id, boo, p);
    }
    if (!boo && cp[id].state) {
      this.showHideRHComp(id, true, p);
    }

    this.checkCollisions()

  }
  showHideRHIndicator_wf(id, boo, p = "") {
    let key = id + "-hfx_radhaz" + p;
    let aops = this.radhaz_demo_mode && this.ship_2_name === 'AOPS';
    let ship = 'hfx_radhaz' + p
    if (aops) {
      ship = "hfx_radhaz_3";
      key = this.getChildMeshEx(ship, id + " MEL");
    }
    this.activityServ.showHideRHCylinder_wf(key, boo, ship);
  }
  showHideRHComp(id, boo, p = "") {
    let cp = this['radhaz_comps' + p];
    let c = cp[id].id;
    let scene = this.dfx.getCamera().getScene();
    let m = this.getChildMeshEx("hfx_radhaz" + p, c);
    let matid = /* cp[id].istate ? cp[id].matid2 : */ cp[id].matid;
    let mat1 = scene.getMaterialByName(matid);
    let mat2 = scene.getMaterialByName(m.defMat);
    let mat = boo ? mat1 : mat2;
    m.material = mat;
    cp[id].state = boo;
  }
  showHideRHCompAll(boo, p = "") {
    let cp = this['radhaz_comps' + p];
    let comps = Object.keys(cp);
    comps.forEach((c) => {
      this.showHideRHComp(c, boo, p);
    });
  }
  showHideRHIndiAll(boo, p = "") {
    let cp = this['radhaz_comps' + p];
    let comps = Object.keys(cp);
    comps.forEach((c) => {
      this.showHideRHIndicator(c, boo, p);
    });
  }
  /**man-aloft */
  toggleMAVersions() {
    this.toggleMAVersion()
    this.toggleMAVersion('_2');
  }
  toggleMAVersion(p = "") {
    let av = this['aloft_version' + p];
    if (av) {
      this['aloft_version' + p] = ""
      let w = this.getChildMeshEx("hfx_radhaz" + p, "WARNINGS");
      w.setEnabled(true);
      w = this.getChildMeshEx("hfx_radhaz" + p, "WARNINGS_V1");
      w.setEnabled(false);
    } else {
      this['aloft_version' + p] = "_v1";
      let w = this.getChildMeshEx("hfx_radhaz" + p, "WARNINGS");
      w.setEnabled(false);
      w = this.getChildMeshEx("hfx_radhaz" + p, "WARNINGS_V1");
      w.setEnabled(true);
    }
    let cp = this['aloft_comps' + p];
    let comps = Object.keys(cp);
    comps.forEach((c) => {
      let boo = cp[c].istate || cp[c].state
      this.showHideMAComp(c, boo, p);
    });
    this.checkCollisions()
  }
  showHideMAIndicator(id, boo, p = "") {
    let cp = this['aloft_comps' + p];
    cp[id].istate = cp[id].state = boo;
    if (boo && !cp[id].state) {

    }
    if (!boo && cp[id].state) {
      this.showHideMAComp(id, true, p);
    } else {
      this.showHideMAComp(id, boo, p);
    }


    this.checkCollisions()

  }
  aloft_version = "";
  aloft_version_2 = "";
  aloft_version_3 = "";
  showHideMAComp(id, boo, p = "") {
    let cp = this['aloft_comps' + p];
    let c = cp[id].id + this['aloft_version' + p];
    let scene = this.dfx.getCamera().getScene();
    let m = this.getChildMeshEx("hfx_radhaz" + p, c);
    if (!m) {
      return
    }
    let mat3 = this.isDiverEnvp(c) ? cp[id].matid4 : cp[id].matid3
    let matid = cp[id].istate ? mat3 : cp[id].matid5;
    let mat1 = scene.getMaterialByName(matid);
    let mat2 = scene.getMaterialByName(m.defMat);
    let mat = boo ? mat1 : mat2;
    m.material = null;
    m.material = mat;
    m.hilited = boo;
    cp[id].state = boo;
  }
  showHideMACompAll(boo, p = "") {
    let cp = this['aloft_comps' + p];
    let comps = Object.keys(cp);
    comps.forEach((c) => {
      this.showHideMAComp(c, boo, p);
    });
  }
  createContext(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
  texCAN
  getTexture(w = 8, h = 8, col = "#ffffff", tex = null) {
    if (!this.texCAN) {
      this.texCAN = this.createContext(w, h)
    }
    let ctx = this.texCAN.getContext("2d");
    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    ctx.rect(0, 0, w, h);
    ctx.fillStyle = col;
    ctx.fill();
    if (tex) {
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      ctx.fillText(tex, w / 2, h / 2);
    }
    let png = this.texCAN.toDataURL();
    return png;
  }
  getHexToRGB(hex) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [parseInt(result[1], 16) / 255, parseInt(result[2], 16) / 255, parseInt(result[3], 16) / 255] : [0, 0, 0];
  }
  addNewProfileColor(col, addTex = true, prefix = "", model = null, trans = 0.3, bfc = true) {
    if (!col) {
      return;
    }
    let pcol = this.color_map[col];
    if (!pcol) {
      let dfx = this.dfx;
      let obj = { "id": "dfx_col1", "diffuse": [1, 1, 1], "specular": [0, 0, 0], "specularPower": 25, "ambient": [1, 1, 1], "emissive": [0, 0, 0], "backFaceCulling": bfc }
      let obj_transp = { "id": "dfx_col2_transparent", "diffuse": [1, 1, 1], "alpha": trans, "specular": [0, 0, 0], "specularPower": 25, "ambient": [1, 1, 1], "emissive": [0, 0, 0], "backFaceCulling": bfc }
      obj.id = prefix + "dfx_" + col;
      obj.diffuse = this.getHexToRGB(col);
      obj.ambient = [obj.diffuse[0] / 4, obj.diffuse[1] / 4, obj.diffuse[2] / 4]
      //obj.emissive = [obj.diffuse[0] / 6, obj.diffuse[1] / 6, obj.diffuse[2] / 6]
      if (addTex) {
        obj['diffuseTexture'] = { "name": this.getTexture(8, 8, col) }
      } else {

      }
      //obj.ambient = obj.diffuse;
      let mat = [obj];
      dfx.addNewMaterials(mat);
      obj_transp.id = prefix + "dfx_" + col + "_transparent";
      obj_transp.diffuse = obj.diffuse;
      obj_transp.ambient = obj.ambient;
      obj_transp.emissive = obj.emissive;
      if (addTex) {
        obj_transp['diffuseTexture'] = obj['diffuseTexture']
      } else {
      }
      //obj_transp.ambient = obj.diffuse;
      obj_transp.alpha = trans;
      let mat2 = [obj_transp];
      dfx.addNewMaterials(mat2);


      this.color_map[col] = prefix + "dfx_" + col
    }
    return this.color_map[col];
  }
  getActiveComp() {
    const hit = this.dfx.getHitPosition();
    if (!hit.hit) {
      return null;
    }
    const hpt = hit.pickedPoint;
    return [hit.pickedMesh, hpt];
  }
  checkAndToggleRHState(id, comps, p) {
    let items = this.getItems(id, comps);
    items.forEach((i) => {
      let item = comps[i];
      item.istate = !item.istate;
      this.showHideRHIndicator(i, item.istate, p)
    })
  }
  getItems(id, comps) {
    let items = []
    for (let m in comps) {
      if (comps[m].id === id) {
        items.push(m);
      }
    }
    return items;
  }
  rhdemo_rhlabel
  attachEventForRadhaz(el) {
    this.dfx.attach(el, {
      actions: {
        pickLeft: [(evt, elem) => {
          if (evt.button === 0) {
            let props = this.dfx.props(el);
            let act = this.getActiveComp();
            if (act) {
              let id = this.getMeshName(null, act[0]);
              let ship = this.getShipName(act[0].name);
              let comp: any = this.radhaz_comps
              let p = ""
              if (ship == 'hfx_radhaz_2') {
                comp = this.radhaz_comps_2;
                p = "_2";
              }
              if (ship == 'hfx_radhaz_3') {
                comp = this.radhaz_comps_3;
                p = "_3";
              }
              this.checkAndToggleRHState(id, comp, p);
              //this.broadcastInfo({ src: 'main', event: 'showHideRHComp', data: id, state: null, sub: null });
            }
            /* this.tagServ.showKioskTag(props.id, true)
            console.log("pickLeft", props) */
          }
        }],
        hoverOn: [(evt, elem) => {
          let props = this.dfx.props(el);
          let act = this.getActiveComp();
          if (act) {
            let ship = this.getShipName(act[0].name);
            let comp: any = this.radhaz_comps
            if (ship == 'hfx_radhaz_2') {
              comp = this.radhaz_comps_2;
            }
            if (ship == 'hfx_radhaz_3') {
              comp = this.radhaz_comps_3;
            }
            let id = this.getMeshName(null, act[0]);
            let rh = this.getItems(id, comp);
            if (rh.length) {
              let mpos = this.getMesh2DPos(act[0]);
              let pos = mpos.position;
              this.rhdemo_rhlabel = comp[rh[0]].name;
              this.tagServ.showTag("rhdemo", pos[0], pos[1]);
            } else {
              this.tagServ.hideTag("rhdemo");
            }

          }


        }],
        hoverOff: [(evt, elem) => {
          this.tagServ.hideTag("rhdemo");
        }]
      }
    });
  }
  getMesh2DPos(mesh) {
    const camera = this.dfx.getCamera();
    const position2D = [0, 0];
    const position = mesh
      ? [mesh.position.x.toFixed(2),
      mesh.position.y.toFixed(2),
      mesh.position.z.toFixed(2)]
      : [0, 0, 0];
    let mesh_position = mesh
      ? {
        x: mesh.position.x,
        y: mesh.position.y,
        z: mesh.position.z
      }
      : { x: 0, y: 0, z: 0 };
    if (mesh) {

      try {
        mesh_position = mesh.getBoundingInfo().boundingBox.centerWorld;

      } catch (err) { }
    }
    let visibility = false;
    // if the element is not supposed to be visible, then bail immediately
    // and avoid costly transformCoordinates steps below
    if ((mesh && mesh.isVisible)
    ) {
      // Check if the element is within the view frustum
      var vectorsWorld = mesh.getBoundingInfo().boundingBox.vectorsWorld;
      const ht = Number(vectorsWorld[1].y - (vectorsWorld[0].y))
      mesh_position.y = (vectorsWorld[0].y + ht);

      const viewMatrix = camera.getViewMatrix();
      const projectionMatrix = camera.getProjectionMatrix();
      // Transform the mesh's world position to datascape
      // 2D position (ranging from -1 to 1)
      const posCamera =
        BABYLON.Vector3.TransformCoordinates(mesh_position, viewMatrix);
      // If any of the coordinates are NaN, then mesh is
      // outside viewing frustum and is not visible
      if (!isNaN(posCamera.x)
        && (!isNaN(posCamera.y)
          && !isNaN(posCamera.z))) {
        const posPlus1Minus1 =
          BABYLON.Vector3.TransformCoordinates(posCamera, projectionMatrix);
        // Determine whether element is within canvas bounds
        // (i.e., must be within -1 to 1 range) to set visibility
        // one last time
        visibility =
          ((posPlus1Minus1.x > -1 && posPlus1Minus1.x < 1)
            && (posPlus1Minus1.y > -1 && posPlus1Minus1.y < 1));
        // Map the [-1 to 1] coordinates to canvas dimensions
        const canvas = this.datauxview.rendererCanvas.nativeElement;
        // eslint-disable-next-line no-undef
        const devicePixelRatio = window.devicePixelRatio || 1;
        const canvasPosX = (canvas.width / devicePixelRatio)
          * (posPlus1Minus1.x + 1.0) * 0.5;
        const canvasPosY = (canvas.height / devicePixelRatio)
          * (posPlus1Minus1.y + 1.0) * 0.5;
        position2D[0] = Math.floor(canvasPosX + 0.5);
        position2D[1] = Math.floor(canvasPosY + 0.5);
      }
    }
    return {
      position: position2D,
      visibility
    };
  }
  getShipName(id) {
    if (!id) {
      return "";
    }
    return id.split(".")[0].split("element-")[1];
  }
  /**
  * first aid area start
  */

  /* * *
  * method for get first aid data from server
  * * */
  getFirstAidData(cbck) {
    this.fistAidJson = [];
    this.configService.getFristAidData().then((fistAidJson: any) => {
      if (fistAidJson) {
        this.fistAidJson = fistAidJson.map(v => ({ ...v, expand: false }));
        // this.fistAidJson = fistAidJson;
        console.log("fistAidJson", this.fistAidJson);
        cbck(true)
      } else {
        this.openPublishDialog('fistAidJson data not found !!');
        cbck(false)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  createFristAid(obj) {
    this.configService.createFirstAid(obj).then(data => {
      if (data) {
        console.log("first aid created ", data)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  updateFirstAidArea(_id, obj) {
    this.configService.updateFirstAid(_id, obj).then(data => {
      if (data) {
        console.log("first aid updated ", data)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }
  deleteFristAid(_id) {
    this.configService.deleteFirstAid(_id).then(data => {
      if (data) {
        console.log("first aid deleted ", data)
      }
    }).catch((error) => {
      console.log("error ", error)
    });
  }

  locationPinObjects = {};
  selectedLocationId;
  selectedLocationObj;
  locationPinColor = ['red', 'orange', 'green']
  addLocationPin(id, pos, material) {
    let shape = 'aed_pin_' + material;
    let profiles = {
      regular: { material: 'custom-included' },
      invisible: { material: 'custom-included', visible: false },
      highlight: { material: 'custom-included' },
      location_red: { material: 'location_red' },
      location_orange: { material: 'location_orange' },
      location_green: { material: 'location_green' }
    };
    if (pos.x > 0) {
      pos.x = -pos.x;

    }
    let settings = { 'geometry': { 'orientation': { x: 0, y: 0, z: 0 }, 'position': pos, 'size': 3 } };
    this.datauxview.addElement(shape, id, profiles, settings);
    this.locationPinObjects[id] = this.datauxview.getElementId(id);
    this.locationPinObjects[id + '_profile'] = material;
    // this.setLocationPinColor(id, material);
    let mat = (this.fmfmode === 'exterior' ? 'invisible' : null);
    if (mat) {
      this.dfx.modify(this.locationPinObjects[id], { profile: mat });
    }

    this.attchStaticObjEvent(this.locationPinObjects[id]);
  }
  applyPinColorIntesity() {
    let o = this.locationPinObjects;
    let arr = []
    for (let m in o) {
      let el = o[m];
      let mesh = this.dfx.getElementMesh(el);
      if (mesh) {
        arr.push(mesh);
      }
    }
    let scene: any = window["scene"];
    scene.lights[4].includedOnlyMeshes.push(...arr);
    scene.lights[4].intensity = 10;
  }
  removeLocationPin(id) {
    let el = this.locationPinObjects[id];
    this.dfx.remove(el)
    this.locationPinObjects[id] = null;
    delete this.locationPinObjects[id];
  }
  moveLocationPin(id) {
    let m = this.getMesh(id);
    this.enableDrag(m)
  }
  moveLocationPinStop(id) {
    this.removeDrag(id)
  }
  setLocationPinColor(id, prf) {
    let el = this.locationPinObjects[id];
    let props = this.dfx.props(el);
    let pos = props.geometry.position;
    //this.dfx.modify(el, { profile: prf });
    this.removeLocationPin(id);
    this.addLocationPin(id, pos, prf);
  }
  setLocationPinArea() {
    this.fistAidJson.forEach(obj => {
      var material = this.locationPinColor[Math.floor(Math.random() * this.locationPinColor.length)];
      if (obj['position']) {
        obj['color'] = material;
        this.addLocationPin(obj['_id'], obj.position, material);
      } else {
        obj['color'] = material;
      }
    });
    //this.applyPinColorIntesity();
  }
  updateLocationPinPos(pos, objPos) {
    this.fistAidJson.forEach(pin => {
      if (pin['_id'] === this.selectedLocationId) {
        let el = this.datauxview.getElementId(this.selectedLocationId);
        this.dfx.modify(el, { 'geometry': { 'position': objPos } })
        pin['position'] = objPos;
      }
    });
    this.selectedLocationId = null;
  }
  enableLocationPinMode(boo) {
    this.plotmode_location = boo;
  }
  updatedFirstAidPin() {
    this.fistAidJson.forEach(obj => {
      if (obj._id === this.updateFirstAid._id) {
        console.log("match data");
        obj['battery_exp'] = this.updateFirstAid['battery_exp'];
        obj['child_pad'] = this.updateFirstAid['child_pad'];
        obj['pad_exp'] = this.updateFirstAid['pad_exp'];
        obj['spare_batt'] = this.updateFirstAid['spare_batt'];
        obj['spare_exp'] = this.updateFirstAid['spare_exp'];
        obj['notes'] = this.updateFirstAid['notes'];
        obj['aed_acc'] = this.updateFirstAid['aed_acc'];
        obj['first_aid'] = this.updateFirstAid['first_aid'];
        this.updateFirstAidArea(obj._id, obj);
      }
    });
  }
  placeLocationPin() {
    let loc = this.getPlotLoc();
    loc.x = -loc.x;
    loc.y = 3.3;
    this.enableLocationPinMode(false);
    this.fistAidJson.forEach(obj => {
      if (obj['_id'] === this.selectedLocationObj['_id']) {
        obj['position'] = loc;
        let material = obj['color'] ? obj['color'] : 'location_orange';
        this.addLocationPin(obj['_id'], obj.position, material);
        this.tagServ.locationPointerTag(obj['_id'], false);
        this.ctrlServ.focusStaticElement(obj['_id']);
        this.tagServ.locationPointerTag(obj['_id'], true);
      }
    });
  }
  selectedFirstAidPin(obj) {
    if (obj != null) {
      if (!obj['position']) {
        this.enableLocationPinMode(true);
      } else {
        if (this.selectedLocationObj) {
          if (this.selectedLocationObj['_id'] != obj['_id']) {
            this.selectedLocationObj = obj;
            this.broadcastInfo({ src: 'main', event: 'first_Aid_data', data: this.selectedLocationObj, key: "" });
            this.tagServ.locationPointerTag(obj['_id'], false);
            this.ctrlServ.focusStaticElement(obj['_id']);
            this.tagServ.locationPointerTag(obj['_id'], true);
          } else {
            this.selectedLocationObj = null;
            this.tagServ.locationPointerTag(obj['_id'], false);
          }
        } else {
          this.selectedLocationObj = obj;
          this.broadcastInfo({ src: 'main', event: 'first_Aid_data', data: this.selectedLocationObj, key: "" });
          this.tagServ.locationPointerTag(obj['_id'], false);
          this.ctrlServ.focusStaticElement(obj['_id']);
          this.tagServ.locationPointerTag(obj['_id'], true);
        }
      }
    }
  }
  showHideLocationPin() {
    let flag = (this.fmfmode === 'exterior' ? false : true);
    if (!flag) {
      if (this.selectedLocationObj) {
        this.tagServ.locationPointerTag(this.selectedLocationObj['_id'], false);
        this.selectedLocationObj = null;
        this.broadcastInfo({ src: 'tag', event: 'unSelectedFirstAid', data: '', key: "" });
      }
    }
    Object.keys(this.locationPinObjects).forEach((key) => {
      if (!key.includes("_profile")) {
        let el = this.locationPinObjects[key];
        if (flag) {
          let material = this.locationPinObjects[key + '_profile'];
          this.dfx.modify(el, { profile: 'regular' });
        } else {
          this.dfx.modify(el, { profile: 'invisible' });
        }
      }
    })


  }



  /* * *
* Status code start
* * */
  statusListData: any = [];


  editGroupData: any;

  statusUpdated;


  commentDetails = []
  // changeStatus(data) {
  //   var statusId = this.statusListData.filter(obj => obj.name == data)
  //   var statusIdData = statusId[0]._id;
  //   var statusIdx = this.statusListData.findIndex(obj => obj.name == data)
  //   if (this.layoutHeading) {
  //     this.commentDetails = [];
  //     this.commentDetails.push({ "status": this.statusListData[statusIdx], "startDate": new Date(), "tagShapeId": this.pickedMeshObj.tagShapeId, group : this.saveNotesData["group"] || {}})
  //     if(!this.saveNotesData._id){
  //       this.saveNotesData = this.commentDetails[0];
  //       this.createMarker();
  //       this.createNotes();
  //     } else {
  //       this.saveNotesData['status'] =this.statusListData[statusIdx]
  //       this.updateNotes(this.saveNotesData)
  //     }
  //   } else {
  //     this.commentDetails = [];
  //     this.commentDetails.push({ "status": this.statusListData[statusIdx], "startDate": new Date(),  "tagShapeId": this.pickedMeshObj.tagShapeId,group : this.saveNotesData["group"] || {} })
  //     this.temporaryCommentData = this.commentDetails[0];
  //     this.saveNotesData = this.commentDetails[0];
  //     this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName', data: this.temporaryCommentData });
  //   }
  // }





  typeCollection: any;
  groupCollection: any;
  groupCollectionData: any = [];
  statusCollection: any;
  statusCollectionData: any = [];;
  shapeCollection: any;
  shapeCollectionIcon: any;
  shapeCollectionImg: any;
  layoutShapeModel = false;

}
export interface DialogData {
  data: string;
  error: any;
  type: any;
  approval: string;
}

@Component({
  selector: 'popup-model',
  templateUrl: 'popup-model.html',
})

export class PopupModelComponent {
  approvalComment: any;
  activityMessage: any;
  constructor(
    public dialogRef: MatDialogRef<PopupModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public communicationServ: CommunicationService) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeClick(): void {
    this.dialogRef.close();
  }
  //   onDelete() {
  //     this.broadcastInfo({ src: 'commentScreen', event: 'deleteComment', data: "", sub: null });
  //     this.closeClick()
  //   }
  //   onNotesDelete() {
  //     this.broadcastInfo({ src: 'main', event: 'deleteNotesData', data: "", sub: null });
  //     this.closeClick()
  //   }
  //   broadcastInfo(data: any) {
  //     this.communicationServ.getInstance().next(data);
  //   }
  // }
  //   closeClick(): void {
  //     this.dialogRef.close();
  //   }
  //   closeAddUserClick(){
  //     this.dialogRef.close();
  //     this.broadcastInfo({ src: 'commentScreen', event: 'closeUser', data: "", sub: null });
  //   }
  //   onDelete() {
  //     this.broadcastInfo({ src: 'commentScreen', event: 'deleteComment', data: "", sub: null });
  //     this.closeClick()
  //   }
  //   onNotesDelete() {
  //     this.broadcastInfo({ src: 'main', event: 'deleteNotesData', data: "", sub: null });
  //     this.closeClick()
  //   }
  //   onStateBoardDelete() {
  //     this.broadcastInfo({ src: 'main', event: 'deleteStateBoardData', data: "", sub: null });
  //     this.closeClick();
  //   }
  //   onSaveCommentData() {
  //     this.broadcastInfo({ src: 'comment', event: 'saveActivityMessage', ApprovalStatus: this.approvalComment,meassage: this.activityMessage, sub: null });
  //     this.closeClick();
  //   }
  //   broadcastInfo(data: any) {
  //     this.communicationServ.getInstance().next(data);
  //   }
  //   messageData(e){
  //     this.activityMessage = e.target.value
  //   }
  //   approval = 0;
  //   approvalStatus(event){
  //     this.approval = event
  //     this.broadcastInfo({ src: 'commentScreen', event: 'approvalStatus', data: event, sub: null });
  //   }
  //   approveComment(event){
  //     this.approvalComment = event
  //     this.broadcastInfo({ src: 'commentScreen', event: 'approvalStatus', data: event, sub: null });
  //   }
}
@Component({
  selector: 'publish-dialog',
  templateUrl: 'publish-popup.html',
  providers: [DatePipe],
})

export class PublishDialog implements AfterViewInit {
  broadcastSubs: any;
  dataSource: any = [];
  activePdfPage: any = '1';
  daySpans = [];
  daySource: any = [];
  monthSpans = {};
  showLoading: any = false;
  pageLoader: boolean = false;
  pdfStatus: any = false;
  popupHeight: any = window.innerHeight / 1.2 + 'px';
  lodaderPosition: any = window.innerHeight / 2.8 + 'px';
  canvasWidth: any = '1080';
  // popupWidth:any='1120';
  wfmReportState: boolean = false;
  wfmReportType: any;
  wfmReportData: any = [];
  firstAidColumns: string[] = ['location', 'aed_acc', 'group', 'barcode', 'serial', 'pad_exp', 'spare_exp', 'child_pad', 'battery_exp', 'spare_batt', 'notes'];
  hazardColumns: string[] = ['color', 'activity', 'startdate', 'enddate', 'notes'];
  monthColumns: string[] = ['StartDate', 'Ship', 'EndDate', 'Location', 'Activity', 'StartTime', 'EndTime', 'Notes'];
  displayedColumns: string[] = ['Location', 'Ship', 'Activity', 'StartTime', 'EndTime', 'Notes'];
  legendsList: any = [{ "iconName": "antenna rotating", "name": "Antenna Rotating" }, { "iconName": "ammunitioning", "name": "Ammunitioning" },
  { "iconName": "man-aloft", "name": "Man Aloft" }, { "iconName": "cold move", "name": "Cold Move" }, { "iconName": "crane work", "name": "Crane Work" },
  { "iconName": "diver", "name": "Diver" }, { "iconName": "basinTrial", "name": "Basin Trial" },
  { "iconName": "emmissions", "name": "Emmissions" }, { "iconName": "radiating", "name": "Radiate" }, { "iconName": "fueling", "name": "Fueling" }]
  coneColors: any = [
    { "name": "orange", "code": "#df5900", 'material': 'cone_orange' },
    { "name": "red", "code": "#ff0000", 'material': 'cone_red' },
    { "name": "green", "code": "#008000", 'material': 'cone_green' }
  ]
  hazardTypeList: any = [{ "key": "emergency", "name": "Emergency" }, { "key": "notice", "name": "Notice" },
  { "key": "spill", "name": "Spill" }, { "key": "maintenance", "name": "Maintenance" },
  { "key": "disabledequipment", "name": "Disabled Equipment" }, { "key": "pavementrepair", "name": "Pavement repair" },
  { "key": "temporarystructure", "name": "Temporary structure" }, { "key": "other", "name": "Other" }];
  broadcastInfo: any;

  constructor(private datePipe: DatePipe, private configService: ConfigService, private communicationServ: CommunicationService, private reportServ: ReportService, public dialogRef: MatDialogRef<PublishDialog>, @Inject(MAT_DIALOG_DATA) public data: PublishData) {
    // if(window.innerWidth>2000){
    //   this.dialogRef.updateSize(window.innerWidth+'px', '');
    // }
    console.log(data);
    // this.dialogRef.close();
    dialogRef.disableClose = true;
    if (data.dataList) {
      this.wfmReportData = data.dataList;
      this.wfmReportType = data.type.split('_')[1];
    }
  }

  /* * * * *
  * Init service data load
  * * * * * */
  ngOnInit() {
    // this.pageLoader = true;
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {

        if (data.src === "report") {
          if (data.event === 'update_preview') {
            this.daySource = data['data'];
            this.shipListReConstruct();
          }
        }
        if (data.src == 'main') {
          if (data.event == 'reportWfm') {
            if (data.key == 'wfmReport_hazard') {
              this.wfmReportData = data.data;
              console.log(this.wfmReportData);

            }
            this.dialogRef.close();
          }
        }
      })

  }

  ngAfterViewInit() {
    // this.pageLoader=false;
    //  this.dialogRef.updateSize(window.innerWidth+'px', '');

    window.screen.orientation
      .lock("landscape")
      .then(
        success => console.log(success),
        failure => console.log(failure)
      )
    if (window.innerWidth < 1000) {
      this.dialogRef.updateSize((window.innerWidth).toString(), '');
      (document.getElementsByClassName('full-width-dialog') as HTMLCollectionOf<HTMLElement>)[0].style.maxWidth = 'none';
      this.canvasWidth = window.innerWidth.toString();
    }
    if (this.wfmReportData) {
      this.pageLoader = false;
      return;
    }
    this.updateCompass();
  }

  xangle = 0;
  zangle = 0;
  animId = null
  updateCompass() {
    let cam = this.reportServ.dfx.getCamera();
    let yaw = cam.yaw_deg.value;
    let pitch = cam.pitch_deg.value;
    this.zangle = 0;
    this.xangle = 0;
    //
    let anim = (t) => {
      yaw = cam.yaw_deg.value;
      pitch = cam.pitch_deg.value;
      this.zangle = 180 - yaw;
      this.xangle = 90 - pitch;
      //requestAnimationFrame(anim)
    }
    requestAnimationFrame(anim)
  }
  getRefersheddate(date, time = false) {
    let refershedDate: any;
    if (time) {
      refershedDate = this.datePipe.transform(date, 'MMMM d, y, h:mm a');
    } else {
      refershedDate = this.datePipe.transform(date, 'MMMM d, y');
    }
    return refershedDate;
  }

  // ///////////////////////////table section start
  // ///activity ship only listed
  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.shipListReConstruct();
  //   }, 500);
  //   setTimeout(() => {
  //     this.daySource = this.reportServ.reportPageData;
  //   }, 800);
  // }

  shipListReConstruct() {
    this.daySpans = []
    var shipList = this.reportServ.reportPageData;
    if (shipList.length > 0) {
      var childList = {}
      shipList.forEach(element => {
        if (this.activePdfPage == '28') {
          childList = (Object.assign({}, {
            startdate: this.spanDeep(['startdate'], element['shipObjects']),
            ship: this.spanDeep(['startdate', 'ship'], element['shipObjects']),
          }))
        } else {
          var data = element['shipObjects'];
          element['shipObjects'].forEach((ele, i) => {
            // console.log(ele['location'].match(/[a-zA-Z]+/g)[0], ",", ele['location'])
            data[i]['jetty'] = ele['location'].match(/[a-zA-Z]+/g)[0]
          });
          childList = (Object.assign({}, {
            jetty: this.spanDeep(['jetty'], data),
          }))
        }
        this.daySpans.push(childList);
      });
      this.pageLoader = false;
      // console.log(shipList, this.daySpans)
    }
  }

  // getReportData(e) {
  //   this.dataSource = [];
  //   e.forEach(ship => {
  //     if (ship.activity) {
  //       this.dataSource.push(ship);
  //     }
  //   });
  //   // this.assignRowSpan( this.dataSource);
  // }

  // assignRowSpan(data){
  //   // this.daySpans = Object.assign({}, {
  //   //   priority: this.spanDeep(['priority'], data),
  //   //   status: this.spanDeep(['priority', 'status'], data),
  //   //   dateCreated: this.spanDeep(['priority', 'status', 'dateCreated'], data)
  //   // });
  //   this.daySpans =[ Object.assign({}, {
  //     location: this.spanDeep(['location'], data),
  //   })];
  // }

  spanDeep(paths: string[] | null, data: any[]) {
    if (!paths.length) {
      return [...data]
        .fill(0)
        .fill(data.length, 0, 1);
    }

    const copyPaths = [...paths];
    const path = copyPaths.shift();

    const uniq = uniqWith(data, (a, b) => get(a, path) === get(b, path))
      .map(item => get(item, path));

    return uniq
      .map(uniqItem => this.spanDeep(copyPaths, data.filter(item => uniqItem === get(item, path))))
      .flat(paths.length);
  }

  getRowSpan(path, idx, i) {
    if (this.daySpans.length > 0) {
      return this.daySpans[i][path][idx];
    }
  }

  //////////////////////////table section end
  onChangeReport(range) {
    if (!this.pageLoader) {
      this.pageLoader = true;
      console.log("onChangeReport");
      this.activePdfPage = range;
      this.reportServ.showDayReportView(range);
      this.shipListReConstruct();
      // this.pageLoader=false;
    }
  }

  downloadReport() {
    // var elemWidth = document.getElementById('previewPdfEle').offsetWidth
    if (this.wfmReportData) {
      this.activePdfPage = 'wfmreport';
    }

    this.showLoading = true;
    this.dialogRef.updateSize('1080px', '');
    (document.getElementsByClassName('full-width-dialog') as HTMLCollectionOf<HTMLElement>)[0].style.maxWidth = 'none';
    setTimeout(() => {
      this.reportServ.generatePDF(this.activePdfPage);
    }, 400);
    setTimeout(() => {
      // this.dialogRef.updateSize(elemWidth+'px','');
      (document.getElementsByClassName('full-width-dialog') as HTMLCollectionOf<HTMLElement>)[0].style.maxWidth = '80vw';
      this.showLoading = false
    }, 1000);
  }

  onSubmit(): void {
    if (this.data.value) {
      console.log(this.data.value);
    }
  }


  getLocation(location) {
    if (location) {
      let str = location.match(/[a-zA-Z]+/g)[0];
      let number = location.replace(str, "");
      let jetty = str + ' ' + number;
      let loc = jetty.replace("_", "/")
      // let loc = location.substring(0, 2);
      // let code = location.substring(2, location.length);
      // let str = loc + ' ' + code.replace("_", "/");
      return loc;
    } else {
      return location;
    }
  }
  getPrintDate() {
    return this.datePipe.transform(new Date(), 'MMMM d, y h:mm');
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 1008) {
      // window.lockOrientation('landscape')
      console.log(window.screen.orientation)
      // var elemWidth = document.getElementById('previewPdfEle').offsetWidth
      // this.popupWidth = event.target.innerWidth+'px';
      this.popupHeight = event.target.innerHeight + 'px';
      this.lodaderPosition = event.target.innerHeight / 2.8 + 'px';
      this.dialogRef.updateSize((window.innerWidth).toString(), '');
      (document.getElementsByClassName('full-width-dialog') as HTMLCollectionOf<HTMLElement>)[0].style.maxWidth = 'none';
    } else {
      // this.popupWidth = '1120';
      this.popupHeight = event.target.innerHeight / 1.2 + 'px';
      this.lodaderPosition = event.target.innerHeight / 2.8 + 'px';
      this.dialogRef.updateSize('1080px', '');
      (document.getElementsByClassName('full-width-dialog') as HTMLCollectionOf<HTMLElement>)[0].style.maxWidth = '80vw';
      if (event.target.innerWidth > 2000) {
        // this.popupWidth =event.target.innerWidth/1.5;
        // this.dialogRef.updateSize(event.target.innerWidth+'px', '');
      }
    }
  }
  closeClick(): void {
    this.dialogRef.close();
  }
}
/**
 * crane manager, animator
 */
export class CraneManager {
  animators
  constructor(private cranes, private translate: TranslateService, private language: LanguageService) {
    this.animators = []
    this.initialiseCraneAnimations();
  }
  initialiseCraneAnimations() {
    this.cranes.forEach((craneprops) => {
      let anim = new CraneAnimator(craneprops.crane, craneprops.props, this.translate, this.language)
      this.animators.push(anim);
    })
  }
  destroy() {
    this.animators.forEach((anim) => {
      anim.destroy();
    })
    this.animators = [];
  }
  play() {
    this.animators.forEach((anim) => {
      anim.playAnim();
    })
  }
  pause() {
    this.animators.forEach((anim) => {
      anim.pauseAnim();
    })
  }
  stop() {
    this.animators.forEach((anim) => {
      anim.stopAnim();
    })
  }
}
export class CraneAnimator {
  startprops
  path
  pathkey
  animId;
  paused;
  stopped;
  playing;
  constructor(private crane, private props, private translate: TranslateService, private language: LanguageService) {
    this.startprops = props.start;
    this.pathkey = props.path;
    if (this.pathkey.length) {
      let pos = { x: crane.position.x, y: crane.position.y, z: crane.position.z, w: this.pathkey[0].w }
      this.pathkey.unshift(pos);
      this.processPathKeys();
    }
    this.language.languageChange.subscribe(props => {
      console.log("language", props);
      this.translate.use(props);
    })
  }
  destroy() {
    this.stopAnim();
    this.startprops = null;
    this.pathkey = null;
    this.crane = null;
    this.props = null;
    this.animId = null;
    this.path = null;
  }
  processPathKeys() {
    let l = this.pathkey.length;
    this.path = [];
    for (let i = 0; i < l - 1; i++) {
      let p = this.getIntPoints(this.pathkey[i], this.pathkey[i + 1], this.pathkey[i + 1].count)
      this.path = this.path.concat(p);
    }
  }
  getIntPoints(p1, p2, q = 20) {
    let points = [];
    let ydiff = p2.z - p1.z, xdiff = p2.x - p1.x;
    let ds = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    let quantity = q;
    let slope = (ydiff) / (xdiff);
    let sang = p1.w || 0;
    let eang = p2.w || 0;
    let dang = (eang - sang) / q;
    let x, y;
    --quantity;
    for (let i = 0; i < quantity; i++) {
      y = slope == 0 ? 0 : ydiff * (i / quantity);
      x = slope == 0 ? xdiff * (i / quantity) : y / slope;
      let dw = ((p1.w || 0) + (dang * (i + 1))).toFixed(2);
      points[i] = { x: (x) + p1.x, z: (y) + p1.z, y: p1.y, w: dw * 1 };
    }
    points[quantity] = p2;
    return points;
  }
  stopAnim() {
    cancelAnimationFrame(this.animId);
    this.stopped = !false;
    this.playing = false;
    this.paused = false;
    this.resetCrane();
  }
  pauseAnim() {
    this.paused = true;
  }
  playAnim() {
    if (this.paused) {
      this.paused = false;
    } else {
      if (this.path && this.path.length) {
        this.runAnim();
      }
    }
  }
  degToRad(d) {
    return d * Math.PI / 180
  }
  radToDeg(r) {
    return r / Math.PI * 180
  }
  resetCrane() {
    this.crane.position.x = this.startprops.position.x;
    this.crane.position.z = this.startprops.position.z;
    this.crane.rotation.y = this.degToRad(this.startprops.orientation.y);
  }
  runAnim() {
    let c1 = this.crane;
    let c = 0;
    let anim = () => {
      if (this.paused) {
        this.stopped = false;
        this.playing = false;
        this.animId = window.requestAnimationFrame(anim);
        return
      }
      this.stopped = false;
      this.playing = true;
      if (c >= this.path.length) {
        this.path.reverse();
        c = 0;
      } else {
        let pos = this.path[c];
        let ang = pos.w;
        c1.position.x = pos.x;
        c1.position.z = pos.z;
        c1.rotation.y = ang;
        c++
      }
      this.animId = window.requestAnimationFrame(anim);
    }
    this.animId = window.requestAnimationFrame(anim);
  }


}
